import { j as s, $ as fi, a as bi, b as xi, c as yi, d as _i, e as Ci, g as vi, h as wi, i as Si, n as E, O as Ii, k as Hs, l as Ms, w as Wn, Z as Di, H as ki, m as An, o as Ct, p as uo, r as yr, q as Ti, t as zs, W as ji, u as Ni, A as Fi, F as Pi, v as _r, x as Cr, y as Vs, z as vr, B as Hn, C as Ri, D as Ei, E as Li, G as Ai, I as $i, J as Oi, K as wr, L as Bi, M as Wi } from "./vendor-B4O8kiwH.js";
import f from "classnames";
import { I as N, T as A, r as Fs, B as it, a as sn, e as Hi } from "./emoji-BzNvonBo.js";
import { E as HT, b as MT, d as zT, i as VT } from "./emoji-BzNvonBo.js";
import { memo as qn, forwardRef as $, PureComponent as D, createContext as vt, useContext as Ht, useRef as q, useLayoutEffect as Mi, useState as V, useCallback as P, useEffect as Z, cloneElement as cn, isValidElement as Tt, Component as ft, Children as Lt, createRef as W, useMemo as G, Fragment as Mt, useImperativeHandle as Fe, createElement as zi, lazy as Vi, Suspense as Ki, useReducer as Ui } from "react";
import { useKey as Sr, useMount as Pe, useUnmount as Jt, useUpdateEffect as Zt, useToggle as qi, useSetState as Gi, useClickAway as Ir, usePrevious as on, useDebounce as Yi } from "react-use";
import j from "moment-timezone";
import { v4 as rn } from "uuid";
import { noop as Qi } from "ts-essentials";
import Xi from "react-dom";
const Zi = "h-button--button__root", Ji = "h-button--button__normal", ta = "h-button--button__large", ea = "h-button--button__primary", na = "h-button--button__active", sa = "h-button--button__label", oa = "h-button--button__secondary", ra = "h-button--button__tertiary", ia = "h-button--button__danger", aa = "h-button--button__disabled", la = "h-button--button__loading", ca = "h-button--button__withLabel", da = "h-button--button__slot", ha = "h-button--button__content", wt = {
  root: Zi,
  normal: Ji,
  large: ta,
  primary: ea,
  active: na,
  label: sa,
  secondary: oa,
  tertiary: ra,
  danger: ia,
  disabled: aa,
  loading: la,
  withLabel: ca,
  slot: da,
  content: ha
}, X = qn(
  $(function({
    children: t,
    className: e,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: a,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, C) {
    const _ = f(
      {
        [wt.root]: !0,
        [wt[o]]: !0,
        [wt[r]]: !0,
        [wt.active]: d,
        [wt.disabled]: g,
        [wt.loading]: h,
        [wt.withLabel]: !c && !!p
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: _,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: C,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || a) && /* @__PURE__ */ s.jsx("span", { className: wt.slot, children: a ? /* @__PURE__ */ s.jsx(N, { name: a }) : l }),
          (m || t) && /* @__PURE__ */ s.jsx("span", { className: wt.content, children: m ? /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: t
            }
          ) : t }),
          p && /* @__PURE__ */ s.jsx(
            A.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: wt.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: wt.slot, children: c })
        ] })
      }
    );
  })
), ua = "h-button-navigationButton--navigationButton__root", pa = {
  root: ua
}, Rk = ({
  className: i,
  navigate: t,
  onClick: e,
  ...n
}) => {
  const o = (r) => {
    e?.(r), t();
  };
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(i, pa.root)
    }
  );
}, ma = "h-spinner--spinner__root", ga = {
  root: ma
};
class Gn extends D {
  render() {
    const { className: t, size: e, color: n, trackColor: o, bgColor: r, ...a } = this.props, l = f(
      {
        [ga.root]: !0
      },
      t
    ), c = typeof e == "number" ? e : 32, d = typeof e == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...a, style: u, className: l });
  }
}
const fa = "h-iconButton--iconButton__root", ba = {
  root: fa
}, K = qn(
  $(function({
    children: t,
    className: e,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: a = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      X,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: a,
        className: f(ba.root, e),
        loadingIndicator: /* @__PURE__ */ s.jsx(Gn, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
);
function xa(i) {
  let t = i;
  const e = [];
  function n(r) {
    if (r !== t) {
      for (const { type: a, handler: l, options: c } of e)
        t.removeEventListener(a, l, c), r.addEventListener(a, l, c);
      t = r;
    }
  }
  return { proxy: new Proxy({}, {
    get(r, a) {
      if (a === "addEventListener")
        return (c, d, h) => {
          e.push({ type: c, handler: d, options: h }), t.addEventListener(c, d, h);
        };
      if (a === "removeEventListener")
        return (c, d, h) => {
          const u = typeof h == "boolean" ? h : h?.capture ?? !1, p = e.findIndex((m) => {
            const g = typeof m.options == "boolean" ? m.options : m.options?.capture ?? !1;
            return m.type === c && m.handler === d && g === u;
          });
          p !== -1 && e.splice(p, 1), t.removeEventListener(c, d, h);
        };
      const l = t[a];
      return typeof l != "function" ? l : new Proxy(l, {
        apply(c, d, h) {
          return l.apply(t, h);
        }
      });
    }
  }), setWindow: n };
}
const Yn = vt(
  typeof window < "u" ? window : {}
);
function Ek({
  value: i,
  children: t
}) {
  const e = q(null);
  return e.current || (e.current = xa(i)), Mi(() => {
    e.current.setWindow(i);
  }, [i]), /* @__PURE__ */ s.jsx(Yn.Provider, { value: e.current.proxy, children: t });
}
function Ks() {
  return Ht(Yn);
}
const ya = "h-tooltip--tooltip__content", _a = "h-tooltip--tooltip__contentLight", Ca = "h-tooltip--tooltip__contentHasHead", va = "h-tooltip--tooltip__body", wa = "h-tooltip--tooltip__head", Sa = "h-tooltip--tooltip__arrow", he = {
  content: ya,
  contentLight: _a,
  contentHasHead: Ca,
  body: va,
  head: wa,
  arrow: Sa
}, Ia = 400;
function st({
  children: i,
  content: t,
  onOpenChange: e,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: a,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = Ia,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const C = Ks(), [_, S] = V(
    g ? !1 : void 0
  ), v = P(() => {
    S(!1), C.removeEventListener("click", v);
  }, [C]);
  Z(() => () => {
    C.removeEventListener("click", v);
  }, [v, C]);
  const y = fi();
  if (c || !t)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const w = (k) => {
    k.stopPropagation(), C[_ ? "removeEventListener" : "addEventListener"](
      "click",
      v
    ), S(!_);
  }, I = f(
    he.content,
    {
      [he.contentHasHead]: !!r,
      [he.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(bi, { children: /* @__PURE__ */ s.jsxs(
    xi,
    {
      open: _ ?? (l ? !0 : void 0),
      defaultOpen: a,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: e,
      children: [
        /* @__PURE__ */ s.jsx(yi, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? w : void 0,
            ...m,
            ...x,
            children: i
          }
        ) : g && Tt(i) ? cn(i, { onClick: w }) : i }),
        /* @__PURE__ */ s.jsx(_i, { container: C.document.body, children: /* @__PURE__ */ s.jsx(
          Ci,
          {
            id: y,
            side: n,
            sideOffset: 4,
            align: h,
            className: I,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: he.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: he.body, children: t }),
              /* @__PURE__ */ s.jsx(vi, { className: he.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const Da = "h-attachment--attachment__root", ka = "h-attachment--attachment__icon", Ta = "h-attachment--attachment__name", ja = "h-attachment--attachment__buttons", gn = {
  root: Da,
  icon: ka,
  name: Ta,
  buttons: ja
}, po = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function Na(i) {
  const t = i.split(".").pop()?.toLowerCase();
  return !t || !po[t] ? "file" : po[t];
}
const Lk = (i) => {
  const {
    className: t,
    nameClassName: e,
    fileName: n,
    label: o,
    onDownload: r,
    onPreview: a,
    isPreviewLoading: l,
    isDownloadLoading: c,
    extraButtons: d,
    ...h
  } = i, u = f(
    {
      [gn.root]: !0
    },
    t
  );
  return /* @__PURE__ */ s.jsxs("div", { ...h, className: u, children: [
    /* @__PURE__ */ s.jsx(
      N,
      {
        className: gn.icon,
        name: Na(n),
        size: 24,
        color: "neutral.700"
      }
    ),
    /* @__PURE__ */ s.jsx(
      st,
      {
        content: o || n,
        wrap: "div",
        wrapProps: { className: f(gn.name, e) },
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o || n })
      }
    ),
    /* @__PURE__ */ s.jsxs("div", { className: gn.buttons, children: [
      a && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "eye",
          onClick: l ? void 0 : a
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: c,
          variant: "secondary",
          icon: "download",
          onClick: c ? void 0 : r
        }
      ),
      d
    ] })
  ] });
}, Fa = {
  onError(i, t) {
    console.error(i, t);
  }
}, Pa = vt(Fa), mo = { error: null };
class Re extends ft {
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  constructor(t) {
    super(t), this.state = mo, this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.resetInternally = this.resetInternally.bind(this);
  }
  componentDidCatch(t, e) {
    this.props.onError?.(t, e), this.context?.onError?.(t, e);
  }
  static contextType = Pa;
  resetErrorBoundary(...t) {
    this.props.onReset?.(...t), this.resetInternally();
  }
  resetInternally() {
    this.setState(mo);
  }
  hasError(t) {
    return t !== null;
  }
  ensureErrorHandlerExists() {
    const { fallback: t, fallbackRender: e } = this.props, n = this.hasFallbackElement(t), o = this.hasFallbackRenderer(e);
    if (!n && !o)
      throw new Error(
        `${Re.name} requires either a fallback component or a fallback renderer`
      );
  }
  hasFallbackRenderer(t) {
    return typeof t == "function";
  }
  hasFallbackElement(t) {
    return t === null || typeof t == "string" || Tt(t);
  }
  render() {
    const { error: t } = this.state, { fallbackRender: e, fallback: n } = this.props;
    if (this.ensureErrorHandlerExists(), !this.hasError(t))
      return this.props.children;
    if (this.hasFallbackElement(n))
      return n;
    if (this.hasFallbackRenderer(e))
      return e({
        error: t,
        resetErrorBoundary: this.resetErrorBoundary
      });
  }
}
function dn(i, t) {
  const e = i.displayName || i.name || "Unknown";
  return wi(
    class extends ft {
      static displayName = `withErrorBoundary(${e})`;
      static defaultProps = i.defaultProps;
      render() {
        const o = i;
        return /* @__PURE__ */ s.jsx(Re, { ...t, children: /* @__PURE__ */ s.jsx(o, { ...this.props }) });
      }
    },
    i
  );
}
const Ra = "h-avatar--avatar__root", $n = {
  root: Ra,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, Ea = {
  24: 16,
  32: 20,
  40: 24
}, La = ({
  icon: i,
  size: t,
  color: e = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: i, size: Ea[t], color: e }), Aa = "h-image--image__image", $a = "h-image--image__error", Oa = "h-image--image__complete", as = {
  image: Aa,
  error: $a,
  complete: Oa
};
class Us extends ft {
  static defaultProps;
  mounted;
  constructor(t) {
    super(t), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(t);
  }
  onError(t) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(t);
  }
  render() {
    const { className: t, src: e, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: a, loadingComplete: l } = this.state, c = f(
      {
        [as.image]: !0,
        [as.error]: !!a,
        [as.complete]: !!l
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Us.defaultProps = {
  className: "",
  alt: ""
};
const Ba = "h-avatar--imageAvatar__root", Wa = {
  root: Ba
}, Ha = ({
  src: i,
  alt: t = "avatar"
}) => /* @__PURE__ */ s.jsx(Us, { src: i, alt: t, className: Wa.root }), Ma = "h-avatar--textAvatar__root", On = {
  root: Ma,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, za = {
  24: On["avatar-24"],
  32: On["avatar-32"],
  40: On["avatar-40"]
}, Va = ({ text: i = "", size: t }) => /* @__PURE__ */ s.jsx("div", { className: f(On.root, za[t]), children: i.trim().split(" ").map(
  (e, n, o) => o.length === 1 ? e : e[0]
).join("").slice(0, 2) }), Ka = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Ua {
  constructor(t) {
    this.colors = t, this.colors = t;
  }
  generate(t) {
    const e = this.getRandomIndex(t);
    return this.colors[e];
  }
  getRandomIndex(t) {
    const e = Si(t);
    return Math.floor(e() * this.colors.length);
  }
}
var et = /* @__PURE__ */ ((i) => (i.Icon = "Icon", i.Image = "Image", i.Text = "Text", i))(et || {});
function ue(i) {
  return i.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function St(i) {
  return !!i && i.trim().length !== 0;
}
function qa(i) {
  if (i.icon)
    return {
      type: et.Icon,
      icon: i.icon,
      backgroundColor: i.color?.backgroundColor,
      iconColor: i.color?.contentColor
    };
  const { user: t } = i;
  if (!t)
    return {
      type: et.Icon,
      icon: "user-slash"
    };
  if (St(t.avatar_url))
    return {
      type: et.Image,
      src: t.avatar_url,
      alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
    };
  if (St(t.name)) {
    const e = ue(t.name.trim()).split(" ");
    if (e.length === 1)
      return {
        type: et.Text,
        text: e[0]?.[0] ?? ""
      };
    const n = e[0], o = e[e.length - 1];
    return {
      type: et.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (St(t.display_name))
    return {
      type: et.Text,
      text: ue(t.display_name.trim())
    };
  if (St(t.given_name) && St(t.family_name))
    return {
      type: et.Text,
      text: ue(t.given_name.trim())[0] + ue(t.family_name.trim())[0]
    };
  if (St(t.given_name) && !St(t.family_name))
    return {
      type: et.Text,
      text: ue(t.given_name.trim())[0]
    };
  if (!St(t.given_name) && St(t.family_name))
    return {
      type: et.Text,
      text: ue(t.family_name.trim())[0]
    };
  if (St(t.email)) {
    const [e] = t.email.split("@");
    return {
      type: et.Text,
      text: e.trim()
    };
  }
  return St(t.phone_number) ? {
    type: et.Text,
    text: t.phone_number.slice(-2)
  } : t.id ? {
    type: et.Icon,
    icon: "user-secret"
  } : {
    type: et.Icon,
    icon: "user-slash"
  };
}
const It = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, go = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...It,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": It,
  "user-slash": It,
  "map-pin": It,
  "web-form": It,
  code: It,
  history: It,
  smile: It,
  key: It,
  webhooks: It,
  plug: It
}, Ga = {
  24: $n["avatar-24"],
  32: $n["avatar-32"],
  40: $n["avatar-40"]
};
class Ya extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new Ua(Ka)
  };
  getAvatarChild(t, e) {
    if (t.type === et.Icon)
      return /* @__PURE__ */ s.jsx(
        La,
        {
          size: e,
          icon: t.icon,
          color: t.iconColor
        }
      );
    if (t.type === et.Image)
      return /* @__PURE__ */ s.jsx(Ha, { src: t.src, alt: t.alt });
    if (t.type === et.Text)
      return /* @__PURE__ */ s.jsx(Va, { size: e, text: t.text });
  }
  calculateColor(t) {
    if (t.type === et.Icon) {
      if (t.backgroundColor && t.iconColor)
        return {
          backgroundColor: t.backgroundColor,
          contentColor: t.iconColor
        };
      if (go[t.icon])
        return go[t.icon];
    }
    return t.type === et.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : t.type === et.Text ? this.props.colorGenerator.generate(t.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: t, size: e } = this.props, n = qa(this.props), o = this.getAvatarChild(n, e), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          $n.root,
          Ga[e],
          t
        ),
        children: o
      }
    );
  }
}
const Dr = dn(Ya, {
  fallback: null
}), Qa = "h-badge--badge__badge", Xa = "h-badge--badge__badgeSmall", Za = "h-badge--badge__badgeMedium", Ja = "h-badge--badge__badgePrimary", tl = "h-badge--badge__badgeSecondary", el = "h-badge--badge__badgeSuccess", nl = "h-badge--badge__badgeInfo", sl = "h-badge--badge__badgeWarning", ol = "h-badge--badge__badgeError", Wt = {
  badge: Qa,
  badgeSmall: Xa,
  badgeMedium: Za,
  badgePrimary: Ja,
  badgeSecondary: tl,
  badgeSuccess: el,
  badgeInfo: nl,
  badgeWarning: sl,
  badgeError: ol
}, rl = {
  small: Wt.badgeSmall,
  medium: Wt.badgeMedium
}, il = {
  primary: Wt.badgePrimary,
  secondary: Wt.badgeSecondary,
  success: Wt.badgeSuccess,
  info: Wt.badgeInfo,
  warning: Wt.badgeWarning,
  error: Wt.badgeError
}, al = "badge";
function $k(i) {
  const { className: t, size: e, variant: n, children: o, ...r } = i, a = f(
    Wt.badge,
    rl[e],
    il[n],
    t
  );
  return /* @__PURE__ */ s.jsx("span", { className: a, ...r, "data-testid": al, children: o });
}
const H = $(function({
  flexWrap: t,
  flexDirection: e,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: a,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...t && { flexWrap: t },
    ...e && { flexDirection: e },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...a && { alignContent: a },
    ...l && { gap: Fs(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(it, { ...h, style: p, ref: u, children: d });
}), ll = "h-banner--banner__root", cl = "h-banner--banner__rootWithClose", dl = "h-banner--banner__iconContainer", hl = "h-banner--banner__closeIcon", ul = "h-banner--banner__headline", pl = "h-banner--banner__rootInfo", ml = "h-banner--banner__icon", gl = "h-banner--banner__description", fl = "h-banner--banner__rootWarning", bl = "h-banner--banner__rootAnnouncement", xl = "h-banner--banner__rootSuccess", yl = "h-banner--banner__rootFail", _t = {
  root: ll,
  rootWithClose: cl,
  iconContainer: dl,
  closeIcon: hl,
  headline: ul,
  rootInfo: pl,
  icon: ml,
  description: gl,
  rootWarning: fl,
  rootAnnouncement: bl,
  rootSuccess: xl,
  rootFail: yl
}, _l = (i, t) => {
  if (t !== void 0)
    return t;
  switch (i) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, Ok = ({
  actionSlot: i,
  className: t,
  description: e,
  headline: n,
  icon: o,
  variant: r,
  onClose: a
}) => {
  const l = f(_t.root, t, {
    [_t.rootInfo]: r === "info",
    [_t.rootAnnouncement]: r === "announcement",
    [_t.rootWarning]: r === "warning",
    [_t.rootSuccess]: r === "success",
    [_t.rootFail]: r === "fail",
    [_t.rootWithClose]: a
  }), c = _l(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(H, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: _t.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: _t.icon }) }),
      /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          A.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: _t.headline,
            children: n
          }
        ),
        cn(e, {
          className: _t.description
        })
      ] })
    ] }),
    i ? /* @__PURE__ */ s.jsx(H, { gap: "250", margin: "0 0 0 250", children: i }) : a && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: _t.closeIcon,
        onClick: a
      }
    )
  ] });
}, Cl = "h-buttonGroup--buttonGroup__root", vl = "h-buttonGroup--buttonGroup__button", wl = "h-buttonGroup--buttonGroup__buttonWithBorder", Sl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", fn = {
  root: Cl,
  button: vl,
  buttonWithBorder: wl,
  buttonWithoutBorder: Sl
}, Bk = ({
  className: i,
  children: t,
  variant: e,
  size: n,
  disabled: o
}) => {
  const r = f(fn.root, i);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Lt.map(t, (a) => {
    if (!Tt(a))
      return null;
    const l = (e ?? a.props.variant) === "secondary", c = f(a.props.className, {
      [fn.button]: !0,
      [fn.buttonWithBorder]: l,
      [fn.buttonWithoutBorder]: !l
    });
    return cn(a, {
      className: c,
      disabled: o ?? a.props.disabled,
      variant: e ?? a.props.variant,
      size: n
    });
  }) });
}, Il = "h-divider--divider__root", Dl = "h-divider--divider__withChildren", kl = "h-divider--divider__horizontal", Tl = "h-divider--divider__vertical", ls = {
  root: Il,
  withChildren: Dl,
  horizontal: kl,
  vertical: Tl
}, Qn = $(function({
  className: t,
  children: e,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: a,
  padding: l,
  ...c
}, d) {
  const h = n ?? (e ? "div" : "hr"), u = f(
    ls.root,
    ls[o],
    {
      [ls.withChildren]: !!e
    },
    t
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": sn(r) } : {},
    ...a ? { margin: Fs(a) } : {},
    ...l ? { padding: Fs(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof e == "string" ? /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: e }) : e
    }
  );
}), jl = "h-buttonList--buttonList__buttonList", Nl = "h-buttonList--buttonList__inner", fo = {
  buttonList: jl,
  inner: Nl
};
let Fl = class extends D {
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Qn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: t });
  }
};
const Pl = "h-buttonList--item__item", Rl = "h-buttonList--item__icon", El = "h-buttonList--item__button", Ll = "h-buttonList--item__buttonDisabled", Al = "h-buttonList--item__buttonCentered", $l = "h-buttonList--item__checkmark", Ol = "h-buttonList--item__buttonLoading", Bl = "h-buttonList--item__buttonContent", zt = {
  item: Pl,
  icon: Rl,
  button: El,
  buttonDisabled: Ll,
  buttonCentered: Al,
  checkmark: $l,
  buttonLoading: Ol,
  buttonContent: Bl
}, Wl = function({
  icon: t,
  children: e,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: a,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [zt.item]: !0
    },
    n
  ), g = f(
    zt.button,
    {
      [zt.buttonCentered]: r,
      [zt.buttonLoading]: a,
      [zt.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: zt.buttonContent, children: [
          t && /* @__PURE__ */ s.jsx(N, { className: zt.icon, name: t }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: o ? "1" : "2", children: e })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: zt.checkmark
          }
        )
      ]
    }
  ) });
}, Hl = $(Wl);
class bo extends D {
  static get Item() {
    return Hl;
  }
  static get Header() {
    return Fl;
  }
  static get Divider() {
    return Ml;
  }
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(
      {
        [fo.buttonList]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: fo.inner, children: t }) });
  }
}
const Ml = () => /* @__PURE__ */ s.jsx(Qn, { as: "li", margin: "100 0" }), zl = "h-checkbox--checkbox__root", Vl = "h-checkbox--checkbox__rootDisabled", Kl = "h-checkbox--checkbox__rootChecked", Ul = "h-checkbox--checkbox__rootIndeterminate", ql = "h-checkbox--checkbox__checkbox", Gl = "h-checkbox--checkbox__input", pe = {
  root: zl,
  rootDisabled: Vl,
  rootChecked: Kl,
  rootIndeterminate: Ul,
  checkbox: ql,
  input: Gl
};
class hn extends D {
  inputRef;
  constructor(t) {
    super(t), this.inputRef = W();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: o,
      checked: r,
      indeterminate: a,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [pe.root]: !0,
        [pe.rootDisabled]: l,
        [pe.rootChecked]: r,
        [pe.rootIndeterminate]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": a ? "mixed" : r,
          className: pe.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: pe.input,
          onChange: e || E,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const Yl = "h-collapseCard--collapseCard__card", Ql = {
  card: Yl
}, qs = vt({
  isOpen: !1,
  onToggle: E
}), Xl = "h-collapseCard--content__content", Zl = "h-collapseCard--content__contentIsOpen", xo = {
  content: Xl,
  contentIsOpen: Zl
};
class Jl extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(t) {
    return f(xo.content, this.props.className, {
      [xo.contentIsOpen]: t
    });
  }
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(qs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: t
      }
    ) : null });
  }
}
function Xn(i) {
  return {
    role: "button",
    onClick: i,
    onKeyDown: (t) => {
      t.key === "Enter" && i(t);
    }
  };
}
const tc = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], ec = ["Escape", "Esc"], Zn = (i) => tc.includes(i), Ee = (i) => ec.includes(i), nc = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], yo = nc.join(
  ':not([hidden]):not([tabindex="-1"]),'
), kr = qn(function({
  containerRef: t,
  children: e,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: a,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = q(null), u = q(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = t || h;
  Sr(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(yo), C = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const _ = x[0], S = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === S || !b.shiftKey && l && C)
        return _?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === _ || b.shiftKey && l && C) && (S?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(yo)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Pe(() => {
    c || (m(), a?.(!0));
  }), Jt(() => {
    c || (g(), a?.(!1));
  }), Zt(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), a?.(!!n);
  }, [n]), t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: e });
}), sc = "h-dropdown--dropdown__dropdown", oc = "h-dropdown--dropdown__dropdownOpen", rc = "h-dropdown--dropdown__dropdownFromRight", ic = "h-dropdown--dropdown__dropdownFromBottom", ac = "h-dropdown--dropdown__dropdownAnimating", lc = "h-dropdown--dropdown__dropdownFixed", cc = "h-dropdown--dropdown__loader", dc = "h-dropdown--dropdown__error", hc = "h-dropdown--dropdown__errorIcon", $t = {
  dropdown: sc,
  dropdownOpen: oc,
  dropdownFromRight: rc,
  dropdownFromBottom: ic,
  dropdownAnimating: ac,
  dropdownFixed: lc,
  loader: cc,
  error: dc,
  errorIcon: hc
};
class te extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  win;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(t) {
    super(t), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = W(), this.win = window, this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.win = this.getWindow(), this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: o, isLoading: r, errorMessage: a, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== t.isLoading || a !== t.errorMessage)) {
      const d = r !== t.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== t.isOpen && (this.win[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && this.win[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && this.win[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  getWindow() {
    return this.dropdownRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentWillUnmount() {
    this.win.removeEventListener("click", this.handleClickOutsideDropdown), this.win.removeEventListener("scroll", this.handleFixedScroll), this.win.removeEventListener("blur", this.handleOnClose), this.win.clearInterval(this.timeoutAnimationStart), this.win.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = this.win.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = this.win.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !t.target) return;
    const e = t.target, { onClose: n } = this.props;
    this.dropdownRef.current && e !== this.dropdownRef.current && !this.dropdownRef.current.contains(e) && n();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, o = this.getWindow(), r = o.innerWidth / 2, a = o.innerHeight / 2;
      this.setState({
        fromRight: e > r,
        fromBottom: n > a,
        fromTop: n <= a
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {}, a = this.getWindow();
      return t ? r.right = `${a.innerWidth - o.right}px` : r.left = `${o.left}px`, e && (r.bottom = `${a.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: a,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: C, height: _ } = this.state, S = f(
      {
        [$t.dropdown]: !0,
        [$t.dropdownOpen]: o,
        [$t.dropdownFromRight]: g,
        [$t.dropdownFromBottom]: b,
        [$t.dropdownAnimating]: x,
        [$t.dropdownFixed]: c
      },
      t
    );
    let v = { ...d };
    C && _ && (v.width = `${C}px`, v.height = `${_}px`), c && (v = { ...v, ...this.getFixedPosition() });
    const y = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: S,
        ref: this.dropdownRef,
        style: v,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: $t.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: $t.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: $t.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          y && /* @__PURE__ */ s.jsx(
            kr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: e
            }
          )
        ]
      }
    );
  }
}
const uc = "h-dropdownButton--dropdownButton__root", pc = "h-dropdownButton--dropdownButton__wrapper", cs = {
  root: uc,
  wrapper: pc
}, un = vt({
  toggleDropdown: E,
  openDropdown: E,
  closeDropdown: E,
  dropdownOpen: !1
});
class de extends ft {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  win;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(t) {
    super(t);
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.win = window, this.buttonWrapperRef = W(), this.buttonRef = W(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  getWindow() {
    return this.buttonWrapperRef.current?.ownerDocument?.defaultView ?? window;
  }
  componentDidMount() {
    this.win = this.getWindow(), this.props.allowEscClose && this.props.show && this.win.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && this.win.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && this.win.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    Ee(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return this.win.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, a = t ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: a }, this.setState({ dropdownOpen: a, pristine: !1 }), e && (a ? this.win.addEventListener.bind(this.win) : this.win.removeEventListener.bind(this.win))("keydown", this.handleKeyDown, !0), n?.(a, o);
  }
  shouldDropdownBeAboveButton() {
    const t = this.buttonWrapperRef.current?.getBoundingClientRect();
    return t ? t.bottom > this.getWindow().innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: a,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e?.className,
        ...e,
        onMouseEnter: a,
        onMouseLeave: l,
        ...Xn(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      X,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: a,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: a,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      destroyOnClose: C,
      ..._
    } = this.props, { dropdownOpen: S, pristine: v } = this.state, y = f({ [cs.root]: cs.root }, t);
    return /* @__PURE__ */ s.jsx(un.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ..._, className: y, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: cs.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        te,
        {
          restoreFocus: this.buttonRef,
          ...a,
          isOpen: S,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (S || !v && !C) && o
        }
      )
    ] }) }) });
  }
}
const mc = "h-collapseCard--header__header", gc = "h-collapseCard--header__headerOpen", fc = "h-collapseCard--header__headerHasDropdown", bc = "h-collapseCard--header__titleWrapper", xc = "h-collapseCard--header__title", me = {
  header: mc,
  headerOpen: gc,
  headerHasDropdown: fc,
  titleWrapper: bc,
  title: xc
};
class yc extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(t) {
    const { dropdown: e, className: n } = this.props;
    return f(
      me.header,
      { [me.headerOpen]: t, [me.headerHasDropdown]: !!e },
      n
    );
  }
  render() {
    const {
      children: t,
      className: e,
      title: n,
      avatar: o,
      dropdown: r,
      onDropdownToggle: a,
      dropdownTrigger: l,
      slotBeforeTitle: c,
      slotAfterTitle: d,
      wrap: h = "nowrap",
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(qs.Consumer, { children: ({ isOpen: p, onToggle: m }) => {
      const g = this.getRootClassName(p);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...u,
          onClick: m,
          className: g,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(
              H,
              {
                alignItems: "center",
                padding: "400 0",
                className: me.titleWrapper,
                children: [
                  c,
                  o,
                  /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      className: me.titleWrapper,
                      onMouseDown: (b) => b.stopPropagation(),
                      children: /* @__PURE__ */ s.jsx(
                        A.Paragraph,
                        {
                          variant: "1",
                          wrap: h,
                          className: me.title,
                          children: t
                        }
                      )
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsxs(H, { alignItems: "center", children: [
              d,
              !!r && /* @__PURE__ */ s.jsx(
                de,
                {
                  onClick: (b) => b.stopPropagation(),
                  icon: l ? void 0 : "dots-h",
                  dropdown: r,
                  buttonProps: { variant: "tertiary" },
                  onToggle: a,
                  children: l
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: p ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const _c = "h-collapseCard--line__line", Cc = "h-collapseCard--line__lineHasLabel", vc = "h-collapseCard--line__value", wc = "h-collapseCard--line__lineHideOverflow", bn = {
  line: _c,
  lineHasLabel: Cc,
  value: vc,
  lineHideOverflow: wc
};
class Sc extends D {
  render() {
    const { label: t, children: e, className: n, hideOverflow: o, ...r } = this.props, a = f(
      {
        [bn.line]: !0,
        [bn.lineHasLabel]: !!t,
        [bn.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: a, children: [
      t && /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: t }),
      t ? /* @__PURE__ */ s.jsx("span", { className: bn.value, children: e }) : e
    ] });
  }
}
const Ic = "h-collapseCard--readMore__readMore", Dc = {
  readMore: Ic
};
class kc extends D {
  render() {
    const { onClick: t, url: e, children: n, className: o, ...r } = this.props, a = f({ [Dc.readMore]: !0 }, o);
    return e ? /* @__PURE__ */ s.jsx(A.ExternalLink, { ...r, href: e, className: a, children: n }) : /* @__PURE__ */ s.jsx(
      X,
      {
        variant: "secondary",
        ...r,
        onClick: t,
        className: a,
        children: n
      }
    );
  }
}
const Tc = "h-collapseCard--status__status", jc = {
  status: Tc
};
class Nc extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f({ [jc.status]: !0 }, e);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: t });
  }
}
class Fc extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(t) {
    super(t), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = Sc;
  static Header = yc;
  static Content = Jl;
  static ReadMore = kc;
  static Status = Nc;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(t) {
    return t?.type?.displayName === "CollapseCard.Header" && Tt(t);
  }
  isContent(t) {
    return t?.type?.displayName === "CollapseCard.Content" && Tt(t);
  }
  getHeaderChildren() {
    return Lt.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Lt.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: t } = this.props;
    return f(Ql.card, t);
  }
  render() {
    const {
      className: t,
      onToggle: e,
      isOpen: n,
      children: o,
      containerRef: r,
      ...a
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      qs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs(
          "div",
          {
            ...a,
            ref: r,
            className: this.getRootClassName(),
            children: [
              this.getHeaderChildren(),
              this.getContentChildren()
            ]
          }
        )
      }
    );
  }
}
const Hk = dn(Fc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), Pc = "h-collapsible--collapsible__root", Rc = "h-collapsible--collapsible__collapsible", Ec = "h-collapsible--collapsible__children", ds = {
  root: Pc,
  collapsible: Rc,
  children: Ec
};
class Mk extends D {
  childrenRef;
  resizeObserver = null;
  constructor(t) {
    super(t), this.childrenRef = W(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(t) {
    t.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: o, ...r } = this.props, { childrenHeight: a } = this.state, l = f(
      {
        [ds.root]: !0
      },
      t
    ), c = {
      maxHeight: n ? a : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: ds.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: ds.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const Lc = "h-colorPicker--colorPicker__root", Ac = {
  root: Lc
}, $c = "h-inputWrapper--inputWrapper__root", Oc = "h-inputWrapper--inputWrapper__rootDisabled", Bc = "h-inputWrapper--inputWrapper__rootActive", Wc = "h-inputWrapper--inputWrapper__rootHasError", Hc = "h-inputWrapper--inputWrapper__rootHasWarning", Mc = "h-inputWrapper--inputWrapper__rootHasSuccess", zc = "h-inputWrapper--inputWrapper__inputWrapper", Vc = "h-inputWrapper--inputWrapper__rootWithPrefix", Kc = "h-inputWrapper--inputWrapper__rootWithSuffix", Uc = "h-inputWrapper--inputWrapper__suffixesContainer", qc = "h-inputWrapper--inputWrapper__prefix", Gc = "h-inputWrapper--inputWrapper__suffix", Yc = "h-inputWrapper--inputWrapper__prefixDropdownButton", Qc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Xc = "h-inputWrapper--inputWrapper__prefixButton", Zc = "h-inputWrapper--inputWrapper__suffixButton", Jc = "h-inputWrapper--inputWrapper__icon", at = {
  root: $c,
  rootDisabled: Oc,
  rootActive: Bc,
  rootHasError: Wc,
  rootHasWarning: Hc,
  rootHasSuccess: Mc,
  inputWrapper: zc,
  rootWithPrefix: Vc,
  rootWithSuffix: Kc,
  suffixesContainer: Uc,
  prefix: qc,
  suffix: Gc,
  prefixDropdownButton: Yc,
  suffixDropdownButton: Qc,
  prefixButton: Xc,
  suffixButton: Zc,
  icon: Jc
}, Ps = vt({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), td = "inputWrapper";
class ed extends D {
  renderIcon() {
    const { icon: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx(N, { className: at.icon, name: t }) : null;
  }
  isButtonAddon(t) {
    return !!t && "type" in t && t.type === "button";
  }
  isCustomAddon(t) {
    return !!t && "type" in t && (!t.type || t.type === "custom");
  }
  renderAddon(t) {
    const e = this.props[t], { disabled: n } = this.props;
    if (!e)
      return null;
    let o;
    if (typeof e != "object" || !("type" in e))
      o = /* @__PURE__ */ s.jsx("div", { className: f(at[t]), children: e });
    else if (this.isCustomAddon(e))
      o = e.noWrap ? e.value : /* @__PURE__ */ s.jsx("div", { className: at[t], children: e.value });
    else if (this.isButtonAddon(e)) {
      const {
        className: r,
        disabled: a,
        ...l
      } = e.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [at[t]]: !e.noStyle,
              [at[`${t}Button`]]: !e.noStyle
            },
            r
          ),
          disabled: n || a,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(t) {
    const { disabled: e, active: n, status: o } = this.props;
    return {
      position: t,
      disabled: !!e,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: t,
      disabled: e,
      active: n,
      status: o,
      prefix: r,
      suffix: a,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      at.root,
      {
        [at.rootActive]: n,
        [at.rootDisabled]: e,
        [at.rootHasError]: o === "error",
        [at.rootHasWarning]: o === "warning",
        [at.rootHasSuccess]: o === "success",
        [at.rootWithPrefix]: !!r,
        [at.rootWithSuffix]: !!a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": td,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(Ps.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: at.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: at.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(Ps.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const At = $(function(t, e) {
  return /* @__PURE__ */ s.jsx(ed, { innerRef: e, ...t, children: t.children });
}), nd = "h-colorPicker-input--colorPickerInput__input", sd = {
  input: nd
}, od = ({
  className: i,
  ...t
}) => /* @__PURE__ */ s.jsx(At, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  Ii,
  {
    className: f(sd.input, i),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...t
  }
) }), rd = "h-colorPicker-presets--colorPickerPresets__root", id = {
  root: rd
}, ad = "h-colorPicker-presets-preset--colorPickerPreset__root", ld = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", cd = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", dd = "h-colorPicker-presets-preset--colorPickerPreset__preset", xn = {
  root: ad,
  rootIsSelected: ld,
  rootAlpha: cd,
  preset: dd
}, hd = ({
  color: i,
  onSelect: t,
  isSelected: e,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(xn.root, o, {
      [xn.rootIsSelected]: e,
      [xn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": i,
        className: xn.preset,
        style: { backgroundColor: i },
        onClick: () => {
          t?.(i);
        }
      }
    )
  }
);
Hs([Ms]);
const ud = ({
  presets: i,
  className: t,
  onChange: e,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f(id.root, t),
    ...r,
    children: i.map((a) => /* @__PURE__ */ s.jsx(
      hd,
      {
        onSelect: e,
        color: a,
        isSelected: n === (a.startsWith("#") ? a : Wn(a).toHex()),
        alpha: o
      },
      a
    ))
  }
);
Hs([Ms]);
const pd = ({
  onChange: i,
  color: t,
  alpha: e,
  className: n,
  ...o
}) => {
  const r = P((a) => {
    setTimeout(() => {
      i?.(Wn(a).toHex());
    });
  }, []);
  return e ? /* @__PURE__ */ s.jsx(
    ki,
    {
      className: n,
      color: Wn(t ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    Di,
    {
      className: n,
      color: t,
      onChange: i,
      ...o
    }
  );
};
Hs([Ms]);
const md = "colorPickerTestId", Jn = ({
  className: i,
  color: t,
  onChange: e,
  alpha: n,
  children: o,
  ...r
}) => {
  const [a, l] = V();
  return G(() => {
    const c = t?.startsWith("#") ? t : Wn(t ?? "").toHex();
    l(c);
  }, [t]), /* @__PURE__ */ s.jsx(
    H,
    {
      flexDirection: "column",
      gap: "250",
      className: f(Ac.root, i),
      "data-testid": md,
      ...r,
      children: Lt.map(
        o,
        (c) => Tt(c) && cn(c, {
          onChange: e,
          color: a,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
Jn.Input = od;
Jn.Sliders = pd;
Jn.Presets = ud;
const gd = "h-columns--columns__root", fd = {
  root: gd
}, bd = "1fr", xd = $(function({ as: t = "div", children: e, className: n, style: o, ...r }, a) {
  const c = Lt.toArray(e).map((d) => d.props.size ?? bd).join(" ");
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...r,
      ref: a,
      className: f(fd.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: e
    }
  );
}), yd = "h-columns-column--column__root", _d = {
  root: yd
}, Cd = "h-columns-column-row--columnRow__root", vd = "h-columns-column-row--columnRow__noMinHeight", wd = "h-columns-column-row--columnRow__noVerticalPadding", Sd = "h-columns-column-row--columnRow__noHorizontalPadding", Id = "h-columns-column-row--columnRow__borderTop", Dd = "h-columns-column-row--columnRow__borderBottom", kd = "h-columns-column-row--columnRow__scrollable", Td = "h-columns-column-row--columnRow__slottable", Vt = {
  root: Cd,
  noMinHeight: vd,
  noVerticalPadding: wd,
  noHorizontalPadding: Sd,
  borderTop: Id,
  borderBottom: Dd,
  scrollable: kd,
  slottable: Td
}, jd = 1, Nd = $(function({
  as: t = "div",
  children: e,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: a,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Vt.root, {
    [Vt.slottable]: u,
    [Vt.noVerticalPadding]: u ?? o,
    [Vt.noHorizontalPadding]: r,
    [Vt.borderTop]: l,
    [Vt.borderBottom]: c,
    [Vt.scrollable]: d,
    [Vt.noMinHeight]: a
  });
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? jd : void 0
      },
      children: e
    }
  );
}), Fd = "h-columns-column-slot--columnSlot__root", Pd = "h-columns-column-slot--columnSlot__noVerticalPadding", _o = {
  root: Fd,
  noVerticalPadding: Pd
}, Rd = ({
  children: i,
  className: t,
  noVerticalPadding: e,
  placement: n = "start"
}) => {
  const o = f(_o.root, t, {
    [_o.noVerticalPadding]: e
  });
  return /* @__PURE__ */ s.jsx(
    H,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: i
    }
  );
}, mt = ({
  as: i,
  children: t,
  className: e
}) => /* @__PURE__ */ s.jsx(
  H,
  {
    as: i,
    flexDirection: "column",
    className: f(_d.root, e),
    children: t
  }
);
mt.Row = Nd;
mt.Slot = Rd;
const Ed = "h-copyToClipboard--copyToClipboard__copyToClipboard", Ld = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", Co = {
  copyToClipboard: Ed,
  copyToClipboardTooltip: Ld
};
class Ad extends ft {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(t) {
    super(t), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    e || (typeof r == "function" && r(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, a = f(
      Co.copyToClipboard,
      { [Co.copyToClipboardTooltip]: r && o },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: a, children: Lt.map(e, (l) => Tt(l) ? cn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class zk extends D {
  render() {
    const { buttonProps: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx(Ad, { ...e, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...t }) });
  }
}
const $d = "h-simplePagination--simplePagination__paginationButton", vo = {
  paginationButton: $d
}, Od = "simplePaginationTestId", Bd = ({
  nextButtonClick: i = E,
  previousButtonClick: t = E,
  nextButtonText: e = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: a = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": Od, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: r || h,
      onClick: t,
      variant: "secondary",
      ...d,
      className: f(
        vo.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !a && /* @__PURE__ */ s.jsx(
    X,
    {
      disabled: o || h,
      onClick: i,
      variant: "secondary",
      ...c,
      className: f(
        vo.paginationButton,
        c?.className
      ),
      children: h ? u : e
    }
  )
] }), ts = vt(
  void 0
);
var ct = /* @__PURE__ */ ((i) => (i.Foot = "table-foot", i.Body = "table-body", i.Head = "table-head", i.Row = "table-row", i.PaginationRow = "table-pagination-row", i.Td = "table-body-cell", i.Th = "table-header-cell", i.RowExpansionTrigger = "table-row-expansion-trigger", i.LoadingRow = "table-loading-row", i.LoadingFailedRow = "table-loading-failed-row", i.EmptyRow = "table-empty-row", i))(ct || {});
const Wd = "h-table-tfoot--tfoot__root", Hd = "h-table-tfoot--tfoot__rootIsLoading", wo = {
  root: Wd,
  rootIsLoading: Hd
}, Tr = vt(
  void 0
), So = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(ts.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(Tr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...e,
    ref: n,
    className: f(
      {
        [wo.rootIsLoading]: o?.status.loading
      },
      wo.root,
      i
    ),
    "data-testid": ct.Foot,
    children: t
  }
) }) }), Md = Object.assign($(So), { name: So.name }), zd = "h-table-thead--thead__root", Vd = "h-table-thead--thead__rootIsLoading", Io = {
  root: zd,
  rootIsLoading: Vd
}, jr = vt(
  void 0
), Do = ({ className: i, ...t }, e) => /* @__PURE__ */ s.jsx(ts.Consumer, { children: (n) => {
  const o = f(Io.root, i, {
    [Io.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(jr.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...t,
      ref: e,
      className: o,
      "data-testid": ct.Head
    }
  ) });
} }), Kd = Object.assign($(Do), { name: Do.name }), Le = (i) => {
  const t = Ht(ts);
  if (!t)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const e = Ht(jr) || {
    isTableHead: !1
  }, n = Ht(Tr) || {
    isTableFoot: !1
  };
  return i.children({
    ...t,
    ...e,
    ...n
  });
}, Ud = "h-table-tableFooter--tableFooter__root", qd = "h-table-tableFooter--tableFooter__rootIsLoading", ko = {
  root: Ud,
  rootIsLoading: qd
}, To = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [ko.rootIsLoading]: o.loading
      },
      ko.root,
      t
    ),
    ...e,
    children: i
  }
) }), Gs = Object.assign($(To), {
  name: To.name
});
function Gd(i) {
  return Lt.toArray(i).reduce(
    (t, e) => {
      const n = e;
      return n.type === Gs ? t.footers.push(n) : t.children.push(n), t;
    },
    { children: [], footers: [] }
  );
}
var Mn = /* @__PURE__ */ ((i) => (i.PageNumber = "page-number", i.PrevPageButton = "prev-page-button", i.NextPageButton = "next-page-button", i))(Mn || {});
const Yd = "h-pagination--pageNumber__button", Qd = "h-pagination--pageNumber__text", Xd = "h-pagination--pageNumber__textSelected", hs = {
  button: Yd,
  text: Qd,
  textSelected: Xd
}, Zd = ({
  number: i,
  isSelected: t = !1,
  onClick: e
}) => {
  const n = f(hs.text, {
    [hs.textSelected]: t
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    X,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => e(i),
      "data-testid": Mn.PageNumber,
      className: hs.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: i })
    }
  ) });
}, Jd = "h-pagination--pagination__root", th = "h-pagination--pagination__pageNumberSeparatorWrapper", jo = {
  root: Jd,
  pageNumberSeparatorWrapper: th
};
class eh extends ft {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(t) {
    super(t), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: t, pageCount: e, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [t, e, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(t) {
    const { currentPage: e, onPageChange: n } = this.props;
    t !== e && n(t);
  }
  areAllPagedDisplayable() {
    const { pageCount: t, pageRangeDisplayed: e } = this.props;
    return e >= t;
  }
  leadingTruncationIsNeeded() {
    const { start: e } = this.calculateMiddlePagesRange();
    return e - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: t } = this.props, { start: e, length: n } = this.calculateMiddlePagesRange(), o = e - 1 + n;
    return t - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: t } = this.props;
    return t - 2;
  }
  calculateMiddlePagesRange(t) {
    const { pageCount: e, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (t?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: An(
      n - r,
      2,
      e - o
    ), length: o };
  }
  createPageNumbers(t, e = 1) {
    return Array.from({ length: t }, (n, o) => o + e);
  }
  renderPageNumbers(t, e = 1) {
    return this.createPageNumbers(t, e).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(t) {
    const { currentPage: e } = this.props, n = t === e;
    return /* @__PURE__ */ s.jsx(
      Zd,
      {
        number: t,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      t
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(t = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: jo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(N, { name: "dots-h" }) }, `gap-${t}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: t } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(t)] : this.renderSinglePageNumber(t);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: t, length: e } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(e, t);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: t } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(jo.root, t), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": Mn.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": Mn.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const No = ({ children: i, ...t }, e) => /* @__PURE__ */ s.jsx(Le, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Gs, { children: /* @__PURE__ */ s.jsx("div", { ref: e, ...t, "data-testid": ct.PaginationRow, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  eh,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), nh = Object.assign($(No), {
  name: No.name
}), sh = "h-table-tbody--tbody__root", oh = "h-table-tbody--tbody__rootIsLoading", rh = "h-table-tbody--tbody__rootIsLoadingFade", us = {
  root: sh,
  rootIsLoading: oh,
  rootIsLoadingFade: rh
}, ih = "h-emptyState--emptyState__textWrapper", ah = "h-emptyState--emptyState__rootSmall", lh = "h-emptyState--emptyState__rootLarge", ps = {
  textWrapper: ih,
  rootSmall: ah,
  rootLarge: lh
}, ch = ({
  className: i,
  title: t,
  description: e,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: a
}) => {
  const l = f(
    {
      [ps.rootSmall]: r === "small",
      [ps.rootLarge]: r === "large"
    },
    i
  );
  return /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: sn(o) }),
        /* @__PURE__ */ s.jsxs(
          H,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: ps.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: t }),
              /* @__PURE__ */ s.jsx(
                A.Paragraph,
                {
                  variant: "2",
                  as: typeof e == "string" ? "p" : "div",
                  children: e
                }
              )
            ]
          }
        ),
        a?.children && /* @__PURE__ */ s.jsx(X, { ...a })
      ]
    }
  );
};
function dh(i) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(ch, { ...i }) }) }) });
}
function hh({
  onRetry: i,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingFailedRow, ...t, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong..." }),
        i && /* @__PURE__ */ s.jsx(X, { variant: "tertiary", onClick: i, children: "Try again" })
      ]
    }
  ) }) });
}
function uh({
  ...i
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingRow, ...i, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    H,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(Gn, {}),
        /* @__PURE__ */ s.jsx(it, { margin: "300", children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const Fo = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: a, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...e,
      "data-testid": ct.Body,
      ref: n,
      className: f(
        {
          [us.rootIsLoading]: o,
          [us.rootIsLoadingFade]: o && c === "fade"
        },
        us.root,
        t
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(uh, {}),
        d && /* @__PURE__ */ s.jsx(hh, { onRetry: a }),
        l && /* @__PURE__ */ s.jsx(dh, { ...l }),
        h && i
      ]
    }
  );
} }), ph = Object.assign($(Fo), { name: Fo.name }), mh = "h-table-td--td__root", gh = "h-table-td--td__rootExtraPaddingForFirstChild", fh = "h-table-td--td__rootStickyFooterTd", ms = {
  root: mh,
  rootExtraPaddingForFirstChild: gh,
  rootStickyFooterTd: fh
}, Po = ({ className: i, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Le, { children: ({ rows: o, presentation: r, isTableFoot: a }) => {
  const l = f(
    ms.root,
    {
      [ms.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [ms.rootStickyFooterTd]: r.stickyFooter === !0 && a === !0
    },
    i
  );
  return /* @__PURE__ */ s.jsx(
    it,
    {
      as: "td",
      ref: n,
      className: l,
      ...e,
      "data-testid": ct.Td,
      children: t
    }
  );
} }), ae = Object.assign($(Po), { name: Po.name }), bh = "h-table-th--th__root", xh = "h-table-th--th__rootSticky", yh = "h-table-th--th__rootShowBG", _h = "h-table-th--th__rootClickable", Ch = "h-table-th--th__icon", vh = "h-table-th--th__contentWrapper", wh = "h-table-th--th__tooltip", ne = {
  root: bh,
  rootSticky: xh,
  rootShowBG: yh,
  rootClickable: _h,
  icon: Ch,
  contentWrapper: vh,
  tooltip: wh
};
class Ro extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (t) => t === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: e?.sorting.sortStatus?.sortBy === t,
      sortDirection: e?.sorting.sortStatus?.direction,
      columnIsSortable: e?.sorting.sortable && !Ct(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      t?.(n), o && !Ct(r) && e?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: ne.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Le, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: a,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        ne.root,
        {
          [ne.rootClickable]: u,
          [ne.rootSticky]: n.stickyHeader,
          [ne.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [ne.tooltip]: a
      });
      return /* @__PURE__ */ s.jsx(
        it,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": ct.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: ne.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(st, { content: a, disabled: !a, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Rs = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(Ro, { ...t, thRef: e });
    }
  ),
  { name: Ro.name }
), Sh = (i) => i === !1, Ih = "h-table-tr--tr__trHoverable", Dh = "h-table-tr--tr__expansionTriggerWrapper", kh = "h-table-tr--tr__expansionTriggerWrapperExpanded", Th = "h-table-tr--tr__checkboxCell", jh = "h-table-tr--tr__checkboxCellExpanded", Nh = "h-table-tr--tr__expandedRowContentWrapper", Dt = {
  trHoverable: Ih,
  expansionTriggerWrapper: Dh,
  expansionTriggerWrapperExpanded: kh,
  checkboxCell: Th,
  checkboxCellExpanded: jh,
  expandedRowContentWrapper: Nh
}, Fh = ({
  rowId: i,
  isExpandable: t,
  isExpanded: e,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: a,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [Dt.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": ct.Row,
        children: [
          t && /* @__PURE__ */ s.jsx(
            ae,
            {
              className: f(Dt.expansionTriggerWrapper, {
                [Dt.expansionTriggerWrapperExpanded]: e
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: e ? "angle-down" : "angle-right",
                  "data-testid": ct.RowExpansionTrigger,
                  onClick: () => {
                    Ct(i) || n(i);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            ae,
            {
              className: f(Dt.checkboxCell, {
                [Dt.checkboxCellExpanded]: e
              }),
              children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                hn,
                {
                  checked: a,
                  name: `selection-trigger-${i}`,
                  id: `selection-trigger-${i}`,
                  onChange: () => {
                    Ct(i) || l(i);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    t && e && /* @__PURE__ */ s.jsxs("tr", { "data-testid": ct.Row, children: [
      /* @__PURE__ */ s.jsx(ae, { className: Dt.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(ae, { className: Dt.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        ae,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: Dt.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, Ph = ({
  isExpandable: i,
  children: t,
  trRef: e,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: e, "data-testid": ct.Row, children: [
  i && /* @__PURE__ */ s.jsx(ae, { className: Dt.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t
] }), Rh = ({
  isExpandable: i,
  isSelectable: t,
  allRowsSelected: e,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: a,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: a, "data-testid": ct.Row, children: [
  i && /* @__PURE__ */ s.jsx(Rs, { className: Dt.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t && /* @__PURE__ */ s.jsx(Rs, { className: Dt.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(H, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    hn,
    {
      checked: e,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class Eo extends D {
  context = void 0;
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    const { rowId: t } = this.props;
    return this.context?.rows.selectableRows === !0 && !Ct(t);
  }
  hasExpandableRow() {
    const { expandableContent: t, rowId: e } = this.props;
    return this.context?.rows.expandableRows === !0 && !Ct(t) && !Ct(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(Sh);
  }
  rowIdIsPresent(t) {
    return !Ct(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Le, { children: (r) => {
      this.context = r;
      const { rows: a } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          Rh,
          {
            ...o,
            isExpandable: a.expandableRows,
            isSelectable: a.selectableRows,
            allRowsSelected: a.allRowsSelected,
            allRowsSelectedIndeterminate: a.allRowsSelectedIndeterminate,
            onAllRowsSelect: a.onAllRowsSelect,
            children: t
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(Ph, { ...o, isExpandable: a.expandableRows, children: t });
      const l = Ct(n) ? !1 : this.isRowExpanded(a.expandedRows, n), c = Ct(n) ? !1 : a.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        Fh,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: a.onRowSelect,
          isExpandable: a.expandableRows,
          expandableContent: e,
          isSelectable: a.selectableRows,
          onExpansionToggle: a.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const Eh = Object.assign(
  $(function(t, e) {
    return /* @__PURE__ */ s.jsx(Eo, { ...t, trRef: e });
  }),
  { name: Eo.name }
), Lh = "h-table--table__wrapper", Ah = "h-table--table__wrapperIsFramed", $h = "h-table--table__wrapperIsLoading", Oh = "h-table--table__innerWrapper", Bh = "h-table--table__wrapperIsDisabled", Wh = "h-table--table__table", ge = {
  wrapper: Lh,
  wrapperIsFramed: Ah,
  wrapperIsLoading: $h,
  innerWrapper: Oh,
  wrapperIsDisabled: Bh,
  table: Wh
};
class zn extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(t) {
    super(t), this.state = {
      expandedRows: t.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    H,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(t) {
    this.state.expandedRows.includes(t) ? this.setState(({ expandedRows: e }) => ({
      expandedRows: e.filter((n) => n !== t)
    })) : this.setState(({ expandedRows: e }) => ({
      expandedRows: [...e, t]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: t,
        stickyHeader: e,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: a,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!t,
        stickyHeader: !!e,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? E
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? E,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!a,
        selectedRowIds: a?.selectedRowIds ?? [],
        onRowSelect: a?.onRowSelect ?? E,
        onAllRowsSelect: a?.onAllRowsSelect ?? E,
        allRowsSelected: a?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: a?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: t,
      className: e,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: a,
      nativeProps: l,
      tableRef: c
    } = this.props, d = Gd(n), h = f(ge.wrapper, o?.className, {
      [ge.wrapperIsFramed]: t,
      [ge.wrapperIsLoading]: this.props.loading,
      [ge.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [ge.innerWrapper]: !0
      },
      a
    ), p = f(ge.table, e), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Re, { fallback: zn.fallback, children: /* @__PURE__ */ s.jsx(ts.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(nh, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const gt = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(zn, { ...t, tableRef: e });
    }
  ),
  {
    name: zn.name,
    Thead: Kd,
    Tbody: ph,
    Tfoot: Md,
    Tr: Eh,
    Th: Rs,
    Td: ae,
    Footer: Gs
  }
), Hh = "h-helpIcon--helpIcon__infoIcon", Mh = {
  infoIcon: Hh
};
class Ys extends D {
  render() {
    const {
      side: t,
      text: e,
      title: n,
      disabled: o,
      requireClick: r,
      className: a,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        head: n,
        content: e,
        disabled: o,
        side: t,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(Mh.infoIcon, a), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const Nr = ({
  columns: i
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: i.map(({ label: t, style: e, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(gt.Th, { columnId: o || t, style: e, children: [
  t,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Ys, { side: "bottom", ...n })
] }, t || r)) }), zh = ({
  columns: i,
  data: t
}) => /* @__PURE__ */ s.jsxs(gt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(Nr, { columns: i }) }) }),
  /* @__PURE__ */ s.jsx(gt.Tbody, { children: t.map((e, n) => /* @__PURE__ */ s.jsx(gt.Tr, { children: i.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(gt.Td, { children: o(e) }, r)) }, n)) })
] }), Vh = ({
  data: i,
  rowId: t,
  columns: e,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  gt.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      zh,
      {
        data: o(i),
        columns: n
      }
    ),
    rowId: t,
    children: e.map(({ selector: r }, a) => /* @__PURE__ */ s.jsx(gt.Td, { children: r(i) }, a))
  }
), Vk = ({
  columns: i,
  subTableColumns: t,
  data: e,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: a,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = i.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    gt,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(t && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(gt.Thead, { children: /* @__PURE__ */ s.jsx(gt.Tr, { children: /* @__PURE__ */ s.jsx(Nr, { columns: i }) }) }),
        /* @__PURE__ */ s.jsx(gt.Tbody, { children: e.map((b, x) => /* @__PURE__ */ s.jsx(
          Vh,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: i,
            subTableDataSelector: n,
            subTableColumns: t
          },
          x
        )) }),
        a && /* @__PURE__ */ s.jsx(gt.Footer, { children: /* @__PURE__ */ s.jsx(Bd, { ...a }) })
      ]
    }
  );
}, Kh = "h-datePickerOld--datePickerDay__root", Uh = "h-datePickerOld--datePickerDay__rootActive", qh = "h-datePickerOld--datePickerDay__rootDisabled", Gh = "h-datePickerOld--datePickerDay__rootDim", Yh = "h-datePickerOld--datePickerDay__label", He = {
  root: Kh,
  rootActive: Uh,
  rootDisabled: qh,
  rootDim: Gh,
  label: Yh
};
class Qh extends D {
  render() {
    const {
      className: t,
      dim: e,
      active: n,
      disabled: o,
      children: r,
      onClick: a,
      ...l
    } = this.props, c = f(
      {
        [He.root]: !0,
        [He.rootDim]: e,
        [He.rootActive]: n,
        [He.rootDisabled]: !n && o
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: a,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: He.label, children: r })
      }
    );
  }
}
const Xh = "h-datePickerOld--datePickerOld__grid", Zh = "h-datePickerOld--datePickerOld__gridItem", Jh = "h-datePickerOld--datePickerOld__day", tu = "h-datePickerOld--datePickerOld__month", eu = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", nu = "h-datePickerOld--datePickerOld__timeButtonContainerRight", su = "h-datePickerOld--datePickerOld__arrowTime", ou = "h-datePickerOld--datePickerOld__arrow", ru = "h-datePickerOld--datePickerOld__dayNames", iu = "h-datePickerOld--datePickerOld__dayName", au = "h-datePickerOld--datePickerOld__time", lu = "h-datePickerOld--datePickerOld__timeDisplay", Q = {
  grid: Xh,
  gridItem: Zh,
  day: Jh,
  month: tu,
  timeButtonContainerLeft: eu,
  timeButtonContainerRight: nu,
  arrowTime: su,
  arrow: ou,
  dayNames: ru,
  dayName: iu,
  time: au,
  timeDisplay: lu
}, Kk = (i) => [0, 6].indexOf(i.getDay()) !== -1;
class en extends D {
  static defaultProps;
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  constructor(t) {
    super(t);
    const e = en.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: en.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: o, minDate: r, maxDate: a } = this.props, l = [], c = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = en.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === e.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(a && g > a) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  nextMonth = (t) => {
    t.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (t) => {
    t.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: e
    };
    o.getMonth() !== e.getMonth() && (r.showDate = e), this.setState(r), n(e);
  }
  goToTime(t, e, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: a }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + e), this.setState({
      selectedDate: c
    }), a(c);
  }
  nextMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, 15, "minutes");
  };
  prevMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, -15, "minutes");
  };
  nextHour = (t) => {
    t.preventDefault(), this.goToTime(t, 1);
  };
  prevHour = (t) => {
    t.preventDefault(), this.goToTime(t, -1);
  };
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", o = t === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: a } = this.state, l = new Date(a.getTime());
    return l[n](l[o]() + e), !(l.getDate() !== a.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: a,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, t), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Q.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: Q.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: Q.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: Q.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: Q.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: Q.gridItem, children: /* @__PURE__ */ s.jsx(
        Qh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: Q.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: Q.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: Q.timeDisplay, children: `${uo(
          c.getHours().toString(),
          2,
          "0"
        )}:${uo(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: Q.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: Q.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
en.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function cu(i) {
  return Math.abs(i.diff(j())) < 25e3 ? "just now" : i.fromNow();
}
function Es(i) {
  return j(i, j.ISO_8601).isValid();
}
function Te(i) {
  return !!j.tz.zone(i ?? "");
}
const Rt = "HH:mm", Fr = yr(24), Pr = yr(0, 60, 15), Rr = (i) => j("1995-12-25").format(i);
function Er(i) {
  if (i < 0 || i > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function Lr(i) {
  if (i < 0 || i > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Ar({
  hour: i,
  minute: t,
  timeFormat: e
}) {
  const n = j({ hour: i, minute: t });
  return {
    id: n.format(Rt),
    name: n.format(e)
  };
}
function du(i, t) {
  return t?.map(({ hour: e, minute: n }) => (Er(e), Lr(n), Ar({ hour: e, minute: n, timeFormat: i }))) || [];
}
function $r({
  hours: i,
  minutes: t,
  overrides: e,
  timeFormat: n
}) {
  return Ti(
    i.reduce(
      (o, r, a) => [
        ...o,
        ...t.map((l, c) => (c === 0 && Er(r), a === 0 && Lr(l), Ar({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(du(n, e)),
    ["id"]
  );
}
const hu = "h-datePicker--datePicker__root", uu = "h-datePicker--datePicker__navigationButton", pu = "h-datePicker--datePicker__nextMonthButton", mu = "h-datePicker--datePicker__prevMonthButton", ke = {
  root: hu,
  navigationButton: uu,
  nextMonthButton: pu,
  prevMonthButton: mu
}, Vn = {
  previousMonth({ ariaLabel: i, ...t }) {
    const e = f(
      ke.navigationButton,
      ke.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: i, ...t }) {
    const e = f(
      ke.navigationButton,
      ke.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": i, size: 24, name: "angle-right" }) });
  }
}, Or = (i) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: i.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), Br = ({ month: i }) => /* @__PURE__ */ s.jsx("span", { children: i.format("MMMM YYYY") }), Wr = (i) => {
  const { value: t, presets: e, onSelect: n } = i, o = P(
    (r) => {
      n(r.key === t ? null : r);
    },
    [n, t]
  );
  return /* @__PURE__ */ s.jsxs(Mt, { children: [
    /* @__PURE__ */ s.jsx(Qn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(bo, { children: e.map((r) => /* @__PURE__ */ s.jsx(
      bo.Item,
      {
        isSelected: r.key === t,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, gu = "h-fieldLabel--fieldLabel__root", fu = "h-fieldLabel--fieldLabel__label", bu = "h-fieldLabel--fieldLabel__labelChildren", xu = "h-fieldLabel--fieldLabel__rootRequired", yu = "h-fieldLabel--fieldLabel__helpIcon", Me = {
  root: gu,
  label: fu,
  labelChildren: bu,
  rootRequired: xu,
  helpIcon: yu
}, _u = "fieldLabel";
class Qs extends D {
  render() {
    const { required: t, helpIcon: e, className: n, children: o, ...r } = this.props, a = f(Me.root, n, {
      [Me.rootRequired]: t
    });
    return /* @__PURE__ */ s.jsxs("div", { className: a, "data-testid": _u, children: [
      /* @__PURE__ */ s.jsx("label", { className: Me.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: Me.labelChildren, children: o }) }),
      !!e?.text && /* @__PURE__ */ s.jsx(
        Ys,
        {
          ...e,
          className: f(Me.helpIcon, e.className)
        }
      )
    ] });
  }
}
const Cu = "h-dropdownSelect--dropdownInfinite__item", vu = "h-dropdownSelect--dropdownInfinite__list", wu = "h-dropdownSelect--dropdownInfinite__listEmpty", gs = {
  item: Cu,
  list: vu,
  listEmpty: wu
};
class Lo extends D {
  render() {
    const {
      item: t,
      itemComponent: e,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      e,
      {
        item: t,
        onSelect: o,
        onChange: r,
        onKeyDown: a,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: u ? 0 : -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(st, { ...n, children: m }, t.id) : m;
  }
}
const Su = 6, Iu = 48;
class Xs extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(t) {
    super(t), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = W(), this.infiniteListRef = W();
  }
  componentDidUpdate(t) {
    const { activeItem: e, items: n, pagination: o } = this.props, r = typeof t.activeItem == "object" && t.activeItem ? t.activeItem.id : t.activeItem, a = typeof e == "object" && e ? e.id : e;
    if (r !== a && a !== null) {
      const l = n.findIndex(
        (c) => c.id === a
      );
      if (l >= 0) {
        if (typeof o == "object" && o.infinite && this.infiniteListRef.current)
          this.infiniteListRef.current.scrollToItem(l, "smart");
        else if (this.listRef.current) {
          const c = this.listRef.current.children[l];
          c && c.scrollIntoView({ block: "nearest" });
        }
      }
    }
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return e ? typeof e == "object" && "id" in e ? t.id === e.id : t.id === e : !1;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return (e?.findIndex((o) => typeof o == "object" ? o.id === t.id : o === t.id) ?? -1) > -1;
  }
  isItemDisabled(t) {
    return t ? (this.props.disabledItems?.indexOf(t.id) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || zs(e?.[t.id]) ? null : e?.[t.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  focusActiveItem() {
    const { items: t, activeItem: e } = this.props;
    if (!e || !this.listRef.current) return;
    const n = typeof e == "object" && "id" in e ? e.id : e, o = t.findIndex((r) => r.id === n);
    if (o >= 0 && this.listRef.current.children[o]) {
      const r = this.listRef.current.children[o];
      (r.querySelector('[tabindex="0"]') || r)?.focus();
    }
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: t,
    style: e
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: a, clearSearch: l } = this.props, c = this.isItemLoaded(t), d = t === n.length - 1, h = c ? n[t] : { id: rn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: e, className: gs.item, children: [
      /* @__PURE__ */ s.jsx(
        Lo,
        {
          id: this.getItemId(t),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: a,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(ji, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: a,
      clearSearch: l,
      itemsDisplayCount: c = Su,
      itemHeight: d = Iu,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: f({
            [gs.list]: !0,
            [gs.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: t.map((C, _) => {
            const S = Ni(C) ? C : C.id.toString() || C.name.toString() || C.toString();
            return /* @__PURE__ */ s.jsx(
              Lo,
              {
                id: this.getItemId(_),
                checked: this.isItemChecked(C),
                clearSearch: l,
                disabled: this.isItemDisabled(C),
                item: C,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: a,
                tooltip: this.getTooltip(C),
                active: this.isItemActive(C)
              },
              S
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = e, g = m || (p ? t.length + c : t.length), b = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(Fi, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: C }) => /* @__PURE__ */ s.jsx(
      Pi,
      {
        ...b,
        ref: this.infiniteListRef,
        width: C,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const Du = "h-selectItems-checkableBaseItem--checkableBaseItem__root", ku = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", Tu = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", ju = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", Nu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", ze = {
  root: Du,
  rootActive: ku,
  rootDisabled: Tu,
  checkbox: ju,
  content: Nu
};
class Zs extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  handleKeyDown(t) {
    const { disabled: e, onKeyDown: n } = this.props;
    (t.key === "Enter" || t.key === " ") && !e && (t.preventDefault(), this.handleChange()), n && n(t);
  }
  noop(t) {
    t.preventDefault();
  }
  render() {
    const {
      item: t,
      onChange: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      children: l,
      active: c,
      tabIndex: d,
      onKeyDown: h,
      ...u
    } = this.props, p = f(ze.root, {
      [ze.rootDisabled]: r,
      [ze.rootActive]: c
    }), m = r ? E : this.handleChange;
    return /* @__PURE__ */ s.jsxs(
      "label",
      {
        ...u,
        className: p,
        tabIndex: d,
        onKeyDown: this.handleKeyDown,
        children: [
          /* @__PURE__ */ s.jsx(
            hn,
            {
              id: t?.id,
              name: "",
              className: ze.checkbox,
              checked: o,
              onChange: m,
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: ze.content, children: l })
        ]
      }
    );
  }
}
const Fu = "h-selectItems-emptySelectItem--emptySelectItem__root", Pu = "h-selectItems-emptySelectItem--emptySelectItem__name", Ao = {
  root: Fu,
  name: Pu
};
class pn extends D {
  render() {
    const { label: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...e, className: Ao.root, children: /* @__PURE__ */ s.jsx("div", { className: Ao.name, children: t }) });
  }
}
const Ru = "h-selectItems-selectItem--selectItem__root", Eu = "h-selectItems-selectItem--selectItem__rootActive", Lu = "h-selectItems-selectItem--selectItem__name", Au = "h-selectItems-selectItem--selectItem__nameBold", $u = "h-selectItems-selectItem--selectItem__nameWithDescription", Ou = "h-selectItems-selectItem--selectItem__description", Bu = "h-selectItems-selectItem--selectItem__icon", se = {
  root: Ru,
  rootActive: Eu,
  name: Lu,
  nameBold: Au,
  nameWithDescription: $u,
  description: Ou,
  icon: Bu
};
class Hr extends ft {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: a,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = t, m = f(se.root, {
      [se.rootActive]: a
    }), g = f(se.name, {
      [se.nameBold]: o,
      [se.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": a,
        className: m,
        disabled: r,
        onClick: () => {
          e(t);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: se.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: se.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const Wu = "h-selectItems-checkableSelectItem--checkableSelectItem__name", Hu = {
  name: Wu
};
class Uk extends D {
  render() {
    const { item: t, isLoading: e } = this.props, { name: n } = e ? { name: "Loading..." } : t;
    return /* @__PURE__ */ s.jsx(Zs, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: Hu.name, children: n }) });
  }
}
const Mu = "h-selectItems-tagSelectItem--tagSelectItem__root", zu = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", Vu = "h-selectItems-tagSelectItem--tagSelectItem__name", Ku = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", Uu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", qu = "h-selectItems-tagSelectItem--tagSelectItem__dot", fe = {
  root: Mu,
  rootActive: zu,
  name: Vu,
  nameBold: Ku,
  dotContainer: Uu,
  dot: qu
};
class qk extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: a,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = t, u = f(fe.root, {
      [fe.rootActive]: l
    }), p = f(fe.name, {
      [fe.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          e(t), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: fe.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: fe.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const Gu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", Yu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", Qu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Xu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", yn = {
  name: Gu,
  dotContainer: Yu,
  dot: Qu,
  nameContainer: Xu
};
class Gk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  render() {
    const { item: t, isLoading: e, disabled: n } = this.props, { name: o, color: r } = e ? { name: "Loading...", color: "#000" } : t;
    return /* @__PURE__ */ s.jsx(
      Zs,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: yn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: yn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: yn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: yn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const Zu = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Ju = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", tp = "h-selectItems-avatarSelectItem--avatarSelectItem__names", ep = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", np = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", sp = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", op = "h-selectItems-avatarSelectItem--avatarSelectItem__container", rp = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Kt = {
  root: Zu,
  rootActive: Ju,
  names: tp,
  primaryName: ep,
  secondaryName: np,
  namesBold: sp,
  container: op,
  containerCheckable: rp
};
class ip extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(t) {
    const e = /* @__PURE__ */ new Set();
    typeof t.name == "string" && e.add(t.name), typeof t.name != "string" && typeof t.display_name == "string" && e.add(t.display_name), typeof t.phone_number == "string" && e.add(t.phone_number), typeof t.email == "string" && e.add(t.email);
    const n = Array.from(e);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(t) {
    return typeof t.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: t.icon, size: 16 }) : /* @__PURE__ */ s.jsx(Dr, { user: t });
  }
  renderContent() {
    const t = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, e = this.getAvatar(t), n = this.getNames(t), o = f(Kt.container, {
      [Kt.containerCheckable]: this.props.checkable
    }), r = f(Kt.names, {
      [Kt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      e,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Kt.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Kt.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const t = this.renderContent(), { checkable: e, ...n } = this.props;
    if (e) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Zs, { ...m, children: t });
    }
    const o = n, { item: r, disabled: a, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Kt.root, {
      [Kt.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: a,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          t,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class Yk extends D {
  render() {
    return /* @__PURE__ */ s.jsx(ip, { checkable: !0, ...this.props });
  }
}
const ap = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", lp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", cp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", dp = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", _n = {
  root: ap,
  rootActive: lp,
  suggestion: cp,
  icon: dp
};
class Qk extends ft {
  static defaultProps = {
    searchSuggestion: (t, e) => t.find((n) => n.name.toLowerCase() === e.toLowerCase()),
    renderSuggestion: (t) => `Add "${t}" tag`
  };
  constructor(t) {
    super(t), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(t) {
    const { searched: e, active: n } = this.props;
    e !== t.searched && this.searchItem(), n !== t.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: t, searched: e, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(t, e);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: t, onSuggest: e, clearSearch: n, triggerClose: o } = this.props;
    o?.(), e?.(t), n();
  }
  handleKeyDown(t) {
    this.props.active && t.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: t,
      triggerClose: e,
      onSuggest: n,
      searched: o,
      items: r,
      active: a,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(t, _n.root, {
      [_n.rootActive]: a
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": a,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: _n.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: _n.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const hp = "h-selectItems-deselectItem--deselectItem__root", up = "h-selectItems-deselectItem--deselectItem__rootDisabled", pp = "h-selectItems-deselectItem--deselectItem__name", mp = "h-selectItems-deselectItem--deselectItem__icon", Cn = {
  root: hp,
  rootDisabled: up,
  name: pp,
  icon: mp
};
class gp extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, ...r } = this.props, { name: a } = t, l = f(Cn.root, {
      [Cn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: Cn.name, children: a }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Cn.icon,
          onClick: () => {
            e(t);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const fp = "h-selectItems-tagDeselectItem--tagDeselectItem__root", bp = "h-selectItems-tagDeselectItem--tagDeselectItem__name", xp = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", yp = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", _p = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Ve = {
  root: fp,
  name: bp,
  icon: xp,
  dotContainer: yp,
  dot: _p
};
class Xk extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, isLoading: r, ...a } = this.props, { name: l, color: c } = t, d = f(Ve.root);
    return /* @__PURE__ */ s.jsxs("div", { ...a, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Ve.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Ve.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Ve.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Ve.icon,
          onClick: () => {
            e(t);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const Cp = "h-chip--chip__root", vp = "h-chip--chip__rootLight", wp = "h-chip--chip__rootNoBorder", Sp = "h-chip--chip__rootDisabled", Ip = "h-chip--chip__rootInteractable", Ke = {
  root: Cp,
  rootLight: vp,
  rootNoBorder: wp,
  rootDisabled: Sp,
  rootInteractable: Ip
}, Dp = ({
  className: i,
  children: t,
  onClick: e,
  light: n,
  noBorder: o,
  disabled: r,
  ...a
}) => {
  const l = f(
    {
      [Ke.root]: !0,
      [Ke.rootLight]: n,
      [Ke.rootNoBorder]: o,
      [Ke.rootDisabled]: r,
      [Ke.rootInteractable]: typeof e == "function" && !r
    },
    i
  ), c = typeof e == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(it, { ...a, as: c, className: l, onClick: e, children: t });
}, kp = "h-tag--tag__tagName", Tp = "h-tag--tag__tagNameTruncated", jp = "h-tag--tag__icon", Np = "h-tag--tag__deleteButton", Fp = "h-tag--tag__deleteButtonDisabled", Pp = "h-tag--tag__deleteIcon", be = {
  tagName: kp,
  tagNameTruncated: Tp,
  icon: jp,
  deleteButton: Np,
  deleteButtonDisabled: Fp,
  deleteIcon: Pp
}, je = ({
  className: i,
  tagNameClassName: t,
  children: e,
  onDelete: n,
  color: o,
  light: r,
  noBorder: a,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [be.tagName]: !0,
      [be.tagNameTruncated]: !l
    },
    t
  ), u = f(be.deleteButton, {
    [be.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    Dp,
    {
      ...d,
      className: i,
      light: r,
      noBorder: a,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: be.icon,
            style: { backgroundColor: sn(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: e }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: be.deleteIcon }) })
      ]
    }
  );
}, Rp = "h-select--select__root", Ep = "h-select--select__rootDisabled", Lp = "h-select--select__inputWrapper", Ap = "h-select--select__control", $p = "h-select--select__rootHasIcon", Op = "h-select--select__selection", Bp = "h-select--select__selectionItem", Wp = "h-select--select__tag", Hp = "h-select--select__tagName", Mp = "h-select--select__tagLimiter", zp = "h-select--select__text", Vp = "h-select--select__rootSearchable", Kp = "h-select--select__rootDropdownOpen", Up = "h-select--select__rootIsSearching", qp = "h-select--select__search", Gp = "h-select--select__rootSingle", Yp = "h-select--select__indicators", Qp = "h-select--select__spinner", Xp = "h-select--select__clearIndicator", Zp = "h-select--select__dropdownIndicator", Jp = "h-select--select__dropdown", tm = "h-select--select__dropdownFixed", em = "h-select--select__pagination", Y = {
  root: Rp,
  rootDisabled: Ep,
  inputWrapper: Lp,
  control: Ap,
  rootHasIcon: $p,
  selection: Op,
  selectionItem: Bp,
  tag: Wp,
  tagName: Hp,
  tagLimiter: Mp,
  text: zp,
  rootSearchable: Vp,
  rootDropdownOpen: Kp,
  rootIsSearching: Up,
  search: qp,
  rootSingle: Gp,
  indicators: Yp,
  spinner: Qp,
  clearIndicator: Xp,
  dropdownIndicator: Zp,
  dropdown: Jp,
  dropdownFixed: tm,
  pagination: em
};
class Ne extends D {
  static contextType = Yn;
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: _r("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: Hr,
    emptyComponent: pn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(t) {
    super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = W(), this.searchRef = W(), this.listRef = W();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !Ne.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), Ne.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if ((this.context ?? window)[n ? "addEventListener" : "removeEventListener"]("click", this.handleClickOutside), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    Cr(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && (this.context ?? window).removeEventListener(
      "click",
      this.handleClickOutside
    );
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, o = `${t}-dropdown`, r = e !== null ? `${o}-option-${e}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: o } = this.props;
    if (!e && !o && t.length) {
      const r = this.resolveItem(t[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      e?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return o?.(!e), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !e?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      if (t === null || t === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[t]?.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: a, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = t.key === "Escape", h = t.key === "Enter", u = t.key === "ArrowUp", p = t.key === "ArrowDown", m = t.key === "Backspace";
    if ((h || u || p) && t.preventDefault(), p && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (d && (n && t.stopPropagation(), this.handleDropdown("close")), m && a && !e) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(e), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: o } = this.props;
    if (e) {
      const r = this.isItemSelected(t);
      this.handleChange(t, !r);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: e ? [...o, t] : o.filter((r) => r.id !== t.id)
    }), this.resetSearch(), n?.(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, a = new RegExp(Vs(t), "i");
    return e.filter((c) => {
      const d = [];
      return t && !o && (r && typeof r == "function" ? d.push(r(c, t)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && a.test(u.toString().trim());
        })
      ) : d.push(a.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    return this.props.disabledItems?.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ s.jsx(H, { flexDirection: "column", children: e?.slice(t).map((n) => /* @__PURE__ */ s.jsxs(
        H,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(it, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    return this.props.renderSelection?.(t) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, o = t?.slice(0, e).map((r) => {
      const a = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: Y.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            je,
            {
              className: Y.tag,
              tagNameClassName: Y.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: a
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            je,
            {
              className: f(Y.tag, Y.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: Y.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: Y.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: a,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [Y.dropdown]: !0,
        [Y.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), C = x[e ?? -1] ?? null, _ = !x.length;
    return /* @__PURE__ */ s.jsxs(
      te,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          _ && typeof a == "function" && /* @__PURE__ */ s.jsx(
            a,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !_ && /* @__PURE__ */ s.jsx(
            Xs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: C,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: Y.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: a,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [Y.root]: !0,
        [Y.rootSingle]: !r,
        [Y.rootDisabled]: e,
        [Y.rootSearchable]: a,
        [Y.rootDropdownOpen]: m,
        [Y.rootIsSearching]: !!p,
        [Y.rootHasIcon]: !!h
      },
      t
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            At,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: e,
              className: Y.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: Y.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: Y.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: Y.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        Gn,
                        {
                          className: Y.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: Y.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: Y.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && m && this.renderDropdown()
        ]
      }
    );
  }
}
function nm(i) {
  return /* @__PURE__ */ s.jsx(
    Re,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(Ne, { ...i })
    }
  );
}
const sm = "h-datePicker-timezoneSelector--timezoneSelector__root", om = "h-datePicker-timezoneSelector--timezoneSelector__label", $o = {
  root: sm,
  label: om
}, Mr = ({
  disabled: i,
  tooltipProps: t,
  selectedTimezone: e,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = P((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), a = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${a(h)} ${h}`, c = G(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${a(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: $o.root, children: [
    /* @__PURE__ */ s.jsx(Qs, { className: $o.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(st, { ...t, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      nm,
      {
        disabled: i,
        items: c,
        onSelect: d,
        selectedItems: [
          Te(e) ? e : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, rm = "h-fieldAlert--fieldAlert__root", im = "h-fieldAlert--fieldAlert__alert", am = "h-fieldAlert--fieldAlert__icon", fs = {
  root: rm,
  alert: im,
  icon: am
}, lm = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", cm = {
  root: lm
};
function dm({
  className: i,
  variant: t = "tertiary",
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    X,
    {
      ...e,
      variant: t,
      className: f(i, cm.root)
    }
  );
}
const hm = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function es({
  children: i,
  className: t,
  ...e
}) {
  const n = e.variant || "title", o = f(fs.root, t), [r, a] = V(!1), l = hm[n], c = P(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      a(h < u);
    },
    [i]
  );
  return /* @__PURE__ */ s.jsxs(A.Input, { ...e, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: fs.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: fs.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(st, { content: i, children: i }) : i })
  ] });
}
es.Button = dm;
const vn = (i, t = 0) => {
  if (!i)
    return t;
  if (typeof i == "number")
    return i;
  const e = parseFloat(i);
  return isNaN(e) ? t : e;
}, um = "h-inputText-inputNumberArrows--inputNumberArrows__root", pm = "h-inputText-inputNumberArrows--inputNumberArrows__button", mm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", gm = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", fm = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", xe = {
  root: um,
  button: pm,
  buttonUp: mm,
  buttonDown: gm,
  spacer: fm
}, bm = 50, Oo = 300, xm = "inputNumberArrowsTestId";
class ym extends D {
  intervalId;
  timeoutId;
  constructor(t) {
    super(t), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const a = vn(r.value), l = vn(e, 1), c = vn(n, Number.MIN_SAFE_INTEGER), d = vn(o, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(a - l, c) : Math.min(a + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Oo
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Oo
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      bm
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const o = this.getNewValue(t), r = new Event("input", { bubbles: !0 }), a = Object.getPrototypeOf(e);
    Object.getOwnPropertyDescriptor(
      a,
      "value"
    )?.set?.call(e, o), e.dispatchEvent(r), e.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: xe.root, "data-testid": xm, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xe.button, xe.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: xe.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(xe.button, xe.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const _m = "h-inputText--inputText__rootReadOnly", Cm = "h-inputText--inputText__container", vm = "h-inputText--inputText__rootHasIcon", wm = "h-inputText--inputText__rootTypeNumber", Sm = "h-inputText--inputText__input", Ue = {
  rootReadOnly: _m,
  container: Cm,
  rootHasIcon: vm,
  rootTypeNumber: wm,
  input: Sm
}, Im = "inputText", Qt = $(function(t, e) {
  const n = q(null);
  Fe(e, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: a,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: C = !1,
    ..._
  } = t, S = f(o, {
    [Ue.rootTypeNumber]: l === "number",
    [Ue.rootHasIcon]: !!u,
    [Ue.rootReadOnly]: a
  });
  return /* @__PURE__ */ s.jsx(
    At,
    {
      className: S,
      status: p,
      disabled: r,
      active: C,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: Ue.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": Im,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ..._,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: a,
            className: Ue.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          ym,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: a
          }
        )
      ] })
    }
  );
}), Dm = "hmm A", km = (i, t) => {
  const e = `${i}`.padStart(2, "0"), n = `${t}`.padStart(2, "0");
  return `${e}:${n}`;
}, Bo = (i, t) => {
  const e = i.hours(), n = i.minutes();
  return {
    id: km(e, n),
    name: i.format(t)
  };
}, an = ({
  hasDropDownIndicator: i = !0,
  allowCustomTimeInput: t = !1,
  timeOptions: e,
  overrides: n,
  selectedItems: o,
  selectableHours: r = Fr,
  selectableMinutes: a = Pr,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = G(
    () => e || $r({
      hours: r,
      minutes: a,
      overrides: n,
      timeFormat: l
    }),
    [
      e,
      r,
      a,
      n,
      l
    ]
  ), C = G(() => {
    const v = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, Dm]
    );
    if (!v.isValid())
      return null;
    const w = v.hours(), I = v.minutes();
    if (!d || d(w, I))
      return Bo(v, l);
    const k = w <= 12, F = w + 12, O = d(F, I);
    return k && O ? Bo(j({ hours: F, minutes: I }), l) : null;
  }, [u, g]), _ = G(() => {
    if (!t)
      return x;
    const v = p ? x.filter(({ name: w }) => w !== C?.name) : x.filter(
      ({ name: w }) => w.startsWith(g) && w !== C?.name
    );
    if (!C)
      return v;
    const y = p !== C.id ? 0 : v.findIndex(
      (w) => j(w.id, [l]) > j(C.id, [l])
    );
    return v.splice(
      // If it's -1 then there was no later time, so add it to the end.
      y === -1 ? v.length : y,
      0,
      C
    ), v;
  }, [C, g, p, x]), S = P(
    (v) => {
      v?.id !== C?.id && b(""), c(v?.id || null), m(v?.id || null);
    },
    [C]
  );
  return Z(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    Ne,
    {
      searchable: !0,
      placeholder: Rr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: i,
      items: t ? _ : x,
      onChange: E,
      onClear: S,
      onSelect: S,
      ...t && { onSearch: b }
    }
  );
}, Tm = "h-timePicker-range--timeRangePicker__root", jm = "h-timePicker-range--timeRangePicker__timePickerFrom", Nm = "h-timePicker-range--timeRangePicker__timePickerTo", Fm = "h-timePicker-range--timeRangePicker__arrowContainer", Pm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", Rm = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", Em = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", oe = {
  root: Tm,
  timePickerFrom: jm,
  timePickerTo: Nm,
  arrowContainer: Fm,
  arrowContainerHasError: Pm,
  arrowContainerHasWarning: Rm,
  arrowContainerHasSuccess: Em
}, Lm = ({
  className: i,
  disabled: t,
  endTime: e,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: a = Fr,
  selectableMinutes: l = Pr,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: e || null
  }), x = G(
    () => $r({
      hours: a,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [a, l, o, u]
  ), C = G(() => {
    const y = x.map(
      ({ id: k }) => j(k, [u])
    ), w = j(m, [u]), I = m && y.findIndex(
      (k) => k > w
    ) || 0;
    return x.slice(I);
  }, [x, m, u]);
  Z(() => {
    const y = typeof d == "string", w = typeof d == "string";
    (y && d !== m || w && e !== g) && b((I) => ({
      ...I,
      ...y && { startTime: d },
      ...w && { endTime: e }
    }));
  });
  const _ = P(
    (y) => (w) => {
      b((I) => {
        const k = j(w, [u]), F = j(I.startTime, [u]), O = j(I.endTime, [u]), T = x.map(
          ({ id: nt }) => j(nt, [u])
        ), R = T.findIndex(
          (nt) => nt >= k
        ) || -1, B = y === "startTime" ? R : T.findIndex(
          (nt) => nt >= F
        ), U = y === "endTime" ? -1 : T.findIndex(
          (nt) => nt >= O
        ), ot = {
          ...I,
          [y]: w,
          ...I.endTime !== null && y !== "endTime" && B >= U && {
            endTime: x[R + 1]?.id || null
          }
        };
        return n(ot), ot;
      });
    },
    [n]
  ), S = P(
    (y, w) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const F = I.hours(), O = I.minutes();
      return F < y || F === y && O < w;
    },
    [m, u]
  ), v = (y) => r?.[y] || r || Rr(u);
  return /* @__PURE__ */ s.jsxs(it, { className: f(oe.root, i), children: [
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: oe.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: t,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: _("startTime"),
        placeholder: v("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      it,
      {
        className: f(oe.arrowContainer, {
          [oe.arrowContainerHasError]: c === "error",
          [oe.arrowContainerHasWarning]: c === "warning",
          [oe.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      an,
      {
        className: oe.timePickerTo,
        searchable: !0,
        disabled: t || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: C,
        onSelect: _("endTime"),
        placeholder: v("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: S
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Yt {
  constructor(t, e, n) {
    this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n, this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n;
  }
  static validationOK = { isValid: !0, error: null };
  isValidDate(t) {
    try {
      return this.dateParser(t).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(t) {
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: e, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(t);
    return o.isBefore(e, "day") ? {
      isValid: !1,
      error: `Date must be after ${e.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Yt.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && r.isAfter(a, "day") ? {
      isValid: !1,
      error: `From date must be before ${a.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Yt.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(t), a = this.dateParser(e);
    return a.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && a.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : a.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Yt.validationOK;
  }
  isTimeOrderValid({
    startDate: t,
    endDate: e
  }) {
    return !t || !e ? Yt.validationOK : t.isAfter(e) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Yt.validationOK;
  }
}
const Am = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", $m = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", Om = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", Bm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", Wm = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", Hm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", Mm = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Ut = {
  root: Am,
  rootPlacementTop: $m,
  rootPlacementTopWithTimezoneSelector: Om,
  rootPlacementBottom: Bm,
  fields: Wm,
  input: Hm,
  alert: Mm
};
Array(24).fill(0).map((i, t) => t);
class Js extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: this.props.startDate?.format(e) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(e) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Js.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Yt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e?.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e?.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = e !== "" && !r ? a : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: a } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = t !== "" && !r ? a : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, o, r, a, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(Qs, { children: t === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Qt,
        {
          className: Ut.input,
          placeholder: c.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: r,
          onChange: (C) => this.handleInputValueChange(C, t),
          onFocus: () => u(t),
          autoComplete: "off",
          status: a ? "error" : void 0,
          disabled: d,
          active: h === t
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: Ut.input, children: /* @__PURE__ */ s.jsx(
        st,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            an,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (C) => p(e, C)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ s.jsx(
      es,
      {
        className: Ut.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: a
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(Ut.root, {
      [Ut.rootPlacementTop]: u === "top",
      [Ut.rootPlacementTopWithTimezoneSelector]: u === "top" && a,
      [Ut.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Ut.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const zm = "dateRangePickerTestId";
class Vm extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const {
      startDate: e,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: a,
      focusedInput: l = "startDate"
    } = t;
    this.state = {
      startTime: e ? j(e).format(Rt) : null,
      endTime: n ? j(n).format(Rt) : null,
      timezone: Te(o) ? o : j.tz.guess(!0),
      presetKey: a?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  visibleCalendarMonthRef = W();
  updatePresetKey(t) {
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === e)?.key ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && Te(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? j(e, n) : j("0001-01-01"),
      maxDate: t ? j(t, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, o)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: a } = this.props, l = this.addTimezoneToDate(
      t.startDate,
      r
    ), c = this.addTimezoneToDate(
      t.endDate,
      r
    );
    let d = l?.clone().startOf(a) || null, h = c?.clone().endOf(a) || null, u = t.startDate?.clone().startOf(a) || null, p = t.endDate?.clone().endOf(a) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: t.startDate?.clone().startOf(a).format(Rt) ?? null,
          endTime: t.endDate?.clone().startOf(a).format(Rt) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(t.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: o } = t;
      this.onDatesChange({ startDate: e, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Te(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, a] = e.split(":");
    return !r || !a ? n === "startDate" ? t.clone().startOf(o) : t.clone().endOf(o) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(a, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !t.isBetween(n, o, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(t) || this.setState({
      startTime: n ? j(n).format(Rt) : null
    }), o?.isSame(e) || this.setState({
      endTime: o ? j(o).format(Rt) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (e && t && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !e) && !(!o && e)) {
      if (o && !e) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && e) {
        if (o.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: a } = this.state;
    if (!o)
      return null;
    const l = !!t || !!e, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Mr,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: a
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: a,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== t || !e && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: C, maxDate: _ } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Js,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: C,
        maxDate: _,
        disabled: a,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Wr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: o, endDate: r } = this.props, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": zm,
        className: f(ke.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              vr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Or,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Br,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Km = "h-datePicker-single-inputFields--datePickerInputFields__root", Um = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", qm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Gm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Ym = "h-datePicker-single-inputFields--datePickerInputFields__input", Qm = "h-datePicker-single-inputFields--datePickerInputFields__alert", re = {
  root: Km,
  rootPlacementTop: Um,
  rootPlacementTopWithTimezoneSelector: qm,
  rootPlacementBottom: Gm,
  input: Ym,
  alert: Qm
};
class to extends D {
  dateValidators;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: this.props.date?.format(e) ?? "",
      dateError: null
    }, this.instanceId = to.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Yt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  static instanceCount = 0;
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, o = j(e);
    if (!(e === t.date || o?.isSame(j(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Qt,
      {
        className: re.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: a,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !t && !r, d = !t || r;
    return /* @__PURE__ */ s.jsx(
      st,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: re.input, children: /* @__PURE__ */ s.jsx(
          an,
          {
            disabled: d,
            onSelect: a,
            selectedItems: e ? [e] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ s.jsx(
      es,
      {
        className: re.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = f(re.root, {
      [re.rootPlacementTop]: e === "top",
      [re.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [re.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Xm = "datePickerTestId";
class Zm extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const { date: e, timezone: n, presets: o, presetKey: r } = t;
    this.state = {
      time: e ? j(e).format(Rt) : null,
      timezone: Te(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: a }) => a === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = W();
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || j("0001-01-01"),
      maxDate: t || j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, a = this.addTimezoneToDate(t, o);
    let l = a?.clone().startOf(r) || null, c = t?.clone().startOf(r) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: t?.clone().startOf(r).format(Rt) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(a, n), c = this.addTimeToDate(t, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Te(e) ? j(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = e.split(":");
    return !o || !r ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(o, r, n);
  }
  updateTimeOnDateChange(t) {
    const { date: e } = this.props;
    t.date?.isSame(e) || this.setState({
      time: e ? j(e).format(Rt) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: t } = this.props, e = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const a = !!t, l = !a && !e, c = !a || e || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Mr,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: a,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== t || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      to,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: a,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: t,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Wr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, a = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Vn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Xm,
        className: f(ke.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(H, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              vr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Or,
                daySize: 32,
                renderNavPrevButton: a,
                renderNavNextButton: l,
                renderMonthElement: Br,
                initialVisibleMonth: () => o || j(),
                onFocusChange: E,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Jm = "h-dialer--dialer__dialer", tg = "h-dialer--dialer__number", eg = "h-dialer--dialer__letters", ng = "h-dialer--dialer__asterisk", Bn = {
  dialer: Jm,
  number: tg,
  letters: eg,
  asterisk: ng
}, sg = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Bn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class Zk extends D {
  render() {
    const { className: t, onInput: e, ...n } = this.props, o = f(Bn.dialer, t);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: sg.map((r) => /* @__PURE__ */ zi(
      "div",
      {
        className: f(Bn.number),
        ...Xn(() => e(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: Bn.letters, children: r.letters }) })
    )) });
  }
}
const og = "h-fieldWrapper--fieldWrapper__root", rg = "h-fieldWrapper--fieldWrapper__rootDisabled", ig = "h-fieldWrapper--fieldWrapper__label", ag = "h-fieldWrapper--fieldWrapper__alert", wn = {
  root: og,
  rootDisabled: rg,
  label: ig,
  alert: ag
}, lg = "fieldWrapper";
class z extends D {
  static hasStatus(t, e) {
    return t?.[e] ? t?.touched === void 0 || t.touched === !0 : !1;
  }
  static getStatusMessage(t, e) {
    if (this.hasStatus(t, e))
      return t?.[e];
  }
  static getStatus(t) {
    return z.hasStatus(t, "error") ? "error" : z.hasStatus(t, "warning") ? "warning" : z.hasStatus(t, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: t, description: e } = this.props;
    let n = e, o;
    return z.hasStatus(t, "error") ? (n = z.getStatusMessage(t, "error"), o = "error") : z.hasStatus(t, "warning") ? (n = z.getStatusMessage(t, "warning"), o = "warning") : z.hasStatus(t, "success") && (n = z.getStatusMessage(t, "success"), o = "success"), /* @__PURE__ */ s.jsx(es, { variant: o, className: wn.alert, children: n });
  }
  render() {
    const {
      className: t,
      labelFor: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      wn.root,
      {
        [wn.rootDisabled]: a
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": lg,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            Qs,
            {
              required: r,
              htmlFor: e,
              helpIcon: l,
              className: wn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ls extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Qt,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const cg = "h-dropdownSelect--dropdownSelectContainer__search", dg = "h-dropdownSelect--dropdownSelectContainer__pagination", hg = "h-dropdownSelect--dropdownSelectContainer__selectionActions", ug = "h-dropdownSelect--dropdownSelectContainer__extra", Sn = {
  search: cg,
  pagination: dg,
  selectionActions: hg,
  extra: ug
}, pg = "DROP_SEARCH_INPUT";
class zr extends ft {
  listRef;
  searchRef;
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, o = { ...e };
    return n || (o.searchValue = "", o.activeItemIndex = 0), o;
  }
  constructor(t) {
    super(t), this.state = {
      searchValue: "",
      activeItemIndex: 0
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.handleItemKeyDown = this.handleItemKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = W(), this.searchRef = W();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: pg,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { key: e } = t, { searchValue: n, activeItemIndex: o } = this.state, { triggerClose: r, items: a, disabledItems: l = [] } = this.props, c = a.map((h, u) => ({ item: h, index: u })).filter(({ item: h }) => !l.includes(h.id)).map(({ index: h }) => h), d = c.indexOf(o);
    if (e === "Escape")
      n === "" ? r() : this.clearSearch();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), c.length > 0) {
        const h = d < c.length - 1 ? d + 1 : 0;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), c.length > 0) {
        const h = d > 0 ? d - 1 : c.length - 1;
        this.setState(
          { activeItemIndex: c[h] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "Home")
      t.preventDefault(), c.length > 0 && this.setState(
        { activeItemIndex: c[0] },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "End")
      t.preventDefault(), c.length > 0 && this.setState(
        {
          activeItemIndex: c[c.length - 1]
        },
        () => this.listRef.current?.focusActiveItem()
      );
    else if (e === "Enter") {
      t.preventDefault();
      const h = a[o];
      if (h && !l.includes(h.id)) {
        const { onChange: u, selectedItems: p = [] } = this.props;
        if (u) {
          const m = p.some((g) => (typeof g == "object" ? g.id : g) === h.id);
          this.onChange(h, !m);
        } else
          this.onSelect(h);
      }
    }
  }
  handleItemKeyDown(t) {
    const { key: e } = t, { activeItemIndex: n } = this.state, { triggerClose: o, items: r, disabledItems: a = [] } = this.props, l = r.map((d, h) => ({ item: d, index: h })).filter(({ item: d }) => !a.includes(d.id)).map(({ index: d }) => d), c = l.indexOf(n);
    if (e === "Escape")
      o();
    else if (e === "ArrowDown") {
      if (t.preventDefault(), l.length > 0) {
        const d = c < l.length - 1 ? c + 1 : 0;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else if (e === "ArrowUp") {
      if (t.preventDefault(), l.length > 0) {
        const d = c > 0 ? c - 1 : l.length - 1;
        this.setState(
          { activeItemIndex: l[d] },
          () => this.listRef.current?.focusActiveItem()
        );
      }
    } else e === "Home" ? (t.preventDefault(), l.length > 0 && this.setState(
      { activeItemIndex: l[0] },
      () => this.listRef.current?.focusActiveItem()
    )) : e === "End" && (t.preventDefault(), l.length > 0 && this.setState(
      {
        activeItemIndex: l[l.length - 1]
      },
      () => this.listRef.current?.focusActiveItem()
    ));
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n,
      activeItemIndex: 0
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: o } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(t, e), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    const { hasSearch: t } = this.props;
    t ? this.focusSearch() : setTimeout(() => {
      this.listRef.current?.focusActiveItem();
    }, 0);
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: t } = this.props, { searchValue: e } = this.state;
    e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: a,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: C,
      dropdownOpen: _,
      emptyMessage: S,
      selectedItems: v,
      disabledItems: y,
      tooltipItems: w,
      activeItem: I,
      itemsDisplayCount: k,
      itemHeight: F,
      renderSuggestion: O,
      searchSuggestion: T,
      ...R
    } = this.props;
    if (!_)
      return null;
    const { searchValue: B, activeItemIndex: U } = this.state, ot = a.length === 0, nt = a[U] ?? I ?? a[0] ?? null, L = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...R, className: L, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: Sn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ls,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: Sn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: B,
            onSuggest: m,
            triggerClose: h ? void 0 : C,
            clearSearch: this.clearSearch,
            items: a,
            searchSuggestion: T,
            renderSuggestion: O
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !ot && /* @__PURE__ */ s.jsx(
          Xs,
          {
            ref: this.listRef,
            pagination: d,
            items: a,
            onSelect: this.onSelect,
            onChange: this.onChange,
            onKeyDown: this.handleItemKeyDown,
            clearSearch: this.clearSearch,
            selectedItems: v,
            disabledItems: y,
            itemComponent: e,
            tooltipItems: w,
            itemsDisplayCount: k,
            itemHeight: F,
            activeItem: nt
          }
        ),
        ot && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: S || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: Sn.selectionActions, children: /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          disabled: v?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: Sn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          X,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class eo extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: pn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: t,
      items: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: C,
      containerProps: _,
      pagination: S,
      emptyComponent: v,
      emptyMessage: y,
      selectedItems: w,
      disabledItems: I,
      tooltipItems: k,
      activeItem: F,
      itemsDisplayCount: O,
      itemHeight: T,
      optionComponent: R,
      renderSuggestion: B,
      searchSuggestion: U,
      ...ot
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      de,
      {
        ...ot,
        className: t,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: C,
        dropdown: /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ toggleDropdown: nt, dropdownOpen: L }) => /* @__PURE__ */ s.jsx(
          zr,
          {
            ..._,
            items: e,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: a,
            onClearText: l,
            onKeyDown: c,
            triggerClose: nt,
            dropdownOpen: L,
            pagination: S,
            emptyComponent: v,
            emptyMessage: y,
            selectedItems: w,
            disabledItems: I,
            tooltipItems: k,
            activeItem: F,
            itemsDisplayCount: O,
            itemHeight: T,
            optionComponent: R,
            renderSuggestion: B,
            searchSuggestion: U
          }
        ) }),
        children: b
      }
    );
  }
}
const mg = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", gg = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", fg = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", bs = {
  items: mg,
  moreItemsDropdown: gg,
  tagName: fg
};
class bg extends ft {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: pn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: t } = this.props;
    return t;
  }
  render() {
    const {
      items: t,
      itemComponent: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: a,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: C,
      ..._
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      eo,
      {
        ..._,
        containerProps: g,
        items: this.getItems(),
        itemComponent: e,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: a,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: C,
        children: b
      }
    );
  }
}
class Jk extends ft {
  static defaultProps = {
    MoreItemsItemComponent: gp,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(t) {
    super(t), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(t) {
    if (typeof t == "object")
      return t;
    const e = this.props.items.find((n) => n.id === t);
    return e || { id: _r(), name: "Unknown" };
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  isItemDisabled(t) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(t.id) >= 0 : !1;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !e || zs(e[t.id]) ? null : e[t.id];
  }
  getListItem(t, e) {
    const { onRemove: n } = this.props, o = this.resolveItem(t), r = this.getItemName(o), a = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      je,
      {
        className: bs.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return a ? /* @__PURE__ */ s.jsx(st, { ...a, children: l }, e) : l;
  }
  getListMoreItem(t) {
    const { MoreItemsItemComponent: e, onRemove: n } = this.props, o = this.resolveItem(t), r = this.getTooltip(o), a = /* @__PURE__ */ s.jsx(
      e,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: E,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(st, { ...r, children: a }, o.id) : a;
  }
  getPreviewItems() {
    const {
      selectedItems: t,
      previewItemsNumber: e,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], a = "";
    if (e && t) {
      if (t.length > 0 && t.length < e)
        o = t.map(this.getListItem);
      else if (t.length >= e) {
        const h = t.slice(0, e), u = t.slice(
          e,
          t.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), a = u.length.toString();
      }
    } else
      o = t.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(bs.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      e && t.length > e ? /* @__PURE__ */ s.jsxs(
        de,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            a,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: t,
      selectedItems: e,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: a,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: C,
      containerProps: _,
      moreItemsDropdownProps: S,
      MoreItemsItemComponent: v,
      hideSelectedItems: y,
      disabledItems: w,
      tooltipItems: I,
      optionComponent: k,
      ...F
    } = this.props, O = f(
      {
        [bs.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: O, children: [
      /* @__PURE__ */ s.jsx(
        bg,
        {
          items: t,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: a,
          pagination: b,
          emptyComponent: x,
          emptyMessage: C,
          containerProps: _,
          selectedItems: e,
          disabledItems: w,
          tooltipItems: I,
          optionComponent: k,
          ...F
        }
      ),
      !y && this.getPreviewItems()
    ] });
  }
}
const xg = "h-fieldButton--fieldButton__button", yg = {
  button: xg
}, tT = $(
  function({
    className: t,
    buttonClassName: e,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: a,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(e, yg.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: a,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          X,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), _g = "h-inputDatePicker--inputDatePicker__root", Cg = "h-inputDatePicker--inputDatePicker__inputContainer", vg = "h-inputDatePicker--inputDatePicker__input", wg = "h-inputDatePicker--inputDatePicker__rootReadOnly", Sg = "h-inputDatePicker--inputDatePicker__iconsContainer", Ig = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", Dg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", kg = "h-inputDatePicker--inputDatePicker__calendarIcon", Tg = "h-inputDatePicker--inputDatePicker__clearIcon", Ot = {
  root: _g,
  inputContainer: Cg,
  input: vg,
  rootReadOnly: wg,
  iconsContainer: Sg,
  rootHasClearIcon: Ig,
  rootHasWrapperIcon: Dg,
  calendarIcon: kg,
  clearIcon: Tg
}, jg = "inputDatePickerTestId";
class Ng extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(t) {
    super(t), this.inputRef = W(), this.rootRef = W(), this.datePickerContainerRef = W(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    Zn(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: a,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: C,
      ..._
    } = this.props, { isDropdownOpen: S } = this.state;
    return /* @__PURE__ */ s.jsx(
      At,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: S,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Ot.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ..._,
              id: e,
              name: e,
              className: Ot.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Hn(n) ? void 0 : n?.format(r) ?? "",
              onChange: Hn(n) ? void 0 : E,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Ot.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: Ot.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: Ot.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: a,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(te, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Zm,
      {
        disabled: a,
        ...r,
        dateFormat: c,
        date: t ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(Ot.root, t, {
      [Ot.rootHasClearIcon]: n && e,
      [Ot.rootHasWrapperIcon]: !!r,
      [Ot.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": jg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class eT extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      date: t?.date ? t.date.toISOString() : "",
      localDate: t?.localDate ? t.localDate.toISOString() : "",
      timezone: t?.timezone || "",
      localTimezone: t?.localTimezone || ""
    });
  }
  render() {
    const {
      className: t,
      input: { value: e, name: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          Ng,
          {
            name: n,
            value: Es(e?.localDate) ? j(e.localDate, j.ISO_8601) : null,
            timezone: e?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Fg = "h-inputDateRangePicker--inputDateRangePicker__root", Pg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", Rg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", Eg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", Lg = "h-inputDateRangePicker--inputDateRangePicker__input", Ag = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", $g = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", Og = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", Bg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", Wg = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", Hg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", Mg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", zg = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Vg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ut = {
  root: Fg,
  inputsContainer: Pg,
  arrowContainer: Rg,
  inputContainer: Eg,
  input: Lg,
  rootReadOnly: Ag,
  iconsContainer: $g,
  rootStartDateHasClearIcon: Og,
  startDateIconsContainer: Bg,
  rootEndDateHasClearIcon: Wg,
  endDateIconsContainer: Hg,
  rootHasWrapperIcon: Mg,
  calendarIcon: zg,
  clearIcon: Vg
}, Kg = "inputDateRangePickerTestId";
class ln extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(t) {
    super(t), this.inputsRef = {
      startDate: W(),
      endDate: W()
    }, this.rootRef = W(), this.dateRangePickerContainerRef = W(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || o !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: t } = this.state, e = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? e?.[0]?.focus() : e?.[1]?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    Ee(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    const { onChange: e, value: n } = this.props, { focusedInput: o } = this.state;
    typeof e == "function" && e(t), (n?.[o] ?? t[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: o, localTimezone: r } = this.props, a = {
      startDate: e === "startDate" ? null : n?.startDate ?? null,
      localStartDate: e === "startDate" ? null : n?.localStartDate ?? null,
      endDate: e === "endDate" ? null : n?.endDate ?? null,
      localEndDate: e === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(a);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    Zn(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: a } = this.state;
    return /* @__PURE__ */ s.jsx(
      At,
      {
        prefix: t,
        suffix: e,
        disabled: r,
        icon: n,
        active: a,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ut.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ut.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: a,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: C,
      status: _,
      suffix: S,
      tabIndex: v,
      timezone: y,
      value: w,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ut.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: ln.getInputName(m, t),
          name: ln.getInputName(m, t),
          className: ut.input,
          ref: this.inputsRef[t],
          onClick: (k) => this.handleInputClick(k, t),
          onFocus: (k) => this.handleInputFocus(k, t),
          onBlur: (k) => this.handleInputBlur(k),
          onKeyDown: (k) => this.handleInputKeydown(k, t),
          disabled: l,
          placeholder: b?.[t] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: w && j(w[t]).isValid() ? j(w[t]).format(this.dateFormat) : "",
          onChange: Hn(w) ? void 0 : E,
          tabIndex: e ?? v,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ut.iconsContainer, {
            [ut.startDateIconsContainer]: t === "startDate",
            [ut.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: o } = this.props;
    return !e || !n?.[t] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ut.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: a,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(te, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Vm,
      {
        disabled: a,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: t?.startDate ?? null,
        endDate: t?.endDate ?? null,
        timezone: o ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, a = f(ut.root, t, {
      [ut.rootStartDateHasClearIcon]: n && e?.startDate,
      [ut.rootEndDateHasClearIcon]: n && e?.endDate,
      [ut.rootHasWrapperIcon]: !!r,
      [ut.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Kg,
        ref: this.rootRef,
        className: a,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class nT extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      startDate: t?.startDate ? t.startDate.toISOString() : "",
      localStartDate: t?.localStartDate ? t.localStartDate.toISOString() : "",
      endDate: t?.endDate ? t.endDate.toISOString() : "",
      localEndDate: t?.localEndDate ? t.localEndDate.toISOString() : "",
      timezone: t?.timezone ?? "",
      localTimezone: t?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: t,
    localEndDate: e
  }) {
    const n = Es(t) ? j(t, j.ISO_8601) : null, o = Es(e) ? j(e, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: t,
      input: { name: e, value: n, onChange: o, ...r },
      label: a,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: a,
        labelFor: ln.getInputName(e, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          ln,
          {
            name: e,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const Ug = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format",
  "inlineCode",
  "blockquote"
], ce = (i) => Ri(i), no = (i, t = window) => t.getComputedStyle(i).display === "block", Xt = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
);
function xs(i, t) {
  const e = {
    ctrlKey: [
      "Control",
      ...Xt ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...Xt ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...Xt ? ["$metaOrCtrl"] : []]
  };
  return i.some((n) => {
    if (t.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(e).every(
      ([r, a]) => {
        const l = Ei(
          a,
          o
        ).length;
        return t[r] ? l > 0 : l === 0;
      }
    );
  });
}
const qg = (i, t, e) => {
  if (!i || t < 0 || e < 0) return !1;
  const n = i?.textContent?.length ?? 0;
  return !(t > n || e > n);
}, Gg = (i, t) => i.document.queryCommandState(t), Yg = (i) => i.document.queryCommandValue("formatBlock"), Qg = (i) => i.type.indexOf("image/") === 0, Wo = (i, t) => {
  const e = rn();
  return {
    src: (i.URL || i.webkitURL).createObjectURL(t),
    uid: e
  };
}, Xg = (i) => {
  i && i.querySelectorAll("td").forEach((t) => {
    t.style.border = "1px solid currentColor";
  });
}, As = (i) => {
  i.setAttribute("dir", "auto");
  const t = window.getComputedStyle(i).direction;
  i.setAttribute("dir", t);
}, Ho = (i) => {
  i && i.childNodes.forEach((t) => {
    t.nodeType !== Node.ELEMENT_NODE && t.nodeType !== Node.TEXT_NODE || ce(t) && no(t) && As(t);
  });
}, so = (i, t = !0) => {
  const e = document.createElement("div");
  return e.style.display = "none", e.innerHTML = i, document.body.appendChild(e), e.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (ce(n) && no(n))
        n.innerHTML = so(n.innerHTML, !1), As(n);
      else if (t) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), As(o);
      }
    }
  }), document.body.removeChild(e), e.innerHTML;
}, Mo = (i, t = { side: "both" }) => {
  const { side: e } = t, n = i.split(""), o = " ", r = "&nbsp;";
  let a = 0, l = n.length - 1;
  if (e === "both" || e === "start")
    for (; n[a] === o; )
      n[a++] = r;
  if (e === "both" || e === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Kn = (i, t) => i.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? Mo(e, { side: "end" }) : `<div>${Mo(e)}</div>` : "<br />").join("");
function Zg(i) {
  const t = "&nbsp;", o = Jg(i.anchorNode), r = tf(i.anchorNode);
  if (i.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(t)) {
    const { focusOffset: a, anchorOffset: l } = i, c = Array.prototype.indexOf.call(
      i.anchorNode.parentElement?.childNodes,
      i.anchorNode
    ), d = r.replaceAll(t, " ").replace(/.$/, " "), h = document.createTextNode(d);
    if (i.anchorNode.parentElement?.childNodes[c].replaceWith(h), i?.rangeCount && i?.rangeCount > 0 && qg(h, a, l)) {
      const u = i.getRangeAt(0);
      u.setStart(h, a), u.setEnd(h, l);
    }
  }
}
function Jg(i) {
  if (!i)
    return "";
  if (i instanceof Element)
    return i.innerHTML;
  const t = document.createElement("span");
  return t.appendChild(i.cloneNode()), t.innerHTML;
}
function tf(i) {
  return !i || !i.textContent ? "" : i.textContent;
}
const ef = "h-inputRichText-addonTrigger--addonTrigger__root", nf = {
  root: ef
};
function sf(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t) || null;
}
const In = (i, t) => {
  const e = Vr(i, t);
  return e && i.triggers.isAddonTrigger(e.matchedTrigger) ? e.matchedTrigger : null;
}, Dn = (i, t) => {
  const e = Vr(i, t);
  return e ? e.match : null;
}, Vr = (i, t) => t ? i.triggers.test(t) : null, zo = "input-rich-text-addon-trigger", of = (i, t) => {
  const e = i.selection.recreate({ focus: !1 });
  if (!e || !t) return null;
  const n = e.getRangeAt(0).getBoundingClientRect();
  return i.ref.current && n && e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0).getBoundingClientRect() : null;
}, rf = (i, t) => {
  if (i.ref.current && t) {
    const e = i.ref.current.getBoundingClientRect();
    return {
      left: `${t.x - e.x}px`,
      top: `${t.y - e.y}px`,
      height: "0",
      width: `${t.width}px`,
      position: "absolute"
    };
  }
  return {};
}, qt = (i) => sf(i.selection.recreate({ focus: !1 })) || "", ys = (i, t) => !!t && i.triggers.isAddonTrigger(t), _s = (i) => i?.nodeType === Node.ELEMENT_NODE, $s = (i, t) => i.dataset.testid === t ? i : i.parentElement ? $s(i.parentElement, t) : null, ye = {};
class af extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const Ie = new af(), lf = vt({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: Ie
});
var cf = /* @__PURE__ */ ((i) => (i.FOCUS = "focus", i.INSERT = "insert", i.UP = "up", i.DOWN = "down", i))(cf || {});
const df = (i) => {
  const { editor: t } = i, [e, n] = V(null), [o, r] = V(null), [a, l] = V(null), [c, d] = V(!1), h = rf(t, a), [u] = V(rn()), { dismissText: p } = ye[u] ?? { dismissText: "" }, m = e?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = P(() => {
    const w = In(t, qt(t)), I = Dn(t, qt(t)), k = of(t, w);
    ys(t, w) && w?.shouldHandleSelectionChange?.() !== !1 ? (r(w), n(I), l(k)) : (r(null), n(null), l(null)), d(!0);
  }, [t]), x = P(() => {
    const w = In(t, qt(t)), I = Dn(t, qt(t))?.[0];
    return ys(t, w) && !!I;
  }, [t]), C = P(() => {
    const w = In(t, qt(t)), I = Dn(t, qt(t))?.[0], k = ye[u]?.dismissText || "", F = k ? I?.startsWith(k) : !1;
    return ys(t, w) && !!I && !F;
  }, [t, u]), _ = P(() => {
    t.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: C,
        callback: () => {
          Ie.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: C,
        callback: (w, I) => {
          const k = Dn(t, qt(t))?.[0];
          if (!k) {
            ye[u] = {
              dismissText: ""
            };
            return;
          }
          In(t, qt(t))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), ye[u] = {
            dismissText: (k.trim().length === 1 ? "" : k) ?? ""
          };
        }
      }
    ]);
  }, [t, C, u]);
  Z(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (ye[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const S = P((w) => {
    const I = w.nativeEvent.relatedTarget, k = _s(I) && $s(I, Jr), F = _s(I) && $s(I, zo);
    (!_s(I) || !k && !F) && d(!1);
  }, []), v = P(
    (w, { inline: I } = {}) => {
      const k = t.selection.recreate();
      if (!k || !o)
        return;
      const O = !!k.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        so(
          Kn(w, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Kn(w, { inline: !0 })
      );
      k?.rangeCount && k?.rangeCount > 0 && t.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        k.getRangeAt(0).createContextualFragment(O),
        {
          getSelection: () => {
            const T = t.selection.recreate();
            if (!T)
              return null;
            const { focusOffset: R } = T, ot = o.trigger.exec(m)?.[1]?.length ?? 0, nt = m.length - ot;
            return T?.anchorNode && T.extend(
              T.anchorNode,
              R - nt
            ), T;
          }
        }
      );
    },
    [t, m, o]
  );
  if (Pe(() => {
    _(), t.selection.onUpdate(b), t.events.onBlur(S);
  }), Jt(() => {
    delete ye[u];
  }), !o || !c || !m || g)
    return null;
  const y = o.customContainer?.current || t.ref.current?.ownerDocument?.body || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(Li, { open: !0, children: [
    /* @__PURE__ */ s.jsx(Ai, {}),
    /* @__PURE__ */ s.jsx($i, { container: y, children: /* @__PURE__ */ s.jsx(
      Oi,
      {
        onOpenAutoFocus: (w) => w.preventDefault(),
        "data-testid": zo,
        className: nf.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? "start",
        children: /* @__PURE__ */ s.jsx(
          lf.Provider,
          {
            value: { matchText: m, insertContent: v, eventEmitter: Ie },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, hf = "h-inputRichText-toolbarButton--toolbarButton__root", uf = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", pf = "h-inputRichText-toolbarButton--toolbarButton__rootActive", mf = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", gf = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", _e = {
  root: hf,
  rootDisabled: uf,
  rootActive: pf,
  rootWithBadge: mf,
  rootWithText: gf
};
function Et({
  className: i,
  isActive: t,
  icon: e,
  disabled: n,
  showBadge: o,
  text: r,
  tooltip: a,
  tabIndex: l = -1,
  ...c
}) {
  const d = f(
    {
      [_e.root]: _e.root,
      [_e.rootActive]: t,
      [_e.rootDisabled]: n,
      [_e.rootWithBadge]: o,
      [_e.rootWithText]: r
    },
    i
  ), h = /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: l,
      type: "button",
      ...c,
      className: d,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: e }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
  return a ? /* @__PURE__ */ s.jsx(st, { content: a, side: "top", wrap: "none", children: h }) : h;
}
const ff = "h-inputRichText-attachmentButton--attachmentButton__dropzone", bf = "h-inputRichText-attachmentButton--attachmentButton__fileInput", xf = "h-inputRichText-attachmentButton--attachmentButton__dropdown", yf = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", kn = {
  dropzone: ff,
  fileInput: bf,
  dropdown: xf,
  dropzoneIcon: yf
};
let _f = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowAttachments: e } = this.props;
    !e || !t.dataTransfer?.types?.includes("Files") || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && e(t.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: a,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(t), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          h && /* @__PURE__ */ s.jsx(Mt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const Cf = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class vf extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(t) {
    super(t), this.fileInputRef = W(), this.unsubscribeAddAttachment = Qi;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.props.disabled || this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (t) => {
    t.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  handleFileChanged = (t) => {
    const { onAttachFiles: e, editorWindow: n } = this.props, o = t.target;
    o !== null && o instanceof n.HTMLInputElement && (e(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: kn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        _f,
        {
          className: kn.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: kn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: a,
      editorWindow: l,
      disabled: c,
      disabledTooltip: d,
      fixed: h,
      ...u
    } = this.props, p = /* @__PURE__ */ s.jsx(
      Et,
      {
        onMouseDown: this.preventDefault,
        icon: "paperclip",
        showBadge: e.length > 0,
        disabled: c,
        tooltip: "Insert attachment"
      }
    );
    return c ? /* @__PURE__ */ s.jsx(st, { content: d, disabled: !d, children: p }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: kn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        de,
        {
          ...u,
          className: t,
          noStyle: !0,
          fixed: h,
          ref: a,
          dropdown: this.renderDropdown(),
          children: p
        }
      )
    ] });
  }
}
const wf = "h-inputRichText-dropzone--dropzone__root", Sf = "h-inputRichText-dropzone--dropzone__inlineDropzone", If = "h-inputRichText-dropzone--dropzone__attachmentDropzone", Df = "h-inputRichText-dropzone--dropzone__rootDual", kf = "h-inputRichText-dropzone--dropzone__icon", Ce = {
  root: wf,
  inlineDropzone: Sf,
  attachmentDropzone: If,
  rootDual: Df,
  icon: kf
};
class Tf extends D {
  static displayName = "InputRichTextDropzone";
  internalDrag = !1;
  constructor(t) {
    super(t), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragStart = () => {
    this.internalDrag = !0;
  };
  handleDragEnd = () => {
    this.internalDrag = !1;
  };
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowInlineAttachments: e, allowAttachments: n } = this.props;
    if (!e && !n || this.internalDrag) return;
    const o = t.dataTransfer?.types, r = o?.includes("Files"), a = o?.includes("text/uri-list");
    !r && !a || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  async fetchDroppedUrl(t, e) {
    if (t.files.length > 0) {
      e(t.files);
      return;
    }
    const n = t.getData("text/uri-list");
    if (n) {
      try {
        const o = new URL(n);
        if (o.protocol !== "http:" && o.protocol !== "https:") return;
      } catch {
        return;
      }
      try {
        const o = await fetch(n);
        if (!o.ok) return;
        const r = await o.blob(), a = n.split("/").pop()?.split("?")[0] || "dropped-image", l = new File([r], a, { type: r.type }), c = new DataTransfer();
        c.items.add(l), e(c.files);
      } catch {
      }
    }
  }
  handleInlineDrop = (t) => {
    t.preventDefault();
    const { onAddInline: e } = this.props;
    t.dataTransfer && typeof e == "function" && this.fetchDroppedUrl(t.dataTransfer, e), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && typeof e == "function" && this.fetchDroppedUrl(t.dataTransfer, e), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: a,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [Ce.root]: !0,
        [Ce.rootDual]: n && o
      },
      t
    ), m = n || o, g = {};
    return a && (g.onClick = a), m && (g.onDragStart = this.handleDragStart, g.onDragEnd = this.handleDragEnd, g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          e,
          (h || u) && /* @__PURE__ */ s.jsxs(Mt, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: Ce.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: Ce.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: Ce.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: Ce.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Kr = (i, t) => i.split(new RegExp(`(${Vs(t)})`, "gi")).map(
  (e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: e }, n) : e
), jf = "h-inputRichText-emoji--emoji__root", Nf = "h-inputRichText-emoji--emoji__decorator", Ff = "h-inputRichText-emoji--emoji__suggestion", Pf = "h-inputRichText-emoji--emoji__suggestionActive", Rf = "h-inputRichText-emoji--emoji__suggestionName", nn = {
  root: jf,
  decorator: Nf,
  suggestion: Ff,
  suggestionActive: Pf,
  suggestionName: Rf
}, Ef = Vi(
  () => import("./emoji-BzNvonBo.js").then((i) => i.c).then((i) => ({
    default: i.EmojiPicker
  }))
), Un = {};
Hi.emojis.forEach((i) => {
  i.forEach(
    (t) => {
      t.shortNames && t.shortNames.forEach((e) => {
        Un[e.replace(/:/g, "")] = t.emoji;
      });
    }
  );
});
const Lf = (i) => {
  const { active: t, item: e, match: n, onSelect: o } = i, r = n ? Kr(e, n) : e;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(e),
      type: "button",
      "aria-current": t,
      className: f(nn.suggestion, {
        [nn.suggestionActive]: t
      }),
      children: [
        Un[e],
        /* @__PURE__ */ s.jsx("span", { className: nn.suggestionName, children: r })
      ]
    }
  );
};
class Af extends D {
  constructor(t) {
    super(t), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: Lf,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(Un[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(nn.decorator), r.innerHTML = t, o.content.insert(r, {
      getSelection: () => {
        const a = o.selection.recreate();
        return e && a?.anchorNode && a.extend(a.anchorNode, n), a;
      }
    });
  }
  getSuggestions = (t) => Object.keys(Un).filter((n) => n.indexOf(t) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Ki, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ s.jsx(
    Ef,
    {
      onSelect: (e) => {
        this.insertEmoji(e), t();
      }
    }
  ) }) });
  render() {
    const { className: t, fixed: e } = this.props, n = f(
      {
        [nn.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: n, children: /* @__PURE__ */ s.jsx(
      de,
      {
        icon: "smile",
        dropdown: this.renderDropdown(),
        noStyle: !0,
        fixed: e,
        children: /* @__PURE__ */ s.jsx(
          Et,
          {
            icon: "smile",
            tooltip: "Emojis",
            onMouseDown: this.preventDefault
          }
        )
      }
    ) });
  }
}
const $f = "h-inputRichText--inputRichText__inputWrapper", Of = "h-inputRichText--inputRichText__root", Bf = "h-inputRichText--inputRichText__toolbar", Wf = "h-inputRichText--inputRichText__toolbarHint", Hf = "h-inputRichText--inputRichText__toolbarHintVisible", Mf = "h-inputRichText--inputRichText__toolbarHintHidden", zf = "h-inputRichText--inputRichText__editorWrap", Vf = "h-inputRichText--inputRichText__placeholder", Kf = "h-inputRichText--inputRichText__editor", Uf = "h-inputRichText--inputRichText__editorDisabled", qf = "h-inputRichText--inputRichText__fileInput", Gf = "h-inputRichText--inputRichText__uiBlocker", bt = {
  inputWrapper: $f,
  root: Of,
  toolbar: Bf,
  toolbarHint: Wf,
  toolbarHintVisible: Hf,
  toolbarHintHidden: Mf,
  editorWrap: zf,
  placeholder: Vf,
  editor: Kf,
  editorDisabled: Uf,
  fileInput: qf,
  uiBlocker: Gf
};
function Ur(i, t) {
  const e = (n) => n.replace(/&/g, "&amp;");
  return `<a href="${e(i)}">${e(t)}</a>`;
}
function oo(i) {
  if (!i || i.length === 0)
    return "";
  const [t = [], e = ""] = i[0];
  if (!e)
    return "";
  const n = t.map((r) => Yf(r)).filter(Boolean), o = Qf(e);
  return Xt ? [...n, o].join("") : [...n, o].join("+");
}
function Yf(i) {
  if (Xt)
    switch (i) {
      case "$metaOrCtrl":
      case "Meta":
        return "⌘";
      case "Control":
      case "$controlOrAlt":
        return "⌃";
      case "Shift":
        return "⇧";
      case "Alt":
        return "⌥";
      default:
        return i;
    }
  switch (i) {
    case "$metaOrCtrl":
    case "Control":
      return "Ctrl";
    case "$controlOrAlt":
    case "Alt":
      return "Alt";
    case "Shift":
      return "Shift";
    case "Meta":
      return "Win";
    default:
      return i;
  }
}
function Qf(i) {
  if (i.startsWith("Key"))
    return i.slice(3);
  if (i.startsWith("Digit"))
    return i.slice(5);
  switch (i) {
    case "Backslash":
      return "\\";
    case "Slash":
      return "/";
    case "Enter":
      return Xt ? "↵" : "Enter";
    case "Escape":
      return "Esc";
    case "Space":
      return "Space";
    case "Backspace":
      return Xt ? "⌫" : "Backspace";
    case "Delete":
      return Xt ? "⌦" : "Del";
    case "ArrowUp":
      return "↑";
    case "ArrowDown":
      return "↓";
    case "ArrowLeft":
      return "←";
    case "ArrowRight":
      return "→";
    default:
      return i;
  }
}
const Xf = "h-inputRichText-linkButton--linkButton__linkOpener", Zf = "h-inputRichText-linkButton--linkButton__dropdownContainer", Vo = {
  linkOpener: Xf,
  dropdownContainer: Zf
}, Jf = "h-inputRichText-linkButton--linkMenu__root", tb = "h-inputRichText-linkButton--linkMenu__field", Cs = {
  root: Jf,
  field: tb
};
class eb extends D {
  constructor(t) {
    super(t);
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  handleTextChange = (t) => {
    t && this.setState({
      textValue: t.target.value
    });
  };
  handleUrlChange = (t) => {
    t && this.setState({
      urlValue: t.target.value
    });
  };
  handleAddLink = (t) => {
    t?.preventDefault();
    const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    r && (e(o || void 0, r), n());
  };
  handleUnlink = (t) => {
    t.preventDefault();
    const { onUnlink: e, toggleDropdown: n } = this.props;
    e(), n();
  };
  handleKeyDown = (t) => {
    t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: a,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [Cs.root]: !0 }, t);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ls,
        {
          label: "Link title",
          noAlert: !0,
          className: Cs.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ls,
        {
          label: "Link URL",
          noAlert: !0,
          className: Cs.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(H, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(X, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(X, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const qr = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: [[["$metaOrCtrl", "Shift"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (i) => i.command.run("unlink")
  }
], nb = ({ editor: i }) => {
  const [t, e] = Ui((_) => _ + 1, 0), [n, o] = qi(!1), r = q(null), a = q(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Gi({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Pe(() => {
    i.events.onMouseOver((_) => {
      m(_);
    }), a.current = i.events.subscribe("hyperlink", () => {
      o(!0);
    }), i.selection.onUpdate(() => {
      p();
    });
  }), Jt(() => {
    a.current?.();
  });
  const p = () => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: S, focusNode: v } = _;
    if (S && v === S && S.parentElement?.nodeName === "A") {
      const { href: y, innerText: w } = S.parentElement;
      u({
        selectedLink: y,
        selectedText: w
      });
    } else
      u({
        selectedLink: "",
        selectedText: _.toString()
      });
  }, m = P(
    (_) => {
      const { target: S } = _, { current: v } = i.ref;
      if (v && S && S instanceof HTMLAnchorElement) {
        const y = v.getBoundingClientRect(), w = S.getBoundingClientRect();
        u({
          hoverLinkHref: S.getAttribute("href"),
          hoverLinkBounds: {
            top: w.top - y.top,
            left: w.left - y.left,
            width: w.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [i.ref, u]
  ), g = P(() => {
    const _ = i.selection.recreate();
    if (!_)
      return;
    const { anchorNode: S, focusNode: v } = _;
    if (S && S === v && S.parentElement?.nodeName === "A") {
      const y = document.createRange();
      y.selectNodeContents(S.parentElement), _.removeAllRanges(), _.addRange(y);
    }
  }, [i.selection]), b = P(
    (_, S) => {
      S && (g(), i.command.run("insertHTML", Ur(S, _ || S)), e());
    },
    [i.command, g]
  ), x = P(() => {
    g(), i.command.run("unlink");
  }, [i.command, g]), C = P((_) => {
    _.preventDefault();
  }, []);
  return Ir(r, () => {
    o(!1);
  }), Sr("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Mt, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Vo.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Et,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: C,
          onClick: () => o(),
          tooltip: `Insert link (${oo(qr[0].keybindings)})`
        }
      ),
      n && /* @__PURE__ */ s.jsx(te, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        eb,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Vo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, sb = "h-tabs--tabs__root", ob = "h-tabs--tabs__tabs", rb = "h-tabs--tabs__tab", ib = "h-tabs--tabs__tabTop", ab = "h-tabs--tabs__tabTopActive", lb = "h-tabs--tabs__tabTopSelected", cb = "h-tabs--tabs__tabLeft", db = "h-tabs--tabs__tabLeftActive", hb = "h-tabs--tabs__tabLeftSelected", ub = "h-tabs--tabs__tabBottom", pb = "h-tabs--tabs__tabBottomActive", mb = "h-tabs--tabs__tabBottomSelected", gb = "h-tabs--tabs__tabRight", fb = "h-tabs--tabs__tabRightActive", bb = "h-tabs--tabs__tabRightSelected", xb = "h-tabs--tabs__tabDisabled", rt = {
  root: sb,
  tabs: ob,
  tab: rb,
  tabTop: ib,
  tabTopActive: ab,
  tabTopSelected: lb,
  tabLeft: cb,
  tabLeftActive: db,
  tabLeftSelected: hb,
  tabBottom: ub,
  tabBottomActive: pb,
  tabBottomSelected: mb,
  tabRight: gb,
  tabRightActive: fb,
  tabRightSelected: bb,
  tabDisabled: xb
}, yb = 13;
class _b extends D {
  constructor(t) {
    super(t), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: t, onChange: e, disabled: n } = this.props;
    n || e(t);
  }
  handleOnKeyDown(t) {
    t.keyCode === yb && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: t,
      placement: e,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: a
    } = this.props;
    let l = f(rt.tab, n, {
      [rt.tabDisabled]: o,
      [rt.tabTop]: e === "top",
      [rt.tabRight]: e === "right",
      [rt.tabLeft]: e === "left",
      [rt.tabBottom]: e === "bottom",
      [rt.tabTopSelected]: e === "top" && t,
      [rt.tabRightSelected]: e === "right" && t,
      [rt.tabLeftSelected]: e === "left" && t,
      [rt.tabBottomSelected]: e === "bottom" && t,
      [rt.tabTopActive]: e === "top" && r,
      [rt.tabRightActive]: e === "right" && r,
      [rt.tabLeftActive]: e === "left" && r,
      [rt.tabBottomActive]: e === "bottom" && r
    });
    return a && (l = f(l, { [a]: t })), l;
  }
  render() {
    const { id: t, label: e, icon: n, disabled: o, slotEnd: r, slotStart: a } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          a || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          e,
          r
        ]
      },
      t
    );
  }
}
class ro extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.containerRef = W(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: a
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      _b,
      {
        selected: t === l,
        className: u,
        selectedClassName: p,
        id: t,
        label: e,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: t === c,
        slotEnd: r,
        slotStart: a
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: a,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(rt.root, t);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: rt.tabs, children: this.renderTabs() }) });
  }
}
const Cb = dn(ro, {
  fallback: null
}), vb = "h-inputRichText-quickResponseSelector--quickResponseItem__root", wb = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Sb = "h-inputRichText-quickResponseSelector--quickResponseItem__name", qe = {
  root: vb,
  rootActive: wb,
  name: Sb
};
class vs extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: t, onSelect: e, item: n } = this.props;
    t || e(n);
  }
  render() {
    const {
      className: t,
      item: e,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: a,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && e ? e : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [qe.root]: qe.root,
        [qe.rootActive]: r
      },
      t
    ), m = u ? Kr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", className: qe.name, children: m }),
          /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "4", className: qe.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const Ib = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", Db = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", kb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", Tb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", jb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", Nb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", ve = {
  container: Ib,
  dropdownButtonContainer: Db,
  tabbedDropdown: kb,
  tabbedDropdownTabs: Tb,
  tabbedDropdownTabsContent: jb,
  regularDropdown: Nb
}, Ko = /(^|\s)=/, ws = "Quick responses";
class Fb extends ft {
  constructor(t) {
    super(t), this.state = {
      searchTerm: "",
      selectedTab: t.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Ko,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: vs,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  handleSelect = (t, e) => {
    this.insertContent(t)?.then(() => {
      e && e();
    });
  };
  insertContent = (t, e, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: a } = this.props;
    return o(t).then((l) => {
      const c = a.selection.recreate();
      if (!c)
        return;
      const d = !!e, h = d && !!c.anchorNode?.textContent?.match(
        `^${Ko.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = so(
        Kn(r(l), { inline: !1 })
      ) : u = Kn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && a.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = a.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(t) {
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: t, locale: e }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Et,
      {
        icon: this.props.iconName ?? "bolt",
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(st, { content: `${ws} (=)`, children: /* @__PURE__ */ s.jsx(
      eo,
      {
        className: t,
        dropdownProps: {
          className: ve.regularDropdown
        },
        containerProps: { className: ve.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: vs,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    ) });
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: ve.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(st, { content: `${ws} (=)`, children: /* @__PURE__ */ s.jsx(
      de,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: ws },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: ve.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            ro,
            {
              className: ve.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: ve.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) }) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      zr,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: vs,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: pn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const Pb = "h-inputRichText-formatSelector--formatSelector__root", Rb = "h-inputRichText-formatSelector--formatSelector__list", Eb = "h-inputRichText-formatSelector--formatSelector__selector", Lb = "h-inputRichText-formatSelector--formatSelector__option", Ab = "h-inputRichText-formatSelector--formatSelector__optionActive", $b = "h-inputRichText-formatSelector--formatSelector__button", we = {
  root: Pb,
  list: Rb,
  selector: Eb,
  option: Lb,
  optionActive: Ab,
  button: $b
}, Os = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "div"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H1>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H2>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H3>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H4>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<H5>"),
    condition: (i) => i.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (i) => i.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (i) => i.allowFormatting.includes("format")
  }
], Uo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class Ob extends D {
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ s.jsx(un.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ s.jsx("ul", { className: we.list, children: Os.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(t)))
        return;
      const a = Uo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(we.option, {
            [we.optionActive]: this.isActiveFormat(a)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: we.button,
              onClick: () => {
                n.callback?.(t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Os.find(
      (t) => this.isActiveFormat(Uo[t.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...o } = this.props, r = f(we.root, t);
    return /* @__PURE__ */ s.jsx(
      de,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: we.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const Bb = "h-inputRichText-stylingMenu--stylingMenu__menu", Wb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", qo = {
  menu: Bb,
  buttonsContainer: Wb
}, Gr = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (i) => i.command.run("bold"),
    condition: (i) => i.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (i) => i.command.run("italic"),
    condition: (i) => i.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: [[["Control", "$controlOrAlt"], "Digit7"]],
    callback: (i) => i.command.run("insertOrderedList"),
    condition: (i) => i.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: [[["Control", "$controlOrAlt"], "Digit8"]],
    callback: (i) => i.command.run("insertUnorderedList"),
    condition: (i) => i.allowFormatting.includes("unorderedList")
  },
  {
    name: "inlineCode",
    label: "Inline code",
    icon: "code",
    keybindings: [[["$metaOrCtrl"], "KeyE"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyE"]],
    callback: (i) => i.command.run("inlineCode"),
    condition: (i) => i.allowFormatting.includes("inlineCode")
  },
  {
    name: "blockquote",
    label: "Quote text",
    icon: "quote",
    keybindings: [[["Control", "$controlOrAlt"], "Digit9"]],
    callback: (i) => {
      const t = i.window.getSelection();
      if (!t) return;
      const e = t.anchorNode, o = !!(ce(e) ? e : e?.parentElement)?.closest("blockquote");
      i.command.run("formatBlock", o ? "div" : "<BLOCKQUOTE>");
    },
    condition: (i) => i.allowFormatting.includes("blockquote")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [[["$metaOrCtrl"], "Backslash"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "Backslash"]],
    callback: (i) => i.command.run("removeFormat")
  }
], Yr = [...Os, ...Gr];
class Hb extends D {
  domRef;
  constructor(t) {
    super(t), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = W(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== e.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: Yg(t)
    });
  }
  handleClickOutside = (t) => {
    const { current: e } = this.domRef;
    e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (t) => {
    t.preventDefault();
    const { isOpen: e } = this.state;
    this.setState({
      isOpen: !e
    });
  };
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      e.preventDefault(), t && (Yr.find(
        (r) => r.name === t
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    if (t === "blockquote") {
      const n = e.window.getSelection();
      if (!n) return !1;
      const o = n.anchorNode;
      return !!(ce(o) ? o : o?.parentElement)?.closest("blockquote");
    }
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: o, ...r } = this.props, { isOpen: a, currentFormat: l } = this.state, c = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      a && /* @__PURE__ */ s.jsxs("div", { className: qo.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          Ob,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: qo.buttonsContainer, children: Gr.map((d) => {
          const h = "condition" in d;
          if (!(!h || h && d.condition(n)))
            return;
          const p = oo(d.keybindings), m = p ? `${d.label} (${p})` : d.label;
          return /* @__PURE__ */ s.jsx(
            Et,
            {
              isActive: this.styleActive(d.name),
              onMouseDown: this.handleToolbarButtonClick(d.name),
              icon: d.icon,
              tooltip: m
            },
            d.name
          );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Et,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick,
          tooltip: "Formatting"
        }
      )
    ] });
  }
}
const Mb = "h-inputRichText-suggestions--suggestions__dropdown", zb = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", Vb = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", Kb = "h-inputRichText-suggestions--suggestions__dropdownTabs", Ub = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", Ge = {
  dropdown: Mb,
  dropdownWithTabs: zb,
  dropdownWithoutTabs: Vb,
  dropdownTabs: Kb,
  dropdownTabsContent: Ub
};
function qb(i) {
  if (!i)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = i;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t);
}
class Gb extends D {
  dropdownRef;
  tabsRef;
  constructor(t) {
    super(t), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = W(), this.tabsRef = W(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), o !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[e];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!t?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? t?.getTabs?.().findIndex((n) => n.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return t < 0 ? o = e > 0 ? e - 1 : n.length - 1 : o = (e + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : o.length - 1 : r = (e + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, a = qb(n.selection.recreate({ focus: !1 }));
    if (a) {
      const l = n.triggers.test(a);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (t ? p = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : o ? t = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], t, e)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: a, anchorNode: l } = r;
          if (l) {
            if (a - t >= 0)
              try {
                r.extend(l, a - t);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                e(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(t[0].length, (r) => {
      const a = o.selection.recreate();
      if (!a)
        return;
      const { focusOffset: l } = a, h = new RegExp(e.trigger).exec(t[0])?.[1]?.length ?? 0, u = t[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, r = e.listRef.current.children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
        a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, r = e.containerRef.current.children[0].children[t].getBoundingClientRect(), a = n.getBoundingClientRect();
      a.bottom < r.bottom ? n.scrollTop += r.bottom - a.bottom : a.top > r.top && (n.scrollTop -= a.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!t || !t[e] || !o))
      return o.insertContent(
        t[e],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => e.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(pn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: o } = this.state, r = e?.getTabs?.() ?? [], a = !!t?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        ro,
        {
          ref: this.tabsRef,
          className: Ge.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Ge.dropdownTabsContent, children: a ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Xs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? t?.[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !n?.length || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(Ge.dropdown, {
      [Ge.dropdownWithTabs]: this.hasTabs(),
      [Ge.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(te, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function Yb({ children: i, className: t }) {
  const e = q(null), [n, o] = V(0), r = () => e.current ? Array.from(
    e.current.querySelectorAll("button:not([disabled])")
  ).filter((l) => l.closest('[role="toolbar"]') === e.current) : [];
  Z(() => {
    const l = r();
    l.length !== 0 && l.forEach((c, d) => {
      d === 0 ? c.setAttribute("tabindex", "0") : c.setAttribute("tabindex", n === d ? "0" : "-1");
    });
  }, [n]);
  const a = (l) => {
    const c = r();
    if (c.length === 0) return;
    const d = document.activeElement;
    if (!e.current?.contains(d)) return;
    let h = n;
    switch (l.key) {
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), l.stopPropagation(), h = h <= 0 ? c.length - 1 : h - 1, o(h), c[h]?.focus();
        break;
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), l.stopPropagation(), h = h >= c.length - 1 ? 0 : h + 1, o(h), c[h]?.focus();
        break;
      case "Home":
        l.preventDefault(), l.stopPropagation(), o(0), c[0]?.focus();
        break;
      case "End":
        l.preventDefault(), l.stopPropagation();
        const u = c.length - 1;
        o(u), c[u]?.focus();
        break;
    }
  };
  return Z(() => {
    const l = e.current;
    if (!l) return;
    const c = (h) => {
      const u = r(), p = h.target, m = u.indexOf(p);
      m !== -1 && o(m);
    }, d = (h) => {
      l.contains(h.relatedTarget) || o(0);
    };
    return l.addEventListener("focusin", c), l.addEventListener("focusout", d), () => {
      l.removeEventListener("focusin", c), l.removeEventListener("focusout", d);
    };
  }, []), /* @__PURE__ */ s.jsx(
    "div",
    {
      ref: e,
      className: t,
      role: "toolbar",
      "aria-label": "Text formatting",
      onKeyDown: a,
      children: i
    }
  );
}
function Go(i) {
  return i instanceof RegExp ? i.source : i;
}
function Qb(i) {
  return i.replace(/\(/g, "(?:");
}
class Qr {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (t) => `(?!${Go(t.trigger)})`
    ).join("");
  }
  add(t) {
    this.storedTriggers.push(t);
  }
  update(t) {
    const e = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === t.id
    );
    e !== -1 && (this.storedTriggers[e] = t);
  }
  test(t) {
    let e;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: a, minChars: l } = o, c = Qb(
        Go(r)
      ), d = this.excludeTriggersRegex, h = a ? "." : "\\S";
      if (e = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(t), e && (!l || e[1].length >= l))
        return {
          match: e,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(t) {
    return "getSuggestions" in t;
  }
  isAddonTrigger(t) {
    return !this.isSuggestionTrigger(t);
  }
}
function Xr(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return !1;
  let n = e.anchorNode;
  const o = "CODE";
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE && n.tagName === o)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Xb(i, t) {
  t?.();
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  const n = e.getRangeAt(0);
  if (Xr(i)) {
    Zb(i, "CODE");
    return;
  }
  const o = n.collapsed, r = i.document.createElement("code");
  if (o) {
    const a = i.document.createTextNode("​");
    r.appendChild(a), n.insertNode(r), n.setStart(r.firstChild, 1), n.setEnd(r.firstChild, 1);
  } else {
    const a = n.extractContents();
    r.appendChild(a), n.insertNode(r), n.setStartAfter(r), n.setEndAfter(r);
  }
  e.removeAllRanges(), e.addRange(n);
}
function Zb(i, t) {
  const e = i.getSelection();
  if (!e || e.rangeCount === 0) return;
  let n = e.anchorNode;
  for (; n; ) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      const o = n;
      if (o.tagName === t) {
        const r = o.parentNode;
        if (r) {
          const a = i.document.createDocumentFragment();
          for (; o.firstChild; )
            a.appendChild(o.firstChild);
          r.replaceChild(a, o);
          const l = i.document.createRange();
          l.selectNodeContents(r), l.collapse(!1), e.removeAllRanges(), e.addRange(l);
        }
        return;
      }
    }
    n = n.parentNode;
  }
}
const Tn = 25;
let kt = null, le = null;
function Jb(i, t) {
  const e = t.document.createElement("div");
  return e.className = `image-resize-handle image-resize-handle-${i}`, e.dataset.handle = i, e;
}
function tx(i, t) {
  const e = t.document.createElement("div");
  return e.className = "image-resize-wrapper", e.contentEditable = "false", i.parentNode?.insertBefore(e, i), e.appendChild(i), ["nw", "ne", "se", "sw"].forEach((o) => {
    const r = Jb(o, t);
    e.appendChild(r);
  }), e;
}
function Zr(i) {
  const t = i.querySelector("img");
  t && i.parentNode && (i.parentNode.insertBefore(t, i), i.remove());
}
function ex(i, t, e) {
  const { startX: n, startWidth: o, handle: r, aspectRatio: a } = i, l = t - n;
  let c = o;
  switch (r) {
    case "se":
    case "ne":
      c = o + l;
      break;
    case "sw":
    case "nw":
      c = o - l;
      break;
  }
  let d = c / a;
  c < Tn && (c = Tn, d = Tn / a);
  const h = Tn / a;
  return d < h && (d = h, c = h * a), { width: c, height: d };
}
function io(i) {
  if (!kt) return;
  i.preventDefault(), i.stopPropagation();
  const { width: t } = ex(
    kt,
    i.clientX,
    i.clientY
  );
  kt.img.style.width = `${t}px`, kt.img.style.height = "auto";
}
function ao(i) {
  if (!kt) return;
  i.preventDefault(), i.stopPropagation();
  const { img: t } = kt, e = t.ownerDocument.defaultView;
  e.document.removeEventListener("mousemove", io), e.document.removeEventListener("mouseup", ao), kt = null;
  const n = new Event("input", { bubbles: !0 });
  t.closest('[contenteditable="true"]')?.dispatchEvent(n);
}
function nx(i, t, e) {
  i.preventDefault(), i.stopPropagation();
  const n = t.ownerDocument.defaultView, o = t.closest(".image-resize-wrapper");
  if (!o) return;
  const r = t.naturalWidth, a = t.naturalHeight, l = r / a, c = t.getBoundingClientRect(), d = c.width, h = c.height;
  kt = {
    img: t,
    originalWidth: r,
    originalHeight: a,
    aspectRatio: l,
    startX: i.clientX,
    startY: i.clientY,
    startWidth: d,
    startHeight: h,
    handle: e,
    wrapper: o
  }, n.document.addEventListener("mousemove", io), n.document.addEventListener("mouseup", ao);
}
function sx(i, t) {
  le && (Zr(le), le = null);
  const e = tx(i, t);
  le = e, e.querySelectorAll(".image-resize-handle").forEach((o) => {
    const r = o.dataset.handle;
    o.addEventListener(
      "mousedown",
      (a) => nx(a, i, r)
    );
  });
}
function Ss() {
  if (le && (Zr(le), le = null), kt) {
    const i = kt.img.ownerDocument.defaultView;
    i.document.removeEventListener("mousemove", io), i.document.removeEventListener("mouseup", ao), kt = null;
  }
}
function ox(i) {
  return i ? i.classList.contains("image-resize-wrapper") || i.classList.contains("image-resize-handle") || i.closest(".image-resize-wrapper") !== null : !1;
}
function Yo(i) {
  if (!i) return i;
  const n = new DOMParser().parseFromString(`<div>${i}</div>`, "text/html").body.firstChild;
  return n ? (n.querySelectorAll(".image-resize-wrapper").forEach((r) => {
    const a = r.querySelector("img");
    a && r.parentNode && (r.parentNode.insertBefore(a, r), r.remove());
  }), n.innerHTML) : i;
}
const Jr = "input-rich-text-editor", ti = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: [[["$metaOrCtrl"], "KeyM"]]
  }
], Qo = [
  ...ti,
  ...Yr,
  ...qr,
  ...Cf
], rx = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, ix = vt({
  command: {
    run: E,
    active: () => !1
  },
  content: {
    insert: E,
    setUiBlocker: E
  },
  hotkeys: {
    add: E,
    updateKeybindings: E
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: E
  },
  events: {
    subscribe: () => E,
    publish: E,
    onMouseOver: E,
    onBlur: E
  },
  allowFormatting: [],
  triggers: new Qr(),
  ref: W(),
  window,
  history: {
    canUndo: () => !1,
    undo: E,
    takeSnapshot: E,
    reset: E
  }
});
class lo extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Et;
  /** Context containing props and methods to interact with the editor. */
  static Context = ix;
  static contextType = Yn;
  get effectiveWindow() {
    return this.context ?? window;
  }
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: E,
    sendOnEnter: !1,
    onMount: E,
    onUnmount: E,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(t) {
    super(t), this.editorRef = W(), this.currentSuggestionRef = W(), this.fileInputRef = W(), this.attachmentDropdownButtonRef = W(), this.unsubscribeInlineAttachment = E, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Qo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Qr(),
      ref: this.editorRef,
      window: this.effectiveWindow,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const t = this.effectiveWindow, { onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    this.editor.window !== this.effectiveWindow && (this.editor.window = this.effectiveWindow);
    const { fileUploadStatuses: e, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: a } = this.editorRef;
    e && e !== t.fileUploadStatuses && a && (Object.keys(e).forEach((l) => {
      this.updateFileLoader(l, e[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== t.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), Cr(t.keybindings, o) || this.updateKeyCommandsKeybindings(o), t.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: t } = this.props;
    this.unsubscribeInlineAttachment?.(), Ss(), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return Qo.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => wr(n, t));
    };
  }
  publish(t) {
    this.state.pubsub[t]?.forEach((e) => e(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const a = this.extractEditorContent();
      a !== n && (this.setState({
        htmlOld: a
      }), t(a));
    }
    o.forEach((a) => {
      a();
    }), e && e();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (t) => {
    const { mouseOverListeners: e } = this.state;
    e.forEach((n) => {
      n(t);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (t) => {
    const e = t.target, n = this.effectiveWindow;
    if (ce(e) && e.tagName === "IMG") {
      t.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(e), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
      sx(e, n);
    } else ox(e) || Ss();
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (t) => {
    const { blurListeners: e } = this.state;
    e.forEach(
      (n) => {
        n(t);
      }
    );
  };
  handleKeyDown = (t) => {
    if (t.getModifierState(t.key))
      return;
    const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(t), e.some(
      ({ preventDefaultKeybinding: a }) => a && xs(a, t)
    ) && t.preventDefault(), e.some(
      ({ name: a, keybindings: l, condition: c, callback: d }) => {
        if (xs(l, t) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, t), a && this.editor.events.publish(a), !0;
      }
    )) {
      this.setKeyDownHandled(t), t.stopPropagation();
      return;
    }
    if (t.key === "Enter" && !t.shiftKey && !t.ctrlKey && !t.metaKey && !t.altKey && this.editor.allowFormatting.includes("blockquote")) {
      const a = this.effectiveWindow, l = a.getSelection();
      if (!l) return;
      const c = l.anchorNode, h = (ce(c) ? c : c?.parentElement)?.closest("blockquote");
      if (h && this.editorRef.current?.contains(h)) {
        const u = a.document, p = u.createElement("div");
        p.appendChild(u.createElement("br")), h.after(p);
        const m = u.createRange();
        m.setStart(p, 0), m.collapse(!0), l.removeAllRanges(), l.addRange(m), this.setKeyDownHandled(t), this.handleSelectionChange();
        return;
      }
    }
    if (xs([[["$metaOrCtrl"], "Enter"]], t)) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    } else if (t.key === "Enter" && n && !t.shiftKey) {
      const { onTriggerSend: a } = this.props;
      this.setKeyDownHandled(t), a();
    }
    return null;
  };
  getBlockLevelParent = (t) => {
    const e = this.effectiveWindow;
    let n = ce(t) ? t : t.parentElement;
    for (; !no(n, e); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (t) => {
    const { current: e } = this.editorRef, n = t?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      Ho(e), Xg(e);
      return;
    }
    const a = document.getSelection()?.anchorNode;
    if (o === "insertText" && a && a.textContent?.length === 1) {
      const l = this.getBlockLevelParent(a);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: t } = this.state;
    t || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (t) => {
    t.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (t) => {
    this.setState(({ keyCommands: e }) => ({
      keyCommands: [...e, ...t]
    }));
  };
  updateKeyCommandsKeybindings = (t) => {
    if (!t)
      return;
    const { keyCommands: e } = this.state;
    Object.entries(t).forEach(([n, o]) => {
      const r = e.findIndex(
        ({ name: a }) => a === n
      );
      r > -1 && o && (e[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  handlePaste = (t) => {
    const { onFileDropped: e, allowInlineAttachments: n, sanitize: o } = this.props, r = this.effectiveWindow, { clipboardData: a } = t;
    if (!a)
      return;
    let l = a.getData("text/html");
    const c = a.getData("text/plain"), d = a.files.item(0);
    if (l) {
      t.preventDefault(), this.commandRun("insertHTML", o?.(l));
      return;
    }
    if (c && rx.test(c)) {
      t.preventDefault();
      const h = r.getSelection(), u = h && !h.isCollapsed ? h.toString() : "", p = u && this.editor.allowFormatting.includes("link") ? u : c;
      l = Ur(c, p), this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && e) {
        const { src: h, uid: u } = Wo(r, d);
        this.insertImageLoader(h, u), e(d, u);
      }
      t.preventDefault();
    }
  };
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, r = this.effectiveWindow;
      if (o) {
        if (n || this.recreateSelection(), t === "inlineCode") {
          Xb(r, this.addCurrentContentToUndoStack), this.handleSelectionChange();
          return;
        }
        r.document.execCommand(
          t,
          !1,
          // execCommand 3rd expects string | null, TS thinks it needs string | undefined
          e
        );
      }
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, n = this.effectiveWindow;
    return t === "inlineCode" ? !!(e && Xr(n)) : !!(e && Gg(n, t));
  }
  getText = () => {
    const { current: t } = this.editorRef;
    return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: t } = this.editorRef, e = (
      // innerHTML of <div></div> should count as empty
      t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
    );
    return e ? e.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(t) {
    const { current: e } = this.editorRef, n = this.props.sanitize?.(t);
    e && (e.innerHTML = n || "", Ho(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (t) => {
    if (t === null) return;
    const { onFileDropped: e } = this.props, n = this.effectiveWindow;
    t && e && Array.from(t).forEach((r) => {
      if (Qg(r)) {
        const { src: a, uid: l } = Wo(n, r);
        this.insertImageLoader(a, l), e(r, l);
      } else {
        const a = rn();
        this.insertFileLoader(r.name, a), e(r, a);
      }
    });
  };
  handleAttachmentUpload = (t) => {
    const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), t && typeof e == "function" && Array.from(t).forEach((r) => {
      const a = rn();
      e(r, a);
    });
  };
  handleDetachAttachmentFile = (t) => {
    const { onDetachAttacmentFile: e } = this.props;
    typeof e == "function" && e(t);
  };
  handleFileSelect = (t) => {
    const e = t.target;
    e?.ownerDocument?.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
  };
  openFileBrowser = (t) => {
    t?.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  insertImageLoader(t, e) {
    const o = this.effectiveWindow.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("src", t), this.insertContent(o);
  }
  insertFileLoader(t, e) {
    const o = this.effectiveWindow.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("href", "#"), o.innerText = t, this.insertContent(o);
  }
  updateFileLoader(t, { link: e, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const a = r.querySelector(`[data-uid="${t}"]`);
      a && (n === "failed" && a.parentElement ? a.parentElement.removeChild(a) : (a.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), a.classList.add(`async-${n}`), e && a.tagName === "IMG" && (a.src = e, o && (a.title = o)), e && a.tagName === "A" && (a.href = e)));
    }
  }
  handleToggleSendOnEnter = (t) => {
    t.preventDefault();
    const { onToggleSendOnEnter: e } = this.props;
    e();
  };
  handleToggleAutocompleteSuggestions = (t) => {
    t.preventDefault();
    const { autocomplete: e } = this.props;
    e && e.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const o = `.${bt.editor}`;
    let r = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (t, e) => {
    this.contentInsertionQueue.push(t), e?.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (t) => {
    if (!t || !this.isSelectionWithinEditor(t)) {
      this.contentInsertionQueue = [];
      return;
    }
    if (Zg(t), t?.rangeCount && t?.rangeCount > 0) {
      const e = t.getRangeAt(0);
      if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
        e.insertNode(this.contentInsertionQueue[0]);
      else if (this.contentInsertionQueue.length > 1) {
        const n = document.createElement("span");
        this.contentInsertionQueue.forEach((o) => {
          n.appendChild(o);
        }), e.insertNode(n);
      }
    }
    this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
      t.collapseToEnd();
    }), this.handleSelectionChange();
  };
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const t = this.effectiveWindow;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection(t) {
    const { current: e } = this.editorRef, { lastSelection: n } = this.state, r = this.effectiveWindow.getSelection();
    return e && (!r || !this.isSelectionWithinEditor(r)) && t?.focus !== !1 && (e.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const t = this.effectiveWindow;
    this.setState({
      hasFocus: !0
    }), t.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (t) => {
    const e = this.effectiveWindow, n = e.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    Ss(), this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), e.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(t);
  };
  focus = () => {
    const { current: t } = this.editorRef, { hasFocus: e } = this.state;
    t && (e || t.focus());
  };
  moveCursorToEnd = () => {
    const { current: t } = this.editorRef, e = this.effectiveWindow;
    if (!t) return;
    const n = e.getSelection();
    if (n) {
      const o = e.document.createRange();
      o.selectNodeContents(t), o.collapse(!1), n.removeAllRanges(), n.addRange(o);
    }
  };
  hasContent(t) {
    return t?.length ? !t.match(/^\s*<br>\s*$|^<div[^>]*>\s*(<br>\s*)?<\/div>$/) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList") || this.commandActive("inlineCode");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? Ug : [];
  }
  lastExtractedContent = W();
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!t)
      return Yo(o);
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = t(n);
    return this.lastExtractedContent.current = Yo(
      e?.(r) ?? r
    ), this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: t } = this.state;
    if (t.length > 0) {
      const e = t[t.length - 1];
      this.setHtml(e), this.setState({
        undoStack: t.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: a,
      allowInlineAttachments: l,
      allowAttachments: c,
      attachmentsDisabled: d,
      attachmentsDisabledTooltip: h,
      textInputDisabled: u,
      allowEmoji: p,
      attachmentsFields: m,
      attachments: g,
      isAttachmentsUploading: b,
      hideSendOnEnterToggle: x,
      languages: C,
      disabled: _,
      status: S,
      onError: v,
      icon: y,
      prefix: w,
      suffix: I,
      id: k,
      autocomplete: F,
      toolbarAddons: O
    } = this.props, { htmlOld: T, uiBlocker: R } = this.state, B = this.effectiveWindow, U = f(bt.root, t);
    return /* @__PURE__ */ s.jsx(lo.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      At,
      {
        status: S,
        icon: y,
        prefix: w,
        suffix: I,
        disabled: _,
        className: f(bt.inputWrapper, e),
        children: /* @__PURE__ */ s.jsxs("div", { className: U, children: [
          /* @__PURE__ */ s.jsxs(
            Tf,
            {
              className: bt.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(g) ? g : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: k,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: f(bt.editor, {
                      [bt.editorDisabled]: u
                    }),
                    "data-testid": Jr,
                    contentEditable: !u
                  }
                ),
                !this.hasContent(T) && !!a && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: bt.placeholder, children: a })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs(Yb, { className: bt.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                Hb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: B
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(nb, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Et,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser,
                tooltip: `Insert inline image (${oo(ti[0].keybindings)})`
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              vf,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(g) ? g : [],
                isAttachmentsUploading: b,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: B,
                editor: this.editor,
                disabled: d,
                disabledTooltip: h,
                fixed: !0,
                children: m
              }
            ),
            p && /* @__PURE__ */ s.jsx(Af, { "data-tip": "Emojis", editor: this.editor, fixed: !0 }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              Fb,
              {
                languages: C,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            F && F.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Et,
              {
                isActive: F.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete",
                tooltip: "Autocomplete suggestions"
              }
            ),
            O,
            !x && /* @__PURE__ */ s.jsx(
              Et,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter",
                tooltip: "Send on Enter"
              }
            ),
            F ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(bt.toolbarHint, {
                  [bt.toolbarHintVisible]: this.state.showHint,
                  [bt.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  F.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: bt.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(Gb, { editor: this.editor, onError: v }),
          /* @__PURE__ */ s.jsx(df, { editor: this.editor }),
          R && /* @__PURE__ */ s.jsx("div", { className: bt.uiBlocker, children: R })
        ] })
      }
    ) });
  }
}
const ax = "h-textarea--textarea__inputWrapper", lx = "h-textarea--textarea__input", Xo = {
  inputWrapper: ax,
  input: lx
}, cx = "textarea", ei = $(function(t, e) {
  const n = q(null), {
    className: o,
    disabled: r,
    readOnly: a,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p = 0,
    style: m,
    autoGrow: g,
    ...b
  } = t, [x, C] = V(p), _ = {
    ...m,
    height: x ? `${x}px` : void 0
  }, S = P(() => {
    if (!n.current)
      return;
    const v = n.current.clientHeight, y = window.getComputedStyle(n.current), w = parseInt(y.lineHeight || "16");
    n.current.style.height = "auto";
    const I = n.current.scrollHeight + w, k = Math.max(
      p,
      Math.min(v, I)
    ), F = I > k ? I : k;
    n.current.style.height = `${F}px`, C(F);
  }, [p]);
  return Z(() => {
    if (g)
      return S(), window.addEventListener("resize", S), () => {
        window.removeEventListener("resize", S);
      };
  }, [g, S]), /* @__PURE__ */ s.jsx(
    At,
    {
      className: Xo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": cx,
          className: Xo.input,
          dir: "auto",
          id: l,
          ...b,
          onChange: (v) => {
            b?.onChange?.(v), g && S();
          },
          ref: n,
          style: _,
          name: l,
          disabled: r,
          readOnly: a
        }
      )
    }
  );
}), dx = "h-fieldRichText--fieldRichText__editorContainer", hx = "h-fieldRichText--fieldRichText__fallbackTextArea", Zo = {
  editorContainer: dx,
  fallbackTextArea: hx
};
class oT extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: a,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Re,
          {
            fallback: /* @__PURE__ */ s.jsx(
              ei,
              {
                ...e,
                className: Zo.fallbackTextArea,
                disabled: a,
                value: e.value,
                onChange: (p) => e.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Zo.editorContainer, children: /* @__PURE__ */ s.jsx(
              lo,
              {
                disabled: a,
                status: z.getStatus(o),
                ...e,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: E
              }
            ) })
          }
        )
      }
    );
  }
}
class rT extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: t },
      items: e
    } = this.props;
    return typeof t == "string" && e?.some((n) => n.id === t) ? [t] : Array.isArray(t) && t.length && e?.some((n) => t.some((o) => o === n.id)) ? t : [];
  }
  handleSelect(t) {
    const {
      input: { onChange: e }
    } = this.props;
    typeof e == "function" && e(t === null ? "" : t.id.toString());
  }
  handleClear() {
    const {
      input: { value: t },
      onClear: e
    } = this.props;
    typeof t == "string" && this.handleSelect(null), typeof e == "function" && e();
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: o,
        labelFor: e.name,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Ne,
          {
            ...u,
            id: e.name,
            disabled: a,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function mn(i, t) {
  const e = Ks(), n = q(t);
  n.current = t, Z(() => {
    function o(r) {
      n.current?.(r);
    }
    return e.addEventListener(i, o), () => e.removeEventListener(i, o);
  }, [e, i]);
}
function ni(i, t = "") {
  return Lt.toArray(i).reduce((e, n) => Tt(n) ? n.type === Mt ? [
    ...e,
    ...ni(n.props.children, n.key)
  ] : [...e, { ...n, key: `${t}${n.key}` }] : e, []);
}
const ns = (i) => G(() => ni(i), [i]), ux = "h-selectionList--selectionList__root", px = "h-selectionList--selectionList__disabled", Jo = {
  root: ux,
  disabled: px
}, Ae = Bi(
  () => vt({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: E,
      register: E,
      isSelected: () => !1,
      onSelect: E,
      isOnlyVisibleItem: !1
    }
  })
), co = ({ defaultActiveItemIndex: i = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [t, e] = V(!1), [n, o] = V(-1), [r, a] = V([]), [l, c] = V({}), d = P(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: C
    }, _) => {
      g !== void 0 && a((S) => {
        const v = g ? [...S, _].sort((y, w) => y - w) : S.filter((y) => y !== _);
        return b && o((y) => (v.includes(_) && !S.includes(_) || _ !== y) && v.includes(y) && _ !== v[i] ? y : v[i] ?? v[0] ?? y), v;
      }), x !== void 0 && e(x), C !== void 0 && c((S) => ({
        ...S,
        [_]: C
      }));
    },
    [i]
  ), h = P(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = P(
    (g) => {
      o(h(g));
    },
    [h]
  );
  Z(() => {
    (n < 0 || n === void 0) && o(r[i]);
  }, [n, r, i]);
  const p = G(
    () => l[n] ?? [],
    [n, l]
  );
  return G(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: t,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      t,
      p,
      u
    ]
  );
}, tr = ({
  className: i,
  selectedValues: t = [],
  isActive: e,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = E,
  equalityFn: a = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!e, source: "parent" }), x = Ae(), {
    activeItemIndex: C,
    setActiveItem: _,
    handleItemRegister: S,
    isOnlyActiveItemVisible: v,
    keysDelegatedHandlingToItem: y
  } = co({ defaultActiveItemIndex: c }), w = ns(d), I = P(
    (T) => T !== void 0 && (t || []).some(
      (R) => a(R, T)
    ),
    [a, t]
  ), k = P(
    ({ value: T, meta: R }, B) => {
      _({ index: B }), T !== void 0 && r(o ? {
        selectedValues: I(T) ? t.filter(
          (U) => !a(U, T)
        ) : [...t, T],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !I(T),
          value: T
        },
        event: R?.event
      } : {
        selectedValues: [T],
        selectedItem: {
          isNode: R?.isNode,
          isSelected: !0,
          value: T
        },
        event: R?.event
      });
    },
    [
      a,
      I,
      o,
      r,
      t,
      _
    ]
  ), F = G(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), O = (T) => {
    !F || y.includes(T.key) || (T.key === "Enter" ? T.preventDefault() : T.key === "Home" ? (_({ step: "first" }), T.preventDefault()) : T.key === "End" ? (_({ step: "last" }), T.preventDefault()) : T.key === "ArrowDown" ? (_({ step: 1 }), T.preventDefault()) : T.key === "ArrowUp" && (_({ step: -1 }), T.preventDefault()));
  };
  return Z(() => {
    b({ isActive: !!e, source: "parent" });
  }, [e]), mn("keydown", O), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || e ? -1 : l,
      ...h,
      className: f(i, Jo.root, {
        [Jo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: w.map(
        (T, R) => Tt(T) && (!v || R === C) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: F && R === C,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), _({ index: R });
                },
                register: (B) => S(B, R),
                isSelected: I,
                onSelect: (B) => k(B, R),
                isOnlyVisibleItem: v,
                isLastChild: R === w.length - 1
              }
            },
            children: T
          },
          R
        )
      )
    }
  );
}, er = ({ className: i, label: t, ...e }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = Ht(Ae());
  return Pe(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Jt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    Qn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...e,
      children: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", color: "secondary", children: t })
    }
  );
}, si = Object.assign($(er), {
  name: er.name
}), mx = "h-selectionList-subComponents-item--selectionListItem__root", gx = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", fx = "h-selectionList-subComponents-item--selectionListItem__rootActive", bx = "h-selectionList-subComponents-item--selectionListItem__selectionState", xx = "h-selectionList-subComponents-item--selectionListItem__fixedSize", yx = "h-selectionList-subComponents-item--selectionListItem__content", _x = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", ie = {
  root: mx,
  rootDisabled: gx,
  rootActive: fx,
  selectionState: bx,
  fixedSize: xx,
  content: yx,
  contentDisabled: _x
}, nr = ({
  value: i,
  isDisabled: t = !1,
  isIndeterminate: e = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: a,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: C,
      onSelect: _,
      isActive: S,
      isNode: v = !1,
      isLastChild: y = !1,
      setActive: w
    }
  } = Ht(Ae()), I = C(i), k = G(
    () => !m && (g || b),
    [g, m, b]
  ), F = G(
    () => !t && S && k,
    [S, t, k]
  ), O = q(null);
  Fe(
    u,
    () => O.current
  );
  const T = P(
    (L) => {
      !t && !m && (c?.({ value: i, meta: { target: L?.target } }), _({
        value: i,
        meta: {
          target: L?.target,
          event: L || void 0
        }
      }));
    },
    [t, m, c, _, i]
  ), R = P(
    (L) => {
      F && L.key === "Enter" && !t && !m && (c?.({
        value: i,
        meta: { target: L.target ?? void 0 }
      }), _({
        value: i,
        meta: { target: L.target ?? void 0, event: L }
      }));
    },
    [F, t, m, c, _, i]
  );
  Z(() => {
    S && k && O.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [S]);
  const B = P(
    () => ({
      isActive: S,
      isSelected: I,
      isLastChild: y,
      isNode: v,
      value: i
    }),
    [S, y, v, I, i]
  ), U = on(S), ot = on(I);
  Zt(() => {
    S !== U && a?.(B()), I !== ot && l?.(B());
  }, [
    B,
    S,
    I,
    a,
    l,
    U,
    ot
  ]), mn("keydown", R), Z(() => (x({ isActivatable: !t, isLastChild: y }), () => x({ isActivatable: !1, isLastChild: y })), [t]);
  const nt = !p && I || p && i !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: O,
      role: "option",
      "aria-selected": I,
      "aria-disabled": t,
      onClick: T,
      onMouseMove: w,
      className: f(ie.root, n, {
        [ie.rootActive]: F,
        [ie.rootDisabled]: t
      }),
      ...h,
      children: [
        nt && /* @__PURE__ */ s.jsxs(
          H,
          {
            className: f(ie.selectionState, {
              [ie.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && i !== void 0 && /* @__PURE__ */ s.jsx(
                hn,
                {
                  checked: I,
                  indeterminate: !I && e,
                  disabled: t,
                  onChange: E,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          it,
          {
            className: f(ie.content, o, {
              [ie.contentDisabled]: t
            }),
            children: d
          }
        ),
        v && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, Cx = Object.assign($(nr), {
  name: nr.name
}), vx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", wx = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", sr = {
  root: vx,
  rootActive: wx
}, or = ({
  className: i,
  content: t,
  onActiveStateChange: e,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: a,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = Ht(Ae()), m = G(
    () => !a && (l || c),
    [l, a, c]
  ), g = G(
    () => h && m,
    [h, m]
  ), b = q(null);
  Fe(
    r,
    () => b.current
  );
  const x = P(() => {
    u({}), n?.();
  }, [u, n]), C = P(
    (S) => {
      !g || a || S.key === "Enter" && x();
    },
    [x, g, a]
  );
  Z(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }, [h]);
  const _ = on(h);
  return Zt(() => {
    h !== _ && e?.({ isActive: h });
  }, [h, e, _]), mn("keydown", C), Pe(() => {
    d({ isActivatable: !0 });
  }), Jt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(sr.root, i, {
        [sr.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: t || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, oi = Object.assign(
  $(or),
  {
    name: or.name
  }
), Sx = "h-selectionList-subComponents-list--selectionListList__list", Ix = {
  list: Sx
}, rr = ({
  parentItem: i,
  children: t,
  backItemProps: e = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...a
}, l) => {
  const c = Ae(), d = Ht(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: C,
      isLastChild: _ = !1
    }
  } = d, S = G(
    () => !p && (u || h),
    [u, p, h]
  ), v = ns(t), {
    activeItemIndex: y,
    setActiveItem: w,
    handleItemRegister: I,
    isOnlyActiveItemVisible: k,
    keysDelegatedHandlingToItem: F
  } = co({ defaultActiveItemIndex: 1 }), O = P(
    (L, yt) => {
      w({ index: yt }), g(L);
    },
    [g, w]
  ), T = (L) => {
    !S || !b || F.includes(L.key) || (L.key === "Home" ? (w({ step: "first" }), L.preventDefault()) : L.key === "End" ? (w({ step: "last" }), L.preventDefault()) : L.key === "ArrowDown" ? (w({ step: 1 }), L.preventDefault()) : L.key === "ArrowUp" && (w({ step: -1 }), L.preventDefault()));
  }, R = on(
    b
  );
  Zt(() => {
    b !== R && r?.({
      isActive: b,
      isLastChild: _
    });
  }, [
    b,
    r,
    R
  ]), Z(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), mn("keydown", T);
  const B = P(
    ({ value: L, meta: yt }) => {
      yt?.target instanceof HTMLInputElement && yt.target.type === "checkbox" ? g({ value: L, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), U = P(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  Z(() => {
    b || w({ index: -1 });
  }, [b, w]);
  const ot = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: B,
        isNode: !0
      }
    }),
    [B, d]
  ), nt = G(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: U,
        isActive: y === 0,
        setActive: () => {
          C(), w({ index: 0 });
        },
        register: (L) => I(L, 0)
      }
    }),
    [
      y,
      U,
      I,
      d,
      C,
      w
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !k && /* @__PURE__ */ s.jsx(c.Provider, { value: nt, children: /* @__PURE__ */ s.jsx(oi, { ...e }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...a, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(Ix.list, n),
        ...o,
        children: v.map((L, yt) => {
          const dt = yt + 1;
          return Tt(L) && (!k || dt === y) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && dt === y,
                  setActive: () => {
                    C(), w({ index: dt });
                  },
                  register: (ee) => I(ee, dt),
                  onSelect: (ee) => O(ee, dt),
                  isOnlyVisibleItem: k,
                  isLastChild: yt === v.length - 1
                }
              },
              children: L
            },
            yt
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: ot, children: i });
}, Dx = Object.assign($(rr), {
  name: rr.name
}), kx = "h-selectionList-subComponents-section--selectionListSection__section", Tx = {
  section: kx
}, ir = ({
  title: i,
  children: t,
  listProps: { className: e, ...n } = {},
  onActiveStateChange: o,
  ...r
}, a) => {
  const l = Ae(), c = Ht(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, C = G(
    () => !u && (h || d),
    [h, u, d]
  ), _ = ns(t), {
    activatableItemIndices: S,
    activeItemIndex: v,
    setActiveItem: y,
    handleItemRegister: w,
    keysDelegatedHandlingToItem: I
  } = co(), k = P(
    (T, R) => {
      y({ index: R }), g(T);
    },
    [g, y]
  ), F = (T) => {
    !C || I.includes(T.key) || (T.key === "Home" ? y({ step: "first" }) : T.key === "End" && y({ step: "last" }), p ? T.key === "ArrowDown" && v !== S[S.length - 1] ? (y({ step: 1 }), T.preventDefault()) : T.key === "ArrowUp" && v !== S[0] && (y({ step: -1 }), T.preventDefault()) : T.key === "ArrowDown" ? y({ step: "first" }) : T.key === "ArrowUp" && y({ step: "last" }));
  }, O = on(p);
  return Zt(() => {
    p !== O && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, O]), Z(() => {
    const T = [];
    p && (v !== S[S.length - 1] && T.push("ArrowDown"), v !== S[0] && T.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: T });
  }, [S, v, p]), Pe(() => b({ isActivatable: !0 })), Jt(() => b({ isActivatable: !1 })), mn("keydown", F), /* @__PURE__ */ s.jsx("li", { ref: a, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(Tx.section, e),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(si, { label: i }),
        _.map(
          (T, R) => Tt(T) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && R === v,
                  setActive: () => {
                    m(), y({ index: R });
                  },
                  register: (B) => w(B, R),
                  onSelect: (B) => k(B, R),
                  isLastChild: x && R === _.length - 1
                }
              },
              children: T
            },
            R
          )
        )
      ]
    }
  ) });
}, jx = Object.assign($(ir), {
  name: ir.name
}), Nx = Object.assign($(tr), {
  name: tr.name,
  Item: Cx,
  BackItem: oi,
  Divider: si,
  Section: jx,
  List: Dx
}), Fx = "h-inputSelectionList-chip--inputSelectionListChip__root", Px = "h-inputSelectionList-chip--inputSelectionListChip__name", ar = {
  root: Fx,
  name: Px
}, Is = ({
  onDelete: i,
  className: t,
  disabled: e,
  readOnly: n,
  ...o
}) => {
  const r = G(() => {
    if (!(!i || e || n))
      return (a) => {
        a.stopPropagation(), i();
      };
  }, [e, i, n]);
  return /* @__PURE__ */ s.jsx(
    je,
    {
      ...o,
      onDelete: r,
      className: f(ar.root, t),
      tagNameClassName: ar.name
    }
  );
}, Rx = "h-inputSelectionList--inputSelectionList__root", Ex = "h-inputSelectionList--inputSelectionList__inputWrapper", Lx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", Ax = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", $x = "h-inputSelectionList--inputSelectionList__rootReadOnly", Ox = "h-inputSelectionList--inputSelectionList__titleContainer", Bx = "h-inputSelectionList--inputSelectionList__filterInput", Wx = "h-inputSelectionList--inputSelectionList__placeholder", Hx = "h-inputSelectionList--inputSelectionList__titleBox", Mx = "h-inputSelectionList--inputSelectionList__iconContainer", zx = "h-inputSelectionList--inputSelectionList__iconButton", Vx = "h-inputSelectionList--inputSelectionList__dropdown", Kx = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", Ux = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", lt = {
  root: Rx,
  inputWrapper: Ex,
  inputWrapperChild: Lx,
  rootHasWrapperIcon: Ax,
  rootReadOnly: $x,
  titleContainer: Ox,
  filterInput: Bx,
  placeholder: Wx,
  titleBox: Hx,
  iconContainer: Mx,
  iconButton: zx,
  dropdown: Vx,
  hiddenItemsTooltip: Kx,
  hiddenItemsChip: Ux
}, qx = "inputSelectionListTestId", lr = ({
  className: i,
  name: t,
  value: e,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: a,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: C,
  onClick: _,
  onBlur: S,
  onKeyDown: v,
  limit: y = Number.POSITIVE_INFINITY,
  clearable: w = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: k,
  valueArrayToStringFn: F = JSON.stringify,
  rootClassName: O,
  dropdownProps: T,
  selectionListProps: R,
  slotBeforeList: B,
  slotAfterList: U,
  ...ot
}, nt) => {
  const L = Ks(), yt = q(null), dt = q(null), ee = q(null), ho = q(null), [J, ii] = V(!1);
  Fe(
    nt,
    () => dt.current
  );
  const os = G(
    () => p?.value !== void 0 && p.onChange !== void 0 && J,
    [p, J]
  ), ai = G(() => {
    if (!e?.length)
      return c;
    if (!m) {
      const M = g(e[0]);
      return typeof M == "object" ? "" : M?.toString();
    }
    return "";
  }, [m, c, g, e]), li = G(() => os ? m && !!e?.length : !0, [m, os, e?.length]), rs = P(
    (M) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: M
        },
        selectedValues: e?.filter((Be) => !I(Be, M)) ?? []
      });
    },
    [d, I, n, h, e]
  ), ci = G(() => {
    if (!e?.length)
      return /* @__PURE__ */ s.jsx(H, { alignItems: "center", className: lt.placeholder, children: c });
    if (m) {
      const M = y < e.length ? e.slice(0, y) : e, Be = y < e.length ? e.slice(y) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        M?.map((We, is) => /* @__PURE__ */ s.jsx(
          Is,
          {
            onDelete: () => {
              rs(We);
            },
            disabled: d,
            readOnly: h,
            children: g(We)
          },
          is
        )),
        !!Be.length && /* @__PURE__ */ s.jsx(
          st,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              H,
              {
                className: lt.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Be?.map((We, is) => /* @__PURE__ */ s.jsx(
                  Is,
                  {
                    onDelete: () => {
                      rs(We);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(We)
                  },
                  is
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              Is,
              {
                className: lt.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Be.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(it, { className: lt.titleBox, children: g(e[0]) });
  }, [
    e,
    m,
    g,
    c,
    y,
    d,
    h,
    rs
  ]), ht = P(
    (M) => {
      (h || d) && M || (M !== J && C?.(M), ii(M));
    },
    [d, J, C, h]
  ), $e = P(
    ({ target: M }) => {
      ho.current?.contains(M) || (yt.current?.contains(M) && dt.current?.focus(), ht(!1));
    },
    [ht]
  ), Oe = P(
    (M) => {
      Ee(M.key) && J && (ht(!1), dt.current?.focus());
    },
    [J, ht]
  ), di = P(
    (M) => {
      M.relatedTarget && yt.current?.contains(M.relatedTarget) || (ht(!1), S?.(M));
    },
    [S, ht]
  ), hi = P(
    (M) => {
      J || M.stopPropagation(), ht(!0), _?.(M);
    },
    [J, _, ht]
  ), ui = P(
    (M) => {
      Zn(M.key) && ht(!0), v?.(M);
    },
    [v, ht]
  ), pi = P(
    (M) => {
      M.stopPropagation(), ht(!J), dt.current?.focus();
    },
    [J, ht]
  ), mi = P(
    (M) => {
      M.stopPropagation(), dt.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), gi = P(
    (M) => {
      n?.(M), dt.current?.focus(), !x && !m ? ht(!1) : ee.current?.focus();
    },
    [m, x, n, ht]
  );
  return Z(() => (J ? (L.addEventListener("click", $e), L.addEventListener("keydown", Oe)) : (L.removeEventListener("click", $e), L.removeEventListener("keydown", Oe)), () => {
    L.removeEventListener("click", $e), L.removeEventListener("keydown", Oe);
  }), [$e, Oe, J, L]), Z(() => {
    J && ee.current?.focus();
  }, [J]), Jt(() => {
    L.removeEventListener("click", $e), L.removeEventListener("keydown", Oe);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": qx,
      ref: yt,
      className: f(lt.root, O, {
        [lt.rootHasWrapperIcon]: !!a,
        [lt.rootReadOnly]: h
      }),
      "aria-expanded": J,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          At,
          {
            ...ot,
            ref: dt,
            className: f(i, lt.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: a,
            active: J,
            status: l,
            onClick: hi,
            onBlur: di,
            onKeyDown: ui,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(H, { className: lt.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(H, { gap: "100", flexWrap: "wrap", className: lt.titleContainer, children: [
                li && ci,
                os && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: ee,
                    className: f(lt.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: ai,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(H, { alignItems: "center", className: lt.iconContainer, children: [
                w && !d && !h && !!e?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: mi,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: J ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: pi,
                    "aria-label": J ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        t && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: t,
            value: F(e)
          }
        ),
        /* @__PURE__ */ s.jsx(
          te,
          {
            isOpen: J,
            ...T,
            className: f(T?.className, lt.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: ho, style: { width: "100%" }, children: J && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              B,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Nx,
                {
                  ...R,
                  equalityFn: I,
                  defaultActiveItemIndex: k,
                  isActive: J,
                  isMultiple: m,
                  selectedValues: e,
                  onChange: gi,
                  children: u
                }
              ),
              U
            ] }) })
          }
        )
      ]
    }
  );
}, Gx = Object.assign($(lr), {
  name: lr.name
}), iT = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Gx,
      {
        name: e,
        value: t || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Yx = "h-slider--slider__rootWrapper", Qx = "h-slider--slider__rootWrapperNoAnnotations", Xx = "h-slider--slider__root", Zx = "h-slider--slider__rootDark", Jx = "h-slider--slider__rootDisabled", ty = "h-slider--slider__handle", ey = "h-slider--slider__trackWrapper", ny = "h-slider--slider__track", sy = "h-slider--slider__highlight", oy = "h-slider--slider__minValueIndicator", ry = "h-slider--slider__maxValueIndicator", xt = {
  rootWrapper: Yx,
  rootWrapperNoAnnotations: Qx,
  root: Xx,
  rootDark: Zx,
  rootDisabled: Jx,
  handle: ty,
  trackWrapper: ey,
  track: ny,
  highlight: sy,
  minValueIndicator: oy,
  maxValueIndicator: ry
};
var Pt = /* @__PURE__ */ ((i) => (i.LowBoundIndicator = "input-slider-low-indicator", i.HighBoundIndicator = "input-slider-high-indicator", i.Handle = "input-slider-handle", i.Value = "input-slider-value", i.TrackBackground = "input-slider-tack-background", i.Track = "input-slider-track", i.Highlight = "input-slider-highlight", i))(Pt || {});
const iy = (i) => {
  i.preventDefault();
}, ay = (i, t, e) => typeof i != "number" && !Array.isArray(i) ? "" : typeof i == "number" ? /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i,
  e
] }) : /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "3", children: [
  t,
  i[0],
  e,
  " - ",
  t,
  i[1],
  e
] });
class ly extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: ay,
    hideAnnotations: !1
  };
  constructor(t) {
    super(t), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = W();
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    typeof t == "number" ? this.props.onChange?.(Math.round(t)) : this.props.onChange?.(
      t.map((e) => Math.round(e))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: o, currentIndex: r } = this.state, a = e + (t.clientX - n) / o, l = this.getAbsoluteValue(a, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const o = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (t.clientX - o.left) / o.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let a;
    if (this.isInterval(e)) {
      const l = n ?? this.findTheNearestHandle(r, e);
      this.setState({
        currentIndex: l
      }), a = this.getAbsoluteValue(r, l);
    } else
      a = this.getAbsoluteValue(r);
    this.handleChange(a), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, o] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > o && t > n ? 1 : t < o && t < n ? 0 : Math.abs(n - t) > Math.abs(o - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: o } = this.props;
    let r = An(t, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [a, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    e === 0 && c > l ? c = l : e === 1 && c < a && (c = a);
    const d = [a, l];
    return typeof e == "number" && (d[e] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, o = e + (n - e) * t;
    return An(o, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, o = (t - e) / (n - e);
    return An(o, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[e ?? 0] = r[e ?? 0] + t, o = r;
    } else
      o = n + t;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), o = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (Ct(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: o,
      min: r,
      max: a,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...C
    } = this.props, _ = f(
      xt.root,
      { [xt.rootDark]: l },
      { [xt.rootDisabled]: c },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(xt.rootWrapper, {
          [xt.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...C,
              className: _,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: xt.trackWrapper,
                    "data-testid": Pt.TrackBackground,
                    children: [
                      !Ct(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: xt.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Pt.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: xt.track,
                          style: this.getTrackStyles(),
                          "data-testid": Pt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": a,
                    "aria-valuenow": e,
                    className: xt.handle,
                    onClick: iy,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Pt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ s.jsxs(Mt, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: xt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pt.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: xt.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Pt.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Pt.LowBoundIndicator,
                    className: xt.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: xt.maxValueIndicator,
                    "data-testid": Pt.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(A.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      a,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Pt.Value, children: h(e, p, m) })
        ]
      }
    );
  }
}
const Bs = dn(ly, {
  fallback: null
}), cy = "h-fieldSlider--fieldSlider__root", dy = {
  root: cy
};
class aT extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(t) {
    const e = new Event("change");
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t, name: this.props.input.name }
    }), this.props.input.onChange(e);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(t) {
    const { input: e } = this.props, n = new FocusEvent(
      "blur",
      t
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: e.value, name: e.name }
    }), e.onBlur?.(n);
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(dy.root, t);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Bs,
          {
            ...e,
            onChange: this.handleChange,
            disabled: a,
            ...u
          }
        )
      }
    );
  }
}
const hy = "h-switch--switch__root", uy = "h-switch--switch__input", py = "h-switch--switch__inner", my = "h-switch--switch__pending", gy = "h-switch--switch__active", Ye = {
  root: hy,
  input: uy,
  inner: py,
  pending: my,
  active: gy
}, cr = {
  input: "Switch-input",
  label: "Switch-label"
};
class fy extends D {
  render() {
    const { id: t, className: e, variant: n, ...o } = this.props, r = t || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(e, Ye.root), "data-testid": t, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ye.input,
          "data-testid": cr.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ye.inner, {
            [Ye.active]: n === "active",
            [Ye.pending]: n === "pending"
          }),
          "data-testid": cr.label
        }
      )
    ] });
  }
}
class lT extends D {
  render() {
    const { input: t, ...e } = this.props, { ref: n, ...o } = t;
    return /* @__PURE__ */ s.jsx(fy, { ...o, ...e });
  }
}
class cT extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: a,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: a,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          ei,
          {
            status: z.getStatus(o),
            disabled: a,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const dT = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => {
      n(b ?? "");
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        an,
        {
          selectedItems: e ? [e] : [],
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, hT = ({
  className: i,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => {
      n({
        startTime: b.startTime ?? "",
        endTime: b.endTime ?? ""
      });
    },
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: i,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: a,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        Lm,
        {
          endTime: e.endTime,
          startTime: e.startTime,
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(a)
        }
      )
    }
  );
}, by = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", xy = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", yy = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", _y = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", jn = {
  root: by,
  rootAlpha: xy,
  indicator: yy,
  indicatorNoColor: _y
}, Cy = ({
  color: i,
  alpha: t,
  className: e,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(jn.root, e, {
      [jn.rootAlpha]: t
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(jn.indicator, {
          [jn.indicatorNoColor]: !i
        }),
        style: { backgroundColor: i }
      }
    )
  }
), vy = "h-inputColorPicker--inputColorPicker__root", wy = "h-inputColorPicker--inputColorPicker__inputContainer", Sy = "h-inputColorPicker--inputColorPicker__input", Iy = "h-inputColorPicker--inputColorPicker__rootReadOnly", Dy = "h-inputColorPicker--inputColorPicker__iconContainer", ky = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", Ty = "h-inputColorPicker--inputColorPicker__clearIcon", jy = "h-inputColorPicker--inputColorPicker__colorIndicator", Gt = {
  root: vy,
  inputContainer: wy,
  input: Sy,
  rootReadOnly: Iy,
  iconContainer: Dy,
  rootHasWrapperIcon: ky,
  clearIcon: Ty,
  colorIndicator: jy
}, Ny = "inputColorPickerTestId", Fy = $(function({
  className: t,
  name: e = Math.floor(Math.random() * 1e8).toString(),
  value: n,
  onChange: o,
  dropdownProps: r,
  prefix: a,
  suffix: l,
  icon: c,
  status: d,
  placeholder: h,
  disabled: u,
  colorPickerProps: p,
  clearable: m,
  readOnly: g,
  children: b,
  ...x
}, C) {
  const _ = q(null), S = q(null), v = q(null), [y, w] = V(!1);
  Z(() => {
    y ? (window.addEventListener("click", k), window.addEventListener("keydown", F)) : (window.removeEventListener("click", k), window.removeEventListener("keydown", F)), y && I();
  }, [y]), Jt(() => {
    window.removeEventListener("click", k), window.removeEventListener("keydown", F);
  });
  const I = () => {
    v.current?.querySelector("input")?.focus();
  }, k = ({ target: U }) => {
    S.current?.contains(U) || w(!1);
  }, F = (U) => {
    Ee(U.key) && y && (U.stopPropagation(), w(!1));
  }, O = () => {
    g || w(!0);
  }, T = ({ target: U }) => {
    S.current?.contains(U) || w(!1);
  }, R = () => {
    g || w(!0);
  }, B = ({ key: U }) => {
    Zn(U) && w(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Ny,
      ref: S,
      className: f(Gt.root, t, {
        [Gt.rootHasWrapperIcon]: !!c,
        [Gt.rootReadOnly]: g
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          At,
          {
            prefix: a,
            suffix: l,
            disabled: u,
            icon: c,
            active: y,
            status: d,
            children: /* @__PURE__ */ s.jsxs("div", { className: Gt.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...x,
                  id: e,
                  name: e,
                  className: Gt.input,
                  ref: _,
                  onClick: R,
                  onFocus: O,
                  onBlur: T,
                  onKeyDown: B,
                  disabled: u,
                  placeholder: h,
                  autoComplete: "off",
                  value: n,
                  onChange: Hn(n) ? void 0 : E,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Gt.iconContainer, children: m && n && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: Gt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: u,
                  onClick: () => o?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                Cy,
                {
                  className: Gt.colorIndicator,
                  onClick: R,
                  color: n,
                  alpha: p?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(te, { ...r, isOpen: y, children: /* @__PURE__ */ s.jsx("div", { ref: v, children: /* @__PURE__ */ s.jsx(
          Jn,
          {
            margin: "300",
            ...p,
            color: n,
            onChange: o ?? E,
            children: b
          }
        ) }) })
      ]
    }
  );
}), uT = ({
  className: i,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: a,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: i,
    label: r,
    labelFor: e,
    meta: a,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Fy,
      {
        name: e,
        value: t,
        onChange: n,
        ...o,
        status: z.getStatus(a),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Py = "h-fieldAddonDropdown--fieldAddonDropdown__root", Ry = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", Ey = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", Ly = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", Nn = {
  root: Py,
  prefix: Ry,
  suffix: Ey,
  angleDown: Ly
}, pT = ({
  className: i,
  noArrow: t,
  ...e
}) => zs(e) ? null : /* @__PURE__ */ s.jsx(Ps.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  eo,
  {
    ...wr(e, "meta"),
    noStyle: !0,
    itemComponent: Hr,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          Nn.root,
          {
            [Nn.prefix]: n === "prefix",
            [Nn.suffix]: n === "suffix"
          },
          i
        ),
        disabled: o || e.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: e.meta.selectedValue }),
          !t && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", Nn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), Ay = "h-countryFlag--countryFlag__flag", $y = "h-countryFlag--countryFlag__ad", Oy = "h-countryFlag--countryFlag__ae", By = "h-countryFlag--countryFlag__af", Wy = "h-countryFlag--countryFlag__ag", Hy = "h-countryFlag--countryFlag__ai", My = "h-countryFlag--countryFlag__al", zy = "h-countryFlag--countryFlag__am", Vy = "h-countryFlag--countryFlag__ao", Ky = "h-countryFlag--countryFlag__aq", Uy = "h-countryFlag--countryFlag__ar", qy = "h-countryFlag--countryFlag__as", Gy = "h-countryFlag--countryFlag__at", Yy = "h-countryFlag--countryFlag__au", Qy = "h-countryFlag--countryFlag__aw", Xy = "h-countryFlag--countryFlag__ax", Zy = "h-countryFlag--countryFlag__az", Jy = "h-countryFlag--countryFlag__ba", t_ = "h-countryFlag--countryFlag__bb", e_ = "h-countryFlag--countryFlag__bd", n_ = "h-countryFlag--countryFlag__be", s_ = "h-countryFlag--countryFlag__bf", o_ = "h-countryFlag--countryFlag__bg", r_ = "h-countryFlag--countryFlag__bh", i_ = "h-countryFlag--countryFlag__bi", a_ = "h-countryFlag--countryFlag__bj", l_ = "h-countryFlag--countryFlag__bl", c_ = "h-countryFlag--countryFlag__bm", d_ = "h-countryFlag--countryFlag__bn", h_ = "h-countryFlag--countryFlag__bo", u_ = "h-countryFlag--countryFlag__bq", p_ = "h-countryFlag--countryFlag__br", m_ = "h-countryFlag--countryFlag__bs", g_ = "h-countryFlag--countryFlag__bt", f_ = "h-countryFlag--countryFlag__bv", b_ = "h-countryFlag--countryFlag__bw", x_ = "h-countryFlag--countryFlag__by", y_ = "h-countryFlag--countryFlag__bz", __ = "h-countryFlag--countryFlag__ca", C_ = "h-countryFlag--countryFlag__cd", v_ = "h-countryFlag--countryFlag__cf", w_ = "h-countryFlag--countryFlag__cg", S_ = "h-countryFlag--countryFlag__ch", I_ = "h-countryFlag--countryFlag__ci", D_ = "h-countryFlag--countryFlag__ck", k_ = "h-countryFlag--countryFlag__cl", T_ = "h-countryFlag--countryFlag__cm", j_ = "h-countryFlag--countryFlag__cn", N_ = "h-countryFlag--countryFlag__co", F_ = "h-countryFlag--countryFlag__cp", P_ = "h-countryFlag--countryFlag__cr", R_ = "h-countryFlag--countryFlag__cu", E_ = "h-countryFlag--countryFlag__cv", L_ = "h-countryFlag--countryFlag__cw", A_ = "h-countryFlag--countryFlag__cy", $_ = "h-countryFlag--countryFlag__cz", O_ = "h-countryFlag--countryFlag__de", B_ = "h-countryFlag--countryFlag__dj", W_ = "h-countryFlag--countryFlag__dk", H_ = "h-countryFlag--countryFlag__dm", M_ = "h-countryFlag--countryFlag__dz", z_ = "h-countryFlag--countryFlag__ec", V_ = "h-countryFlag--countryFlag__ee", K_ = "h-countryFlag--countryFlag__eg", U_ = "h-countryFlag--countryFlag__eh", q_ = "h-countryFlag--countryFlag__er", G_ = "h-countryFlag--countryFlag__es", Y_ = "h-countryFlag--countryFlag__et", Q_ = "h-countryFlag--countryFlag__eu", X_ = "h-countryFlag--countryFlag__fi", Z_ = "h-countryFlag--countryFlag__fj", J_ = "h-countryFlag--countryFlag__fm", tC = "h-countryFlag--countryFlag__fo", eC = "h-countryFlag--countryFlag__fr", nC = "h-countryFlag--countryFlag__ga", sC = "h-countryFlag--countryFlag__gb", oC = "h-countryFlag--countryFlag__gd", rC = "h-countryFlag--countryFlag__ge", iC = "h-countryFlag--countryFlag__gg", aC = "h-countryFlag--countryFlag__gh", lC = "h-countryFlag--countryFlag__gi", cC = "h-countryFlag--countryFlag__gl", dC = "h-countryFlag--countryFlag__gm", hC = "h-countryFlag--countryFlag__gn", uC = "h-countryFlag--countryFlag__gp", pC = "h-countryFlag--countryFlag__gq", mC = "h-countryFlag--countryFlag__gr", gC = "h-countryFlag--countryFlag__gt", fC = "h-countryFlag--countryFlag__gu", bC = "h-countryFlag--countryFlag__gw", xC = "h-countryFlag--countryFlag__gy", yC = "h-countryFlag--countryFlag__hk", _C = "h-countryFlag--countryFlag__hn", CC = "h-countryFlag--countryFlag__hr", vC = "h-countryFlag--countryFlag__ht", wC = "h-countryFlag--countryFlag__hu", SC = "h-countryFlag--countryFlag__id", IC = "h-countryFlag--countryFlag__ie", DC = "h-countryFlag--countryFlag__il", kC = "h-countryFlag--countryFlag__im", TC = "h-countryFlag--countryFlag__iq", jC = "h-countryFlag--countryFlag__ir", NC = "h-countryFlag--countryFlag__is", FC = "h-countryFlag--countryFlag__it", PC = "h-countryFlag--countryFlag__je", RC = "h-countryFlag--countryFlag__jm", EC = "h-countryFlag--countryFlag__jo", LC = "h-countryFlag--countryFlag__jp", AC = "h-countryFlag--countryFlag__ke", $C = "h-countryFlag--countryFlag__kg", OC = "h-countryFlag--countryFlag__kh", BC = "h-countryFlag--countryFlag__ki", WC = "h-countryFlag--countryFlag__km", HC = "h-countryFlag--countryFlag__kn", MC = "h-countryFlag--countryFlag__kp", zC = "h-countryFlag--countryFlag__kr", VC = "h-countryFlag--countryFlag__kw", KC = "h-countryFlag--countryFlag__ky", UC = "h-countryFlag--countryFlag__kz", qC = "h-countryFlag--countryFlag__la", GC = "h-countryFlag--countryFlag__lb", YC = "h-countryFlag--countryFlag__lc", QC = "h-countryFlag--countryFlag__li", XC = "h-countryFlag--countryFlag__lk", ZC = "h-countryFlag--countryFlag__lr", JC = "h-countryFlag--countryFlag__ls", tv = "h-countryFlag--countryFlag__lt", ev = "h-countryFlag--countryFlag__lu", nv = "h-countryFlag--countryFlag__lv", sv = "h-countryFlag--countryFlag__ly", ov = "h-countryFlag--countryFlag__ma", rv = "h-countryFlag--countryFlag__mc", iv = "h-countryFlag--countryFlag__md", av = "h-countryFlag--countryFlag__me", lv = "h-countryFlag--countryFlag__mf", cv = "h-countryFlag--countryFlag__mg", dv = "h-countryFlag--countryFlag__mh", hv = "h-countryFlag--countryFlag__mk", uv = "h-countryFlag--countryFlag__ml", pv = "h-countryFlag--countryFlag__mm", mv = "h-countryFlag--countryFlag__mn", gv = "h-countryFlag--countryFlag__mo", fv = "h-countryFlag--countryFlag__mq", bv = "h-countryFlag--countryFlag__mr", xv = "h-countryFlag--countryFlag__ms", yv = "h-countryFlag--countryFlag__mt", _v = "h-countryFlag--countryFlag__mu", Cv = "h-countryFlag--countryFlag__mv", vv = "h-countryFlag--countryFlag__mw", wv = "h-countryFlag--countryFlag__mx", Sv = "h-countryFlag--countryFlag__my", Iv = "h-countryFlag--countryFlag__mz", Dv = "h-countryFlag--countryFlag__na", kv = "h-countryFlag--countryFlag__nc", Tv = "h-countryFlag--countryFlag__ne", jv = "h-countryFlag--countryFlag__ng", Nv = "h-countryFlag--countryFlag__ni", Fv = "h-countryFlag--countryFlag__nl", Pv = "h-countryFlag--countryFlag__no", Rv = "h-countryFlag--countryFlag__np", Ev = "h-countryFlag--countryFlag__nq", Lv = "h-countryFlag--countryFlag__nr", Av = "h-countryFlag--countryFlag__nu", $v = "h-countryFlag--countryFlag__nz", Ov = "h-countryFlag--countryFlag__om", Bv = "h-countryFlag--countryFlag__pa", Wv = "h-countryFlag--countryFlag__pe", Hv = "h-countryFlag--countryFlag__pf", Mv = "h-countryFlag--countryFlag__pg", zv = "h-countryFlag--countryFlag__ph", Vv = "h-countryFlag--countryFlag__pk", Kv = "h-countryFlag--countryFlag__pl", Uv = "h-countryFlag--countryFlag__pr", qv = "h-countryFlag--countryFlag__ps", Gv = "h-countryFlag--countryFlag__pt", Yv = "h-countryFlag--countryFlag__pw", Qv = "h-countryFlag--countryFlag__py", Xv = "h-countryFlag--countryFlag__qa", Zv = "h-countryFlag--countryFlag__re", Jv = "h-countryFlag--countryFlag__ro", tw = "h-countryFlag--countryFlag__rs", ew = "h-countryFlag--countryFlag__ru", nw = "h-countryFlag--countryFlag__rw", sw = "h-countryFlag--countryFlag__sa", ow = "h-countryFlag--countryFlag__sb", rw = "h-countryFlag--countryFlag__sc", iw = "h-countryFlag--countryFlag__sd", aw = "h-countryFlag--countryFlag__se", lw = "h-countryFlag--countryFlag__sg", cw = "h-countryFlag--countryFlag__sh", dw = "h-countryFlag--countryFlag__si", hw = "h-countryFlag--countryFlag__sj", uw = "h-countryFlag--countryFlag__sk", pw = "h-countryFlag--countryFlag__sl", mw = "h-countryFlag--countryFlag__sm", gw = "h-countryFlag--countryFlag__sn", fw = "h-countryFlag--countryFlag__so", bw = "h-countryFlag--countryFlag__sr", xw = "h-countryFlag--countryFlag__ss", yw = "h-countryFlag--countryFlag__st", _w = "h-countryFlag--countryFlag__sv", Cw = "h-countryFlag--countryFlag__sx", vw = "h-countryFlag--countryFlag__sy", ww = "h-countryFlag--countryFlag__sz", Sw = "h-countryFlag--countryFlag__tc", Iw = "h-countryFlag--countryFlag__td", Dw = "h-countryFlag--countryFlag__tg", kw = "h-countryFlag--countryFlag__th", Tw = "h-countryFlag--countryFlag__tj", jw = "h-countryFlag--countryFlag__tl", Nw = "h-countryFlag--countryFlag__tm", Fw = "h-countryFlag--countryFlag__tn", Pw = "h-countryFlag--countryFlag__to", Rw = "h-countryFlag--countryFlag__tr", Ew = "h-countryFlag--countryFlag__tt", Lw = "h-countryFlag--countryFlag__tv", Aw = "h-countryFlag--countryFlag__tw", $w = "h-countryFlag--countryFlag__tz", Ow = "h-countryFlag--countryFlag__ua", Bw = "h-countryFlag--countryFlag__ug", Ww = "h-countryFlag--countryFlag__us", Hw = "h-countryFlag--countryFlag__uy", Mw = "h-countryFlag--countryFlag__uz", zw = "h-countryFlag--countryFlag__va", Vw = "h-countryFlag--countryFlag__vc", Kw = "h-countryFlag--countryFlag__ve", Uw = "h-countryFlag--countryFlag__vg", qw = "h-countryFlag--countryFlag__vi", Gw = "h-countryFlag--countryFlag__vn", Yw = "h-countryFlag--countryFlag__vu", Qw = "h-countryFlag--countryFlag__ws", Xw = "h-countryFlag--countryFlag__ye", Zw = "h-countryFlag--countryFlag__yt", Jw = "h-countryFlag--countryFlag__za", tS = "h-countryFlag--countryFlag__zm", eS = "h-countryFlag--countryFlag__zw", dr = {
  flag: Ay,
  ad: $y,
  ae: Oy,
  af: By,
  ag: Wy,
  ai: Hy,
  al: My,
  am: zy,
  ao: Vy,
  aq: Ky,
  ar: Uy,
  as: qy,
  at: Gy,
  au: Yy,
  aw: Qy,
  ax: Xy,
  az: Zy,
  ba: Jy,
  bb: t_,
  bd: e_,
  be: n_,
  bf: s_,
  bg: o_,
  bh: r_,
  bi: i_,
  bj: a_,
  bl: l_,
  bm: c_,
  bn: d_,
  bo: h_,
  bq: u_,
  br: p_,
  bs: m_,
  bt: g_,
  bv: f_,
  bw: b_,
  by: x_,
  bz: y_,
  ca: __,
  cd: C_,
  cf: v_,
  cg: w_,
  ch: S_,
  ci: I_,
  ck: D_,
  cl: k_,
  cm: T_,
  cn: j_,
  co: N_,
  cp: F_,
  cr: P_,
  cu: R_,
  cv: E_,
  cw: L_,
  cy: A_,
  cz: $_,
  de: O_,
  dj: B_,
  dk: W_,
  dm: H_,
  do: "h-countryFlag--countryFlag__do",
  dz: M_,
  ec: z_,
  ee: V_,
  eg: K_,
  eh: U_,
  er: q_,
  es: G_,
  et: Y_,
  eu: Q_,
  fi: X_,
  fj: Z_,
  fm: J_,
  fo: tC,
  fr: eC,
  ga: nC,
  gb: sC,
  gd: oC,
  ge: rC,
  gg: iC,
  gh: aC,
  gi: lC,
  gl: cC,
  gm: dC,
  gn: hC,
  gp: uC,
  gq: pC,
  gr: mC,
  gt: gC,
  gu: fC,
  gw: bC,
  gy: xC,
  hk: yC,
  hn: _C,
  hr: CC,
  ht: vC,
  hu: wC,
  id: SC,
  ie: IC,
  il: DC,
  im: kC,
  in: "h-countryFlag--countryFlag__in",
  iq: TC,
  ir: jC,
  is: NC,
  it: FC,
  je: PC,
  jm: RC,
  jo: EC,
  jp: LC,
  ke: AC,
  kg: $C,
  kh: OC,
  ki: BC,
  km: WC,
  kn: HC,
  kp: MC,
  kr: zC,
  kw: VC,
  ky: KC,
  kz: UC,
  la: qC,
  lb: GC,
  lc: YC,
  li: QC,
  lk: XC,
  lr: ZC,
  ls: JC,
  lt: tv,
  lu: ev,
  lv: nv,
  ly: sv,
  ma: ov,
  mc: rv,
  md: iv,
  me: av,
  mf: lv,
  mg: cv,
  mh: dv,
  mk: hv,
  ml: uv,
  mm: pv,
  mn: mv,
  mo: gv,
  mq: fv,
  mr: bv,
  ms: xv,
  mt: yv,
  mu: _v,
  mv: Cv,
  mw: vv,
  mx: wv,
  my: Sv,
  mz: Iv,
  na: Dv,
  nc: kv,
  ne: Tv,
  ng: jv,
  ni: Nv,
  nl: Fv,
  no: Pv,
  np: Rv,
  nq: Ev,
  nr: Lv,
  nu: Av,
  nz: $v,
  om: Ov,
  pa: Bv,
  pe: Wv,
  pf: Hv,
  pg: Mv,
  ph: zv,
  pk: Vv,
  pl: Kv,
  pr: Uv,
  ps: qv,
  pt: Gv,
  pw: Yv,
  py: Qv,
  qa: Xv,
  re: Zv,
  ro: Jv,
  rs: tw,
  ru: ew,
  rw: nw,
  sa: sw,
  sb: ow,
  sc: rw,
  sd: iw,
  se: aw,
  sg: lw,
  sh: cw,
  si: dw,
  sj: hw,
  sk: uw,
  sl: pw,
  sm: mw,
  sn: gw,
  so: fw,
  sr: bw,
  ss: xw,
  st: yw,
  sv: _w,
  sx: Cw,
  sy: vw,
  sz: ww,
  tc: Sw,
  td: Iw,
  tg: Dw,
  th: kw,
  tj: Tw,
  tl: jw,
  tm: Nw,
  tn: Fw,
  to: Pw,
  tr: Rw,
  tt: Ew,
  tv: Lw,
  tw: Aw,
  tz: $w,
  ua: Ow,
  ug: Bw,
  us: Ww,
  uy: Hw,
  uz: Mw,
  va: zw,
  vc: Vw,
  ve: Kw,
  vg: Uw,
  vi: qw,
  vn: Gw,
  vu: Yw,
  ws: Qw,
  ye: Xw,
  yt: Zw,
  za: Jw,
  zm: tS,
  zw: eS
}, nS = 127365, sS = /^[a-z]{2}$/, oS = (i) => sS.test(i) ? String.fromCodePoint(
  ...i.split("").map((t) => nS + t.charCodeAt(0))
) : "", mT = ({
  className: i,
  countryCode: t,
  size: e = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(it, { style: { width: e, height: e }, children: /* @__PURE__ */ s.jsx(
  it,
  {
    className: f(dr.flag, dr[t], i),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${e} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: i, style: { fontSize: e }, children: oS(t) }), gT = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], rS = "h-formGrid--formGrid__root", iS = {
  root: rS
}, aS = "formGridTestId", fT = $(function({ className: t, children: e, ...n }, o) {
  const r = f(iS.root, t);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": aS,
      className: r,
      ...n,
      ref: o,
      children: e
    }
  );
}), lS = "h-formGrid-field--formField__root", cS = "h-formGrid-field--formField__rootSpan5", dS = "h-formGrid-field--formField__rootSpan4", hS = "h-formGrid-field--formField__rootSpan3", uS = "h-formGrid-field--formField__rootSpan2", pS = "h-formGrid-field--formField__rootSpan1", De = {
  root: lS,
  rootSpan5: cS,
  rootSpan4: dS,
  rootSpan3: hS,
  rootSpan2: uS,
  rootSpan1: pS
}, mS = "formFieldTestId", gS = {
  1: De.rootSpan1,
  2: De.rootSpan2,
  3: De.rootSpan3,
  4: De.rootSpan4,
  5: De.rootSpan5,
  6: void 0
};
class bT extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: t, className: e, children: n, ...o } = this.props, r = f(
      De.root,
      e,
      gS[t]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": mS, className: r, ...o, children: n });
  }
}
const fS = "h-helperField--helperField__root", bS = "h-helperField--helperField__label", xS = "h-helperField--helperField__helpIcon", yS = "h-helperField--helperField__error", _S = "h-helperField--helperField__rootRequired", Qe = {
  root: fS,
  label: bS,
  helpIcon: xS,
  error: yS,
  rootRequired: _S
};
class xT extends D {
  render() {
    const {
      className: t,
      label: e,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: a,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Qe.root]: !0,
        [Qe.rootRequired]: n
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!e && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Qe.label,
          htmlFor: a,
          id: `${a}-label`,
          children: e
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Ys,
        {
          ...c,
          className: f(Qe.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Qe.error, children: r }),
      l
    ] });
  }
}
const CS = "h-inputDuration--inputDuration__root", vS = {
  root: CS
}, Ds = (i, t = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const e = Math.floor(i / 1e3), n = {};
  let o = e;
  return t.includes("days") && (n.days = Math.floor(e / (24 * 3600)), o = e % (24 * 3600)), t.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), t.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), t.includes("seconds") && (n.seconds = o), n;
}, ks = (i) => ((i.days ?? 0) * 86400 + (i.hours ?? 0) * 3600 + (i.minutes ?? 0) * 60 + (i.seconds ?? 0)) * 1e3, wS = [
  "hours",
  "minutes",
  "seconds"
], yT = $(
  function(t, e) {
    const n = q(null);
    Fe(e, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: a = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = wS,
      status: u,
      onChange: p,
      onBlur: m
    } = t, [g, b] = V(
      () => Ds(a, h)
    );
    Z(() => {
      const v = ks(g);
      if (a !== v) {
        const y = Ds(a, h);
        b(y);
      }
    }, [a, h]);
    const x = P(
      (v, y) => {
        const w = Math.max(0, parseInt(y) || 0);
        if ((v === "minutes" || v === "seconds") && w > 60)
          return;
        const I = { ...g, [v]: w };
        b(I);
        const k = ks(I);
        p?.(k);
      },
      [g, p]
    ), C = P(() => {
      const v = ks(g), y = Ds(
        v,
        h
      );
      b(y), m?.();
    }, [g, h, m]), _ = (v) => {
      const y = g[v] ?? 0, w = y === 0;
      return {
        type: "number",
        id: `${r}-${v}`,
        name: `${r}-${v}`,
        value: w ? "" : y,
        placeholder: w ? "0" : void 0,
        suffix: {
          type: "custom",
          value: v.charAt(0).toUpperCase() + v.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: C,
        onChange: (I) => x(v, I.target.value)
      };
    }, S = f(o, vS.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: S, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Qt, { ..._("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Qt, { ..._("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Qt, { ..._("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Qt, { ..._("seconds"), max: 60 })
    ] });
  }
), Xe = /* @__PURE__ */ new Map();
function SS({
  containerId: i,
  children: t
}) {
  const [e, n] = V(null), o = (a) => {
    const l = Xe.get(i);
    l !== void 0 && Xe.set(i, l + a);
  }, r = () => {
    const a = document.createElement("div");
    return a.id = i, a;
  };
  return Z(() => {
    let a = document.getElementById(i);
    return a || (a = r(), document.body.appendChild(a), Xe.set(i, 0)), n(a), o(1), () => {
      o(-1), Xe.get(i) === 0 && a && (Xe.delete(i), a.remove());
    };
  }, [i]), e ? Xi.createPortal(t, e) : null;
}
const IS = "h-modal--modal__root", DS = "h-modal--modal__rootSkipAnimation", kS = "h-modal--modal__modalContainer", TS = "h-modal--modal__modalContent", jS = "h-modal--modal__rootDisplayed", NS = "h-modal--modal__rootOpened", FS = "h-modal--modal__modal", PS = "h-modal--modal__modalStacked", RS = "h-modal--modal__ghostPanel", ES = "h-modal--modal__ghostLabel", jt = {
  root: IS,
  rootSkipAnimation: DS,
  modalContainer: kS,
  modalContent: TS,
  rootDisplayed: jS,
  rootOpened: NS,
  modal: FS,
  modalStacked: PS,
  ghostPanel: RS,
  ghostLabel: ES
}, LS = vt(!1);
class AS extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(t) {
    super(t), this.rootRef = W(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: o } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== o && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    const { isOpen: e, onClose: n } = this.props;
    e && Ee(t.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    const { skipAnimation: t } = this.props;
    t ? this.setState({ displayed: !0, opened: !0 }) : (this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 })));
  }
  animateClosing() {
    const { skipAnimation: t } = this.props;
    this.removeKeyDownEventListener(), t ? this.setState({ opened: !1, displayed: !1 }) : (this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred());
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: a,
      // Stops allowEscClose from being passed in with otherProps
      skipAnimation: l,
      wrapProps: c,
      autoFocus: d,
      restoreFocus: h,
      bringInFocusOnTab: u,
      ...p
    } = this.props, { displayed: m, opened: g } = this.state, b = f(jt.root, c?.className, {
      [jt.rootDisplayed]: m,
      [jt.rootOpened]: g,
      [jt.rootSkipAnimation]: l
    });
    return /* @__PURE__ */ s.jsx(SS, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...c, className: b, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: jt.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...p,
        children: g && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          kr,
          {
            containerRef: this.rootRef,
            autoFocus: d,
            restoreFocus: h,
            bringInFocusOnTab: u,
            children: /* @__PURE__ */ s.jsx("div", { className: jt.modalContent, children: /* @__PURE__ */ s.jsx(LS.Consumer, { children: (x) => /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: f(jt.modal, t, {
                  [jt.modalStacked]: x
                }),
                onClick: (C) => r && C.stopPropagation(),
                children: [
                  x && /* @__PURE__ */ s.jsx(
                    "div",
                    {
                      role: "button",
                      tabIndex: -1,
                      className: jt.ghostPanel,
                      onClick: o,
                      children: /* @__PURE__ */ s.jsxs("span", { className: jt.ghostLabel, children: [
                        /* @__PURE__ */ s.jsx(N, { name: "arrow-left", size: 12 }),
                        "Go back"
                      ] })
                    }
                  ),
                  n
                ]
              }
            ) }) })
          }
        )
      }
    ) }) });
  }
}
const $S = "h-lightbox--lightbox__lightSource", OS = "h-lightbox--lightbox__closeButton", BS = "h-lightbox--lightbox__downloadButton", WS = "h-lightbox--lightbox__image", HS = "h-lightbox--lightbox__loadingContainer", MS = "h-lightbox--lightbox__navButton", zS = "h-lightbox--lightbox__navButtonPrevious", VS = "h-lightbox--lightbox__navButtonNext", KS = "h-lightbox--lightbox__counter", Nt = {
  lightSource: $S,
  closeButton: OS,
  downloadButton: BS,
  image: WS,
  loadingContainer: HS,
  navButton: MS,
  navButtonPrevious: zS,
  navButtonNext: VS,
  counter: KS
};
class _T extends D {
  render() {
    const {
      className: t,
      src: e,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: a = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      AS,
      {
        className: t,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: Nt.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: Nt.loadingContainer, children: /* @__PURE__ */ s.jsx(Gn, { size: 64 }) }) : e && /* @__PURE__ */ s.jsx(Us, { className: Nt.image, alt: n, src: e }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: Nt.closeButton
            }
          ),
          e && typeof e == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: e,
              target: "_blank",
              download: !0,
              className: Nt.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          a && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${Nt.navButton} ${Nt.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${Nt.navButton} ${Nt.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: Nt.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const US = "h-list-items--item__root", qS = "h-list-items--item__rootWithHoverEffect", GS = "h-list-items--item__rootDense", YS = "h-list-items--item__rootLarge", QS = "h-list-items--item__contentLeft", XS = "h-list-items--item__contentRight", ZS = "h-list-items--item__titles", JS = "h-list-items--item__title", tI = "h-list-items--item__titleSecondary", eI = "h-list-items--item__arrow", Ft = {
  root: US,
  rootWithHoverEffect: qS,
  rootDense: GS,
  rootLarge: YS,
  contentLeft: QS,
  contentRight: XS,
  titles: ZS,
  title: JS,
  titleSecondary: tI,
  arrow: eI
};
class ss extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: t, titleSecondary: e } = this.props;
    return t || e ? /* @__PURE__ */ s.jsxs("div", { className: Ft.titles, children: [
      !!t && /* @__PURE__ */ s.jsx(A.Paragraph, { as: "div", variant: "2", className: Ft.title, children: t }),
      !!e && /* @__PURE__ */ s.jsx(
        A.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: Ft.titleSecondary,
          children: e
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Ft.contentLeft, children: t }) : null;
  }
  renderContentRight() {
    const { contentRight: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: Ft.contentRight, children: t }) : null;
  }
  renderIcon() {
    const { isLink: t, contentRight: e } = this.props;
    return t && !e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(Ft.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Mt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: t,
      children: e,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: a,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(Ft.root, t, {
      [Ft.rootDense]: d === "dense",
      [Ft.rootLarge]: d === "large",
      [Ft.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const nI = "h-list-items--keyValue__root", sI = {
  root: nI
};
class oI extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: t, className: e, pair: n, ...o } = this.props, r = f(sI.root, e);
    return t && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      ss,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(A.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const rI = "h-list-items--text__root", iI = {
  root: rI
};
class aI extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(iI.root, e);
    return /* @__PURE__ */ s.jsx(
      ss,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(A.Paragraph, { variant: "2", children: t })
      }
    );
  }
}
const lI = "h-list-items--user__root", cI = "h-list-items--user__avatarWrapper", hr = {
  root: lI,
  avatarWrapper: cI
};
class dI extends D {
  getTitle() {
    const { user: t, title: e } = this.props;
    return e || t.display_name || t.name || t.phone_number || t.id;
  }
  getSubTitle() {
    const { user: t, titleSecondary: e } = this.props;
    return e || t.email;
  }
  render() {
    const { className: t, user: e, title: n, titleSecondary: o, ...r } = this.props, a = f(t, hr.root);
    return /* @__PURE__ */ s.jsx(
      ss,
      {
        className: a,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: hr.avatarWrapper, children: /* @__PURE__ */ s.jsx(Dr, { user: e }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const hI = "h-list--list__root", uI = {
  root: hI
};
class pI extends D {
  static Item = ss;
  static Text = aI;
  static User = dI;
  static KeyValue = oI;
  render() {
    const { className: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...e, className: f(uI.root, t) });
  }
}
const CT = dn(pI, {
  fallback: null
}), mI = () => {
  document.exitFullscreen && document.exitFullscreen();
}, gI = (i) => {
  i.requestFullscreen ? i.requestFullscreen() : i.mozRequestFullScreen ? i.mozRequestFullScreen() : i.webkitRequestFullscreen ? i.webkitRequestFullscreen() : i.msRequestFullscreen && i.msRequestFullscreen();
}, fI = (i) => document.fullscreenElement === i;
class bI extends Error {
  status;
  url;
  response;
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`), this.status = t.status, this.url = t.url, this.response = t;
  }
}
const xI = {
  fetch: (i, ...t) => fetch(i, ...t).then((e) => {
    if (!(e.status >= 200 && e.status < 300))
      throw new bI(e);
    return e;
  })
}, yI = "h-mediaPlayer--mediaPlayer__root", _I = "h-mediaPlayer--mediaPlayer__controls", CI = "h-mediaPlayer--mediaPlayer__unstyled", vI = "h-mediaPlayer--mediaPlayer__rootFullScreen", wI = "h-mediaPlayer--mediaPlayer__rootHideControls", SI = "h-mediaPlayer--mediaPlayer__control", II = "h-mediaPlayer--mediaPlayer__progress", DI = "h-mediaPlayer--mediaPlayer__progressSlider", kI = "h-mediaPlayer--mediaPlayer__volumeSlider", TI = "h-mediaPlayer--mediaPlayer__timestamp", jI = "h-mediaPlayer--mediaPlayer__videoWrapper", NI = "h-mediaPlayer--mediaPlayer__rootWaiting", FI = "h-mediaPlayer--mediaPlayer__rootAudio", PI = "h-mediaPlayer--mediaPlayer__video", RI = "h-mediaPlayer--mediaPlayer__volume", EI = "h-mediaPlayer--mediaPlayer__volumeMuteControl", LI = "h-mediaPlayer--mediaPlayer__downloadLink", tt = {
  root: yI,
  controls: _I,
  unstyled: CI,
  rootFullScreen: vI,
  rootHideControls: wI,
  control: SI,
  progress: II,
  progressSlider: DI,
  volumeSlider: kI,
  timestamp: TI,
  videoWrapper: jI,
  rootWaiting: NI,
  rootAudio: FI,
  video: PI,
  volume: RI,
  volumeMuteControl: EI,
  downloadLink: LI
};
function AI(i) {
  const t = i >= 3600 ? 8 : 5;
  return Number.isNaN(i) || !Number.isFinite(i) ? "00:00" : new Date(i * 1e3).toISOString().substr(19 - t, t);
}
class vT extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(t) {
    super(t), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = W();
  playerRef = W();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    xI.fetch(e, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((a) => a.blob()).then((a) => {
      const l = window.URL.createObjectURL(a);
      t ? Wi.saveAs(
        a,
        o || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((a) => {
      a && a.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", a), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let o = null;
      const r = t.buffered;
      for (let a = 0; a < r.length; a += 1) {
        const l = r.start(a), c = r.end(a);
        l <= e && e <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = fI(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? mI() : gI(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleVolume = (t) => {
    const { current: e } = this.videoRef;
    !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
      this.setPlayerVolume(t);
    });
  };
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, o = e === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : e
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: a,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: C,
      asyncStatus: _
    } = this.state, S = a?.play ?? !0, v = a?.download ?? !0, y = a?.progress ?? !0, w = a?.volume ?? !0, I = a?.maximize ?? !0, k = S || v || y || w || I, F = typeof e == "string" && e.startsWith("audio"), O = !d || _ === "loading", T = b ? "primary" : "secondary", R = f(
      tt.root,
      {
        [tt.rootFullScreen]: b,
        [tt.rootHideControls]: g,
        [tt.rootWaiting]: h && x,
        [tt.rootAudio]: F
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: R,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: tt.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: tt.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          k && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(tt.controls, {
                [tt.unstyled]: l
              }),
              children: [
                S && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: tt.control,
                    disabled: O,
                    icon: h ? "pause" : "play",
                    variant: T
                  }
                ),
                v && (o ? /* @__PURE__ */ s.jsx(
                  X,
                  {
                    variant: T,
                    className: tt.control,
                    disabled: O,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: tt.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: T,
                    className: tt.control,
                    disabled: O,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                y && /* @__PURE__ */ s.jsxs("div", { className: tt.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    Bs,
                    {
                      hideAnnotations: !0,
                      className: tt.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (B) => !Array.isArray(B) && this.seek(B / u),
                      dark: b,
                      highlightRange: C?.map((B) => B * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: tt.timestamp, children: AI(u) })
                ] }),
                w && /* @__PURE__ */ s.jsxs("div", { className: tt.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: tt.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    Bs,
                    {
                      hideAnnotations: !0,
                      className: tt.volumeSlider,
                      value: m,
                      onChange: (B) => !Array.isArray(B) && this.handleVolume(B),
                      dark: b
                    }
                  )
                ] }),
                I && !F && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: T,
                    onClick: this.handleFullscreenToggle,
                    className: tt.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const $I = "h-modalBody--modalBody__root", OI = {
  root: $I
};
class wT extends D {
  render() {
    const { className: t, children: e, ...n } = this.props, o = f(
      {
        [OI.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: e });
  }
}
const BI = "h-modalFoot--modalFoot__root", WI = "h-modalFoot--modalFoot__confirm", HI = "h-modalFoot--modalFoot__confirmSecondary", MI = "h-modalFoot--modalFoot__cancel", Fn = {
  root: BI,
  confirm: WI,
  confirmSecondary: HI,
  cancel: MI
};
class zI extends D {
  static defaultProps;
  render() {
    const {
      className: t,
      confirmOnClick: e,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: a,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [Fn.root]: !0
      },
      t
    ), g = f(
      {
        [Fn.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [Fn.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [Fn.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: a
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      e && /* @__PURE__ */ s.jsx(
        X,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: e,
          children: r
        }
      )
    ] });
  }
}
zI.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const VI = "h-modalHead--modalHead__root", KI = "h-modalHead--modalHead__top", UI = "h-modalHead--modalHead__title", qI = "h-modalHead--modalHead__buttons", GI = "h-modalHead--modalHead__caption", Ze = {
  root: VI,
  top: KI,
  title: UI,
  buttons: qI,
  caption: GI
}, ST = ({
  className: i,
  title: t,
  children: e,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  buttonsSlot: a,
  ...l
}) => {
  const c = f(
    {
      [Ze.root]: !0
    },
    i
  );
  return /* @__PURE__ */ s.jsxs("div", { ...l, className: c, children: [
    /* @__PURE__ */ s.jsxs("div", { className: Ze.top, children: [
      /* @__PURE__ */ s.jsx(A.Heading, { className: Ze.title, children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: f(Ze.buttons, r), children: [
        a,
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(st, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!e && /* @__PURE__ */ s.jsx(
      A.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: Ze.caption,
        children: e
      }
    )
  ] });
}, YI = "h-page-body--pageBody__root", QI = {
  root: YI
}, XI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: f(QI.root, e),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: t
    }
  );
}), ZI = "h-page-head--pageHead__root", JI = {
  root: ZI
}, tD = $(function({ className: t, title: e, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(JI.root, t),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-2", as: "h1", children: e }) }),
        n && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), eD = "h-page-section--pageSection__root", nD = "h-page-section--pageSection__head", sD = "h-page-section--pageSection__callout", oD = "h-page-section--pageSection__content", Pn = {
  root: eD,
  head: nD,
  callout: sD,
  content: oD
}, rD = $(function({
  children: t,
  className: e,
  title: n,
  titleMeta: o,
  controls: r,
  callout: a,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    mt.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Pn.root, e),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          mt.Row,
          {
            className: Pn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(H, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(A.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(mt.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(H, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        a && /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: Pn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: a
          }
        ),
        /* @__PURE__ */ s.jsx(
          mt.Row,
          {
            className: Pn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: t
          }
        )
      ]
    }
  );
}), iD = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    mt.Row,
    {
      ...n,
      ref: o,
      className: e,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: t
    }
  );
}), ur = ({ children: i, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(xd, { ...e, ref: n, as: "article", className: t, children: /* @__PURE__ */ s.jsx(mt, { children: i }) }), IT = Object.assign($(ur), {
  name: ur.name,
  Head: tD,
  Body: XI,
  Section: rD,
  Tabs: iD
}), aD = "h-radio--radio__radio", lD = "h-radio--radio__radioDisabled", cD = "h-radio--radio__radioChecked", dD = "h-radio--radio__input", Rn = {
  radio: aD,
  radioDisabled: lD,
  radioChecked: cD,
  input: dD
}, DT = $(function(t, e) {
  const { id: n, checked: o, disabled: r, className: a, labelProps: l, ...c } = t, d = f(
    Rn.radio,
    { [Rn.radioChecked]: o },
    { [Rn.radioDisabled]: r },
    a
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: e,
          id: h,
          onChange: c.onChange || E,
          checked: o,
          disabled: r,
          type: "radio",
          className: Rn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), hD = "h-reverseScroll--reverseScroll__root", uD = "h-reverseScroll--reverseScroll__column", pD = "h-reverseScroll--reverseScroll__row", mD = "h-reverseScroll--reverseScroll__scrollHandle", Je = {
  root: hD,
  column: uD,
  row: pD,
  scrollHandle: mD
}, gD = "reverse-scroll", kT = $(function({
  children: t,
  className: e,
  direction: n = "column",
  ...o
}, r) {
  const a = q(null), l = q(null), c = q(null), d = ns(t), h = G(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => a.current?.children[1]?.scrollIntoView(b), g = (b) => a.current?.children[a.current.children.length - 2]?.scrollIntoView(b);
  return Fe(r, () => ({
    rootElem: a.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": gD,
      ref: a,
      className: f(e, Je.root, {
        [Je.row]: n === "row",
        [Je.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Je.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Je.scrollHandle })
      ]
    }
  );
}), fD = "h-removableCard--removableCard__root", bD = "h-removableCard--removableCard__close", xD = "h-removableCard--removableCard__title", yD = "h-removableCard--removableCard__titleIcon", tn = {
  root: fD,
  close: bD,
  title: xD,
  titleIcon: yD
};
class TT extends D {
  render() {
    const { icon: t, title: e, children: n, onRemove: o, className: r, ...a } = this.props, l = f(
      {
        [tn.root]: tn.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      it,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...a,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            it,
            {
              as: "button",
              "aria-label": "Remove",
              className: tn.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            H,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: tn.title,
              children: [
                t && /* @__PURE__ */ s.jsx(N, { name: t, className: tn.titleIcon }),
                e
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(it, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const pr = ({
  colorMode: i = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${i}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${i};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, _D = "h-sandboxIframe--sandboxIframe__frame", CD = {
  frame: _D
};
class ri extends D {
  frameRef;
  static defaultProps;
  constructor(t) {
    super(t), this.state = {
      iframeHeight: 0
    }, this.frameRef = W(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: o } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      t.indexOf("</body>") !== -1 ? r = t.replace(
        "</body>",
        `${pr({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${pr(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...a
    } = this.props, { iframeHeight: l } = this.state, c = f({}, t);
    return /* @__PURE__ */ s.jsx("div", { ...a, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? ri.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: CD.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const vD = "h-scrollbar--scrollbar__track", wD = "h-scrollbar--scrollbar__handle", mr = {
  track: vD,
  handle: wD
};
class jT extends D {
  constructor(t) {
    super(t), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: t } = this.props;
    if (t.current) {
      const { current: e } = t;
      this.setState({
        size: e.offsetHeight / e.scrollHeight,
        progress: e.scrollTop / e.scrollHeight
      });
    }
  };
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const o = e.current.getBoundingClientRect();
      let r = (t.clientY - o.top) / e.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), e.current.scrollTop = r * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: o } = this.state;
    if (e.current) {
      const r = e.current.getBoundingClientRect();
      let a = (t.clientY - r.top) / e.current.offsetHeight - o;
      a < 0 && (a = 0), a + n > 1 && (a = 1 - n), e.current.scrollTop = a * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...o } = this.props, { size: r, progress: a } = this.state, l = f(t);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(mr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(mr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${a * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const SD = "h-scrollShadow--scrollShadow__wrapper", ID = "h-scrollShadow--scrollShadow__content", gr = {
  wrapper: SD,
  content: ID
}, NT = ({
  className: i,
  children: t,
  ...e
}) => {
  const n = f(gr.wrapper, i);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...e, children: /* @__PURE__ */ s.jsx("div", { className: gr.content, children: t }) });
}, DD = "h-searchInput--searchInput__root", kD = "h-searchInput--searchInput__input", TD = "h-searchInput--searchInput__inputButton", En = {
  root: DD,
  input: kD,
  inputButton: TD
}, jD = 275, fr = 300, FT = ({
  className: i,
  initialSearch: t,
  maxWidth: e = jD,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: a,
  ...l
}) => {
  const c = q(null), [d, h] = V(!!t), [u, p] = V(!1), [m, g] = V(t ?? "");
  Yi(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    fr,
    [u]
  ), Zt(() => {
    a?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = P(() => {
    h(!0);
  }, []), x = P(() => {
    p(!0);
  }, []), C = P(
    (y) => {
      y.preventDefault(), r(m);
    },
    [r, m]
  ), _ = P(
    (y) => {
      const {
        target: { value: w }
      } = y;
      g(w), o?.(w);
    },
    [o]
  ), S = P(
    ({ key: y }) => {
      y === "Enter" && b();
    },
    [b]
  ), v = P(
    ({ key: y }) => {
      (y === "Esc" || y === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(En.root, i),
      style: {
        "--max-width": `${d && !u ? e : 32}px`,
        "--transition-delay": `${fr}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: C, children: /* @__PURE__ */ s.jsx(
        Qt,
        {
          className: En.input,
          ref: c,
          onChange: _,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: C,
              className: En.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: En.inputButton
            }
          },
          onKeyDown: v
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: S,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, ND = "h-selectOption--selectOption__root", FD = "h-selectOption--selectOption__checkbox", PD = "h-selectOption--selectOption__content", Ts = {
  root: ND,
  checkbox: FD,
  content: PD
}, PT = (i) => {
  const t = f(Ts.root);
  return /* @__PURE__ */ s.jsxs("label", { className: t, children: [
    /* @__PURE__ */ s.jsx(
      hn,
      {
        ...i,
        className: f(Ts.checkbox, i.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: Ts.content, children: i.name })
  ] });
}, RD = "h-simpleProgressBar--simpleProgressBar__container", ED = "h-simpleProgressBar--simpleProgressBar__progressBar", LD = "h-simpleProgressBar--simpleProgressBar__progressBarFill", js = {
  container: RD,
  progressBar: ED,
  progressBarFill: LD
}, AD = "simpleProgressBarId";
function RT({
  progress: i,
  base: t = 100,
  progressColor: e = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...a
}) {
  const [l, c] = V(0), d = 4;
  Z(() => c(i), [i]);
  const h = t >= l ? l / t : 1, u = () => d / h, p = {
    backgroundColor: sn(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: sn(e)
  };
  return /* @__PURE__ */ s.jsx(
    H,
    {
      "test-id": AD,
      "align-items": "center",
      "justify-content": "center",
      className: js.container,
      ...a,
      children: /* @__PURE__ */ s.jsx(
        st,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: js.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: js.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const $D = "h-tabsWithContent--tabsWithContent__container", OD = "h-tabsWithContent--tabsWithContent__containerTop", BD = "h-tabsWithContent--tabsWithContent__containerLeft", WD = "h-tabsWithContent--tabsWithContent__containerRight", HD = "h-tabsWithContent--tabsWithContent__containerBottom", MD = "h-tabsWithContent--tabsWithContent__childrenContainer", Se = {
  container: $D,
  containerTop: OD,
  containerLeft: BD,
  containerRight: WD,
  containerBottom: HD,
  childrenContainer: MD
};
class Ws extends ft {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.state = { activeTab: t.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(t) {
    this.ensureTabIsValid(t) && (this.setState({ activeTab: t }), this.props.onChange?.(t));
  }
  ensureTabIsValid(t) {
    return this.props.tabs.some((e) => e.id === t);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: t }) => t === this.state.activeTab);
  }
  render() {
    const {
      className: t,
      tabsClassName: e,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: a,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Lt.toArray(l);
    if (h.length !== a.length) {
      const g = `${Ws.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Ws.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(t, Se.container, {
      [Se.containerTop]: c === "top",
      [Se.containerLeft]: c === "left",
      [Se.containerBottom]: c === "bottom",
      [Se.containerRight]: c === "right"
    }), m = f(
      r,
      Se.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        Cb,
        {
          className: e,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: a,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const zD = "h-tagsInput--tagsInput__root", VD = "h-tagsInput--tagsInput__wrapper", KD = "h-tagsInput--tagsInput__input", UD = "h-tagsInput--tagsInput__inputIsHidden", qD = "h-tagsInput--tagsInput__placeholder", GD = "h-tagsInput--tagsInput__placeholderText", YD = "h-tagsInput--tagsInput__iconBox", QD = "h-tagsInput--tagsInput__iconText", XD = "h-tagsInput--tagsInput__tag", ZD = "h-tagsInput--tagsInput__tagIsActive", JD = "h-tagsInput--tagsInput__tagButton", tk = "h-tagsInput--tagsInput__divider", pt = {
  root: zD,
  wrapper: VD,
  input: KD,
  inputIsHidden: UD,
  placeholder: qD,
  placeholderText: GD,
  iconBox: YD,
  iconText: QD,
  tag: XD,
  tagIsActive: ZD,
  tagButton: JD,
  divider: tk
};
function br(i = [], t) {
  switch (t) {
    case "asc":
      return i.sort();
    case "desc":
      return i.sort().reverse();
    default:
      return i;
  }
}
const ek = 255, ET = ({
  className: i,
  disabled: t,
  limit: e,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: a
}) => {
  const l = q(null), c = q(null), [d, h] = V(""), [u, p] = V(
    br(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  Ir(l, () => x(!1)), Zt(() => a(u), [u, a]), Zt(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const C = (I) => {
    h(I.target.value ?? "");
  }, _ = (I) => {
    const k = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((F) => {
          const O = Array.from(/* @__PURE__ */ new Set([...F, d]));
          return h(""), br(O, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (S(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && k > 0 && g(u[k - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && k < u.length - 1 && g(u[k + 1]);
        break;
      default:
        m && g("");
    }
  }, S = (I) => {
    p((k) => {
      const F = [...k];
      return F.splice(F.indexOf(I), 1), F;
    });
  }, v = b ? u.length : e || u.length, y = v < u.length, w = u.slice(0, v);
  return /* @__PURE__ */ s.jsx(
    At,
    {
      ref: l,
      className: f(pt.root, i),
      onClick: () => x(!0),
      disabled: t,
      children: /* @__PURE__ */ s.jsxs("div", { className: pt.wrapper, "data-testid": "tags-wrapper", children: [
        w.map((I, k, F) => {
          const O = !b && F.length > 1 && k === F.length - 1;
          return /* @__PURE__ */ s.jsxs(Mt, { children: [
            O && /* @__PURE__ */ s.jsx(
              A.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: pt.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ s.jsx(
              je,
              {
                className: f(pt.tag, {
                  [pt.tagIsActive]: I === m
                }),
                onDelete: () => S(I),
                "data-testid": "tag",
                children: I
              },
              I
            )
          ] }, I);
        }),
        !b && y && /* @__PURE__ */ s.jsxs(
          je,
          {
            className: f(pt.tag, pt.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - v
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(H, { className: pt.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: pt.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(A.Paragraph, { className: pt.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(pt.input, {
              [pt.inputIsHidden]: !b
            }),
            onChange: C,
            onKeyDown: _,
            maxLength: ek,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, nk = "h-textWithHighlight--textWithHighlight__highlight", sk = {
  highlight: nk
}, ok = ({
  text: i,
  highlight: t,
  className: e,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!t?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: i });
  const r = new RegExp(
    Vs(t.trim()),
    o ? "ig" : "g"
  ), a = i.match(r), l = i.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: e, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    a?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(sk.highlight, n), children: a[d] })
  ] }, d)) });
}, rk = qn(ok);
rk.name = "TextWithHighlight";
const ik = "h-timestamp--timestamp__timestamp", ak = {
  timestamp: ik
}, lk = 1e4;
class LT extends ft {
  interval;
  static defaultProps = {
    refreshRate: lk
  };
  constructor(t) {
    super(t);
    const { relative: e, counter: n, initialFormat: o } = t;
    let r = o ?? "absolute";
    e ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: o } = this.state;
    e !== t.relative && o && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), e?.(o, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: o } = this.state;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const a = j(t).utc().local();
    if (o === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / 3600), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (o === "full") {
      const l = n?.full ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = a.format(l);
    } else if (o === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = n?.absolute ?? `D MMMM LT${e ? "S" : ""}`;
        r = a.format(l);
      } else {
        const l = n?.absolute ?? `LT${e ? "S" : ""}`;
        r = a.format(l);
      }
    else
      r = cu(a);
    return r;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: a,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [ak.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "span",
      {
        ...h,
        ...Xn(this.handleClick),
        className: u,
        children: this.getTimeString()
      }
    );
  }
}
const ck = "h-token--token__root", dk = "h-token--token__select", hk = "h-token--token__label", uk = "h-token--token__rootReadonly", pk = "h-token--token__rootPrimary", mk = "h-token--token__rootWithError", gk = "h-token--token__value", fk = "h-token--token__icon", Bt = {
  root: ck,
  select: dk,
  label: hk,
  rootReadonly: uk,
  rootPrimary: pk,
  rootWithError: mk,
  value: gk,
  icon: fk
};
class AT extends D {
  render() {
    const {
      onDelete: t,
      id: e,
      label: n,
      options: o,
      valueLabel: r,
      primary: a,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [Bt.root]: !0,
        [Bt.rootPrimary]: a,
        [Bt.rootWithError]: c?.error,
        [Bt.rootReadonly]: !o && !t
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: Bt.select, id: e, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: Bt.label, htmlFor: e, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: Bt.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: Bt.icon, name: "angle-down" }),
        !!t && /* @__PURE__ */ s.jsx("span", { ...Xn(t), children: /* @__PURE__ */ s.jsx(N, { className: Bt.icon, name: "close", onClick: t }) })
      ] })
    ] });
  }
}
const bk = "h-skeleton--skeleton__root", xk = "h-skeleton--skeleton__rootAnimationPulse", yk = "h-skeleton--skeleton__rootAnimationWave", Ns = {
  root: bk,
  rootAnimationPulse: xk,
  rootAnimationWave: yk
};
function xr({ className: i, animation: t = "pulse", ...e }, n) {
  const o = f(
    {
      [Ns.root]: !0,
      [Ns.rootAnimationPulse]: t === "pulse",
      [Ns.rootAnimationWave]: t === "wave"
    },
    i
  );
  return /* @__PURE__ */ s.jsx(it, { className: o, ...e, ref: n });
}
const $T = Object.assign($(xr), {
  name: xr.name
}), _k = "h-breadcrumbs--breadcrumbs__root", Ck = "h-breadcrumbs--breadcrumbs__list", vk = "h-breadcrumbs--breadcrumbs__item", wk = "h-breadcrumbs--breadcrumbs__separator", Ln = {
  root: _k,
  list: Ck,
  item: vk,
  separator: wk
}, OT = $(function({
  className: t,
  children: e,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...a
}, l) {
  const c = n ?? "nav", d = Lt.toArray(e).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...a,
      ref: l,
      className: f(Ln.root, t),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: Ln.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(Mt, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.item,
              "aria-current": p ? "page" : void 0,
              children: m
            }
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: Ln.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] }, u);
      }) })
    }
  );
});
export {
  lf as AddonTriggerContext,
  cf as AddonTriggerEvents,
  Lk as Attachment,
  Dr as Avatar,
  ip as AvatarSelectItem,
  $k as Badge,
  Ok as Banner,
  it as Box,
  OT as Breadcrumbs,
  X as Button,
  Bk as ButtonGroup,
  bo as ButtonList,
  Yk as CheckableAvatarSelectItem,
  Zs as CheckableBaseItem,
  Uk as CheckableSelectItem,
  Gk as CheckableTagSelectItem,
  hn as Checkbox,
  Dp as Chip,
  Hk as CollapseCard,
  Mk as Collapsible,
  Jn as ColorPicker,
  mt as Column,
  xd as Columns,
  Ad as CopyToClipboard,
  zk as CopyToClipboardButton,
  mT as CountryFlag,
  Vk as DataTable,
  Zm as DatePicker,
  en as DatePickerOld,
  Vm as DateRangePicker,
  gp as DeselectItem,
  Zk as Dialer,
  Qn as Divider,
  te as Dropdown,
  de as DropdownButton,
  un as DropdownButtonContext,
  Xs as DropdownInfinite,
  Lo as DropdownItem,
  eo as DropdownSelect,
  zr as DropdownSelectContainer,
  Jk as DropdownSelectMultiple,
  Hi as EMOJIS,
  HT as EmojiPicker,
  pn as EmptySelectItem,
  ch as EmptyState,
  Re as ErrorBoundary,
  Pa as ErrorBoundaryContext,
  pT as FieldAddonDropdown,
  es as FieldAlert,
  tT as FieldButton,
  uT as FieldColorPicker,
  eT as FieldDatePicker,
  nT as FieldDateRangePicker,
  Qs as FieldLabel,
  oT as FieldRichText,
  rT as FieldSelect,
  iT as FieldSelectionList,
  aT as FieldSlider,
  lT as FieldSwitch,
  Ls as FieldText,
  cT as FieldTextarea,
  dT as FieldTimePicker,
  hT as FieldTimeRangePicker,
  z as FieldWrapper,
  H as FlexBox,
  kr as FocusScope,
  bT as FormField,
  fT as FormGrid,
  Ys as HelpIcon,
  xT as HelperField,
  N as Icon,
  K as IconButton,
  Us as Image,
  Fy as InputColorPicker,
  Ng as InputDatePicker,
  ln as InputDateRangePicker,
  yT as InputDuration,
  lo as InputRichText,
  Gx as InputSelectionList,
  Qt as InputText,
  At as InputWrapper,
  _T as Lightbox,
  CT as List,
  CT as ListV2,
  vT as MediaPlayer,
  AS as Modal,
  wT as ModalBody,
  zI as ModalFoot,
  ST as ModalHead,
  LS as ModalStackContext,
  Rk as NavigationButton,
  IT as Page,
  eh as Pagination,
  SS as Portal,
  Wr as Presets,
  DT as Radio,
  TT as RemovableCard,
  kT as ReverseScroll,
  ri as SandboxIframe,
  NT as ScrollShadow,
  jT as Scrollbar,
  FT as SearchInput,
  nm as Select,
  Hr as SelectItem,
  PT as SelectOption,
  Nx as SelectionList,
  Bd as SimplePagination,
  RT as SimpleProgressBar,
  $T as Skeleton,
  Bs as Slider,
  Gn as Spinner,
  fy as Switch,
  gt as Table,
  ts as TableContext,
  Cb as Tabs,
  Ws as TabsWithContent,
  je as Tag,
  Xk as TagDeselectItem,
  qk as TagSelectItem,
  Qk as TagSelectSuggestion,
  ET as TagsInput,
  A as Text,
  rk as TextWithHighlight,
  ei as Textarea,
  an as TimePicker,
  Lm as TimeRangePicker,
  LT as Timestamp,
  AT as Token,
  st as Tooltip,
  Yn as WindowContext,
  Ek as WindowProvider,
  MT as addSvgIconsToDocument,
  al as badgeTestId,
  md as colorPickerTestId,
  gT as countryCodes,
  Kk as datepickerDisableWeekends,
  zT as defaultElementType,
  oo as formatShortcut,
  Ug as formattingOptions,
  Ae as getSelectionListContext,
  VT as iconMeta,
  Qo as inputRichTextCommands,
  qx as inputSelectionListTestId,
  gD as reverseScrollTestId,
  Ks as useWindowContext,
  dn as withErrorBoundary
};
//# sourceMappingURL=index.js.map
